import { jsx, jsxs, Fragment } from 'theme-ui/jsx-runtime';
import { useState, useRef, useEffect, forwardRef, useImperativeHandle, useCallback, useMemo } from 'react';
import { ThemeProvider } from '@theme-ui/core';
import { Button, Link, BrandedIcon, SystemIcon, ESystemIconNames, ButtonIcon, ELinkVariant, MDBLogo, ELogoVariant, Globals, Pill, TypographyScale } from '@mdb/flora';
import theme from '@mdb/flora/theme-legacy';
import { Box } from 'theme-ui';
import theme$1 from '@mdb/flora/theme';
import { keyframes } from '@emotion/react';

var nav$8 = {
	primary: [
		{
			title: "Products",
			dropdown: {
				mainSection: {
					columns: [
						{
							size: "large",
							subSections: [
								{
									title: "Platform",
									menuItems: [
										{
											title: "Atlas",
											description: "Build and scale with an AI-ready platform",
											brandedIconName: "atlas_product_family",
											href: "https://www.mongodb.com/atlas"
										}
									]
								},
								{
									title: "Platform Services",
									menuItems: [
										{
											title: "Database",
											description: "Deploy a multi-cloud database",
											brandedIconName: "atlas_database",
											href: "https://www.mongodb.com/products/platform/atlas-database"
										},
										{
											title: "Search",
											description: "Deliver engaging search experiences",
											brandedIconName: "atlas_search",
											href: "https://www.mongodb.com/products/platform/atlas-search"
										},
										{
											title: "Vector Search",
											description: "Design intelligent apps with gen AI",
											brandedIconName: "mdb_vector_search",
											href: "https://www.mongodb.com/products/platform/atlas-vector-search"
										},
										{
											title: "Stream Processing",
											description: "Integrate MongoDB and Kafka",
											brandedIconName: "atlas_stream_processing",
											href: "https://www.mongodb.com/products/platform/atlas-stream-processing"
										}
									]
								}
							]
						},
						{
							size: "large",
							subSections: [
								{
									title: "Self Managed",
									menuItems: [
										{
											title: "Enterprise Advanced",
											description: "Run and manage MongoDB yourself",
											brandedIconName: "enterprise_advanced_product family",
											href: "https://www.mongodb.com/products/self-managed/enterprise-advanced"
										},
										{
											title: "Community Edition",
											description: "Develop locally with MongoDB",
											brandedIconName: "community_edition_product_family",
											href: "https://www.mongodb.com/products/self-managed/community-edition"
										}
									]
								},
								{
									title: "Tools",
									menuItems: [
										{
											title: "Compass",
											description: "Work with MongoDB data in a GUI",
											brandedIconName: "mdb_compass",
											href: "https://www.mongodb.com/products/tools/compass"
										},
										{
											title: "Integrations",
											description: "Integrations with third-party services",
											brandedIconName: "atlas_integration",
											href: "https://cloud.mongodb.com/ecosystem/?filter=integration"
										},
										{
											title: "Relational Migrator",
											description: "Migrate to MongoDB with confidence",
											brandedIconName: "mdb_migrator",
											href: "https://www.mongodb.com/products/tools/relational-migrator"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "View All Products",
					description: "Explore our full developer suite",
					href: " https://www.mongodb.com/products"
				},
				footerAdditionalSection: {
					title: "MongoDB 8.0",
					description: "Our fastest version ever",
					href: "https://www.mongodb.com/products/updates/version-release"
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "Build with MongoDB Atlas",
							description: "Get started for free in minutes",
							label: "Sign Up",
							href: "https://www.mongodb.com/cloud/atlas/register",
							isButtonType: true
						},
						{
							title: "Test Enterprise Advanced",
							description: "Develop with MongoDB on-premises",
							label: "Download",
							href: "https://www.mongodb.com/try/download/enterprise",
							isButtonType: true,
							onlyDesktop: true
						},
						{
							title: "Try Community Edition",
							description: "Explore the latest version of MongoDB",
							label: "Download",
							href: "https://www.mongodb.com/try/download/community",
							isButtonType: true,
							onlyDesktop: true
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Resources",
			dropdown: {
				mainSection: {
					columns: [
						{
							subSections: [
								{
									title: "Documentation",
									menuItems: [
										{
											title: "Atlas Documentation",
											description: "Get started using Atlas",
											href: "https://www.mongodb.com/docs/atlas/"
										},
										{
											title: "Server Documentation",
											description: "Learn to use MongoDB",
											href: "https://www.mongodb.com/docs/manual/"
										}
									]
								}
							]
						},
						{
							subSections: [
								{
									title: " ",
									menuItems: [
										{
											title: "Tools and Connectors",
											description: "Learn how to connect to MongoDB",
											href: "https://www.mongodb.com/docs/tools-and-connectors/"
										},
										{
											title: "MongoDB Drivers",
											description: "Use drivers and libraries for MongoDB",
											href: "https://www.mongodb.com/docs/drivers/"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "Resources Hub",
					description: "Get help building the next big thing with MongoDB",
					href: "https://www.mongodb.com/resources"
				},
				helperSection: {
					subSections: [
						{
							title: "Connect",
							menuItems: [
								{
									title: "Community",
									description: "Join a global community of developers",
									brandedIconName: "general_events_ask_the_experts",
									href: "https://www.mongodb.com/community/"
								},
								{
									title: "Courses and Certification",
									description: "Learn for free from MongoDB",
									brandedIconName: "general_content_tutorial",
									href: "https://learn.mongodb.com/"
								},
								{
									title: "Events and Webinars",
									description: "Find an event or webinar near you",
									brandedIconName: "general_events_session",
									href: "https://www.mongodb.com/events"
								}
							]
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Solutions",
			dropdown: {
				mainSection: {
					columns: [
						{
							size: "small",
							subSections: [
								{
									title: "Use cases",
									menuItems: [
										{
											title: "Artificial Intelligence",
											href: "https://www.mongodb.com/solutions/use-cases/artificial-intelligence"
										},
										{
											title: "Modernization",
											href: "https://www.mongodb.com/solutions/use-cases/modernize"
										},
										{
											title: "Payments",
											href: "https://www.mongodb.com/solutions/use-cases/payments"
										},
										{
											title: "Serverless Development",
											href: "https://www.mongodb.com/solutions/use-cases/serverless"
										},
										{
											title: "Gaming",
											href: "https://www.mongodb.com/solutions/use-cases/gaming"
										},
										{
											title: "Intelligent Search",
											href: "https://www.mongodb.com/solutions/use-cases/intelligent-search"
										},
										{
											title: "Edge and Mobile",
											href: "https://www.mongodb.com/solutions/use-cases/edge-and-mobile"
										}
									]
								}
							]
						},
						{
							size: "small",
							subSections: [
								{
									title: "Industries",
									menuItems: [
										{
											title: "Financial Services",
											href: "https://www.mongodb.com/solutions/industries/financial-services"
										},
										{
											title: "Telecommunications",
											href: "https://www.mongodb.com/solutions/industries/telecommunications"
										},
										{
											title: "Healthcare",
											href: "https://www.mongodb.com/solutions/industries/healthcare"
										},
										{
											title: "Retail",
											href: "https://www.mongodb.com/solutions/industries/retail"
										},
										{
											title: "Public Sector",
											href: "https://www.mongodb.com/solutions/industries/public-sector"
										},
										{
											title: "Manufacturing",
											href: "https://www.mongodb.com/solutions/industries/manufacturing"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "Solutions Library",
					description: "Organized and tailored solutions to kick-start projects",
					href: "https://www.mongodb.com/docs/atlas/architecture/current/solutions-library"
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "AI Applications Program",
							description: "Expedite your AI journey with expert guidance",
							label: "Learn more",
							href: "https://www.mongodb.com/services/consulting/ai-applications-program"
						},
						{
							title: "Startups and AI Innovators",
							description: "For world-changing ideas and AI pioneers",
							label: "Learn more",
							href: "https://www.mongodb.com/solutions/startups"
						},
						{
							title: "Customer Case Studies",
							description: "Hear directly from our users",
							label: "See Stories",
							href: "https://www.mongodb.com/solutions/customer-case-studies"
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Company",
			dropdown: {
				mainSection: {
					columns: [
						{
							subSections: [
								{
									menuItems: [
										{
											title: "Careers",
											description: "Start your next adventure",
											href: "https://www.mongodb.com/company/careers"
										},
										{
											title: "Blog",
											description: "Read articles and announcements",
											href: "https://www.mongodb.com/blog"
										},
										{
											title: "Newsroom",
											description: "Read press releases and news stories",
											href: "https://www.mongodb.com/company/newsroom"
										}
									]
								}
							]
						},
						{
							subSections: [
								{
									menuItems: [
										{
											title: "Partners",
											description: "Learn about our partner ecosystem",
											href: "https://www.mongodb.com/company/partners"
										},
										{
											title: "Leadership",
											description: "Meet our executive team",
											href: "https://www.mongodb.com/company/leadership"
										},
										{
											title: "Company",
											description: "Learn more about who we are",
											href: "https://www.mongodb.com/company"
										}
									]
								}
							]
						}
					]
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "Contact Us",
							description: "Reach out to MongoDB",
							label: "Connect with an expert",
							href: "https://www.mongodb.com/company/contact"
						},
						{
							title: "Investors",
							description: "Visit our investor portal",
							label: "Learn more",
							href: "https://investors.mongodb.com/"
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Pricing",
			target: "_self",
			href: "https://www.mongodb.com/pricing"
		}
	],
	secondary: {
		"try": {
			title: "Get Started",
			target: "_self",
			href: "https://www.mongodb.com/cloud/atlas/register"
		},
		support: {
			title: "Support",
			target: "_self",
			href: "https://www.mongodb.com/services/support"
		},
		login: {
			title: "Sign In",
			target: "_self",
			href: "https://account.mongodb.com/account/login"
		},
		search: {
			submit: "Search",
			options: [
				{
					value: "General Information",
					placeholder: "Search products, whitepapers, & more...",
					universalKey: "DOTCOM"
				},
				{
					value: "Documentation",
					placeholder: "Search documentation...",
					universalKey: "DOCS"
				},
				{
					value: "Developer Articles & Topics",
					placeholder: "Search articles and topics...",
					universalKey: "DEVHUB"
				},
				{
					value: "Community Forums",
					placeholder: "Search community forums...",
					universalKey: "COMMUNITY"
				},
				{
					value: "Blog",
					placeholder: "Search blog...",
					universalKey: "BLOG"
				},
				{
					value: "University",
					placeholder: "Search university...",
					universalKey: "UNIVERSITY"
				}
			]
		}
	}
};
var footer$8 = {
	copyright: "MongoDB, Inc.",
	sections: [
		{
			title: "About",
			links: [
				{
					title: "Careers",
					target: "_self",
					href: "https://www.mongodb.com/careers"
				},
				{
					title: "Investor Relations",
					target: "_self",
					href: "https://investors.mongodb.com"
				},
				{
					title: "Legal",
					target: "_self",
					href: "https://www.mongodb.com/legal"
				},
				{
					title: "Privacy Policy",
					target: "_self",
					href: "https://www.mongodb.com/legal/privacy/privacy-policy"
				},
				{
					title: "GitHub",
					target: "_self",
					href: "https://github.com/mongodb"
				},
				{
					title: "Security Information",
					target: "_self",
					href: "https://www.mongodb.com/company/contact/mongodb-vulnerability-disclosure-policy"
				},
				{
					title: "Trust Center",
					target: "_self",
					href: "https://www.mongodb.com/products/platform/trust"
				},
				{
					title: "Connect with Us",
					target: "_self",
					href: "https://www.mongodb.com/company/contact/social-media-hub"
				},
				{
					title: "Saudi Arabian VAT Certificate",
					target: "_blank",
					href: "https://webassets.mongodb.com/_com_assets/cms/lcqodf8rajwqnn9uw-MongoBD%20VAT%20certificate_ZATCA_KSA.pdf",
					hide: true
				}
			]
		},
		{
			title: "Support",
			links: [
				{
					title: "Contact Us",
					target: "_self",
					href: "https://www.mongodb.com/company/contact"
				},
				{
					title: "Customer Portal",
					target: "_self",
					href: "https://support.mongodb.com/welcome"
				},
				{
					title: "Atlas Status",
					target: "_self",
					href: "https://status.mongodb.com/"
				},
				{
					title: "Customer Support",
					target: "_self",
					href: "https://www.mongodb.com/services/support"
				},
				{
					id: "manage-cookies",
					title: "Manage Cookies",
					target: "_self",
					href: "#"
				}
			]
		},
		{
			title: "Deployment Options",
			links: [
				{
					title: "MongoDB Atlas",
					target: "_self",
					href: "https://www.mongodb.com/cloud/atlas/register"
				},
				{
					title: "Enterprise Advanced",
					target: "_self",
					href: "https://www.mongodb.com/try/download/enterprise"
				},
				{
					title: "Community Edition",
					target: "_self",
					href: " https://www.mongodb.com/try/download/community"
				}
			]
		},
		{
			title: "Data Basics",
			links: [
				{
					title: "Vector Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/vector-databases"
				},
				{
					title: "NoSQL Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/nosql-explained"
				},
				{
					title: "Document Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/document-databases"
				},
				{
					title: "RAG Database",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/artificial-intelligence/retrieval-augmented-generation"
				},
				{
					title: "ACID Transactions",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/acid-transactions"
				},
				{
					title: "MERN Stack",
					target: "_self",
					href: "https://www.mongodb.com/resources/languages/mern-stack"
				},
				{
					title: "MEAN Stack",
					target: "_self",
					href: " https://www.mongodb.com/resources/languages/mean-stack"
				}
			]
		}
	]
};
var enUs = {
	nav: nav$8,
	footer: footer$8
};

var nav$7 = {
	primary: [
		{
			title: "Produtos",
			dropdown: {
				mainSection: {
					columns: [
						{
							size: "large",
							subSections: [
								{
									title: "Plataforma",
									menuItems: [
										{
											title: "Atlas",
											description: "Crie uma plataforma de dados para desenvolvedores",
											brandedIconName: "atlas_product_family",
											href: "https://www.mongodb.com/pt-br/atlas"
										}
									]
								},
								{
									title: "SERVIÇOS DE PLATAFORMA",
									menuItems: [
										{
											title: "Banco de dados",
											description: "Implemente um banco de dados multi-cloud",
											brandedIconName: "atlas_database",
											href: "https://www.mongodb.com/pt-br/products/platform/atlas-database"
										},
										{
											title: "Pesquisa",
											description: "Ofereça experiências de busca envolventes",
											brandedIconName: "atlas_search",
											href: "https://www.mongodb.com/pt-br/products/platform/atlas-search"
										},
										{
											title: "Vector Search",
											description: "Crie aplicativos inteligentes com gen AI",
											brandedIconName: "mdb_vector_search",
											href: "https://www.mongodb.com/pt-br/products/platform/atlas-vector-search"
										},
										{
											title: "Stream Processing",
											description: "Integre o MongoDB e o Kafka",
											brandedIconName: "atlas_stream_processing",
											href: "https://www.mongodb.com/pt-br/products/platform/atlas-stream-processing"
										}
									]
								}
							]
						},
						{
							size: "large",
							subSections: [
								{
									title: "Autogerenciado",
									menuItems: [
										{
											title: "Enterprise Advanced",
											description: "Execute e gerencie o MongoDB por conta própria",
											brandedIconName: "enterprise_advanced_product family",
											href: "https://www.mongodb.com/pt-br/products/self-managed/enterprise-advanced"
										},
										{
											title: "Community Edition",
											description: "Desenvolvimento local com o MongoDB",
											brandedIconName: "community_edition_product_family",
											href: "https://www.mongodb.com/products/self-managed/community-edition"
										}
									]
								},
								{
									title: "Ferramentas",
									menuItems: [
										{
											title: "Compass",
											description: "Use dados do MongoDB em uma GUI",
											brandedIconName: "mdb_compass",
											href: "https://www.mongodb.com/pt-br/products/tools/compass"
										},
										{
											title: "Integrações",
											description: "Conecte-se a serviços de terceiros",
											brandedIconName: "atlas_integration",
											href: "https://cloud.mongodb.com/ecosystem/?filter=integration"
										},
										{
											title: "Relational Migrator",
											description: "Migre com confiança para o MongoDB",
											brandedIconName: "mdb_migrator",
											href: "https://www.mongodb.com/pt-br/products/tools/relational-migrator"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "Ver todos os produtos",
					description: "Explore nosso pacote completo de desenvolvedores",
					href: " https://www.mongodb.com/products"
				},
				footerAdditionalSection: {
					title: "MongoDB 8.0",
					description: "Nossa versão mais rápida de todas",
					href: "https://www.mongodb.com/products/updates/version-release"
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "Crie com o MongoDB Atlas",
							description: "Comece gratuitamente em poucos minutos",
							label: "Crie uma conta",
							href: "https://www.mongodb.com/pt-br/cloud/atlas/register",
							isButtonType: true
						},
						{
							title: "Teste o Enterprise Advanced",
							description: "Desenvolvimento com o MongoDB no local",
							label: "Baixar",
							href: "https://www.mongodb.com/try/download/enterprise",
							isButtonType: true,
							onlyDesktop: true
						},
						{
							title: "Experimente o Community Edition",
							description: "Conheça a última versão do MongoDB",
							label: "Baixar",
							href: "https://www.mongodb.com/try/download/community",
							isButtonType: true,
							onlyDesktop: true
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Recursos",
			dropdown: {
				mainSection: {
					columns: [
						{
							subSections: [
								{
									title: "Documentação",
									menuItems: [
										{
											title: "Documentação do Atlas",
											description: "Introdução ao Atlas",
											href: "https://www.mongodb.com/docs/atlas/"
										},
										{
											title: "Documentação do servidor",
											description: "Aprenda a usar o MongoDB",
											href: "https://www.mongodb.com/docs/manual/"
										}
									]
								}
							]
						},
						{
							subSections: [
								{
									title: " ",
									menuItems: [
										{
											title: "Ferramentas e conectores",
											description: "Veja como se conectar ao MongoDB",
											href: "https://www.mongodb.com/docs/tools-and-connectors/"
										},
										{
											title: "MongoDB Drivers",
											description: "Use drivers e bibliotecas para o MongoDB",
											href: "https://www.mongodb.com/docs/drivers/"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "Centro de recursos",
					description: "Obtenha ajuda para construir o próximo grande sucesso com o MongoDB",
					href: "https://www.mongodb.com/resources"
				},
				helperSection: {
					subSections: [
						{
							title: "Conectar",
							menuItems: [
								{
									title: "Comunidade",
									description: "Participe de uma comunidade global de desenvolvedores",
									brandedIconName: "general_events_ask_the_experts",
									href: "https://www.mongodb.com/community/"
								},
								{
									title: "Cursos e certificações",
									description: "Aprenda gratuitamente com o MongoDB",
									brandedIconName: "general_content_tutorial",
									href: "https://learn.mongodb.com/"
								},
								{
									title: "Eventos e webinars",
									description: "Encontre um evento ou webinar perto de você",
									brandedIconName: "general_events_session",
									href: "https://www.mongodb.com/events"
								}
							]
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Soluções",
			dropdown: {
				mainSection: {
					columns: [
						{
							size: "small",
							subSections: [
								{
									title: "Casos De Uso",
									menuItems: [
										{
											title: "Inteligência artificial",
											href: "https://www.mongodb.com/pt-br/solutions/use-cases/artificial-intelligence"
										},
										{
											title: "Modernização",
											href: "https://www.mongodb.com/pt-br/solutions/use-cases/modernize"
										},
										{
											title: "Pagamentos",
											href: "https://www.mongodb.com/pt-br/solutions/use-cases/payments"
										},
										{
											title: "Desenvolvimento Serverless",
											href: "https://www.mongodb.com/pt-br/solutions/use-cases/serverless"
										},
										{
											title: "Jogos",
											href: "https://www.mongodb.com/solutions/use-cases/gaming"
										}
									]
								}
							]
						},
						{
							size: "small",
							subSections: [
								{
									title: "Indústrias",
									menuItems: [
										{
											title: "Serviços financeiros",
											href: "https://www.mongodb.com/pt-br/solutions/industries/financial-services"
										},
										{
											title: "Telecomunicações",
											href: "https://www.mongodb.com/pt-br/solutions/industries/telecommunications"
										},
										{
											title: "Saúde",
											href: "https://www.mongodb.com/pt-br/solutions/industries/healthcare"
										},
										{
											title: "Varejo",
											href: "https://www.mongodb.com/pt-br/solutions/industries/retail"
										},
										{
											title: "Setor público",
											href: "https://www.mongodb.com/pt-br/solutions/industries/public-sector"
										},
										{
											title: "Fabricação",
											href: "https://www.mongodb.com/pt-br/solutions/industries/manufacturing"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "Biblioteca de soluções",
					description: "Soluções organizadas e personalizadas para iniciar projetos",
					href: "https://www.mongodb.com/docs/atlas/architecture/current/solutions-library"
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "Startups e IA inovadores",
							description: "Para ideias que mudam o mundo e pioneiros em IA",
							label: "Saiba mais",
							href: "https://www.mongodb.com/pt-br/solutions/startups"
						},
						{
							title: "Estudos de caso de clientes",
							description: "Ouça diretamente de nossos usuários",
							label: "Veja histórias",
							href: "https://www.mongodb.com/solutions/customer-case-studies"
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Empresa",
			dropdown: {
				mainSection: {
					columns: [
						{
							subSections: [
								{
									menuItems: [
										{
											title: "Carreiras",
											description: "Comece uma nova jornada conosco",
											href: "https://www.mongodb.com/company/careers"
										},
										{
											title: "Blog",
											description: "Leia artigos e pronunciamentos",
											href: "https://www.mongodb.com/blog"
										},
										{
											title: "Imprensa",
											description: "Leia comunicados de imprensa e notícias",
											href: "https://www.mongodb.com/company/newsroom"
										}
									]
								}
							]
						},
						{
							subSections: [
								{
									menuItems: [
										{
											title: "Parceiros",
											description: "Saiba mais sobre nosso ecossistema de parceiros",
											href: "https://www.mongodb.com/pt-br/company/partners"
										},
										{
											title: "Liderança",
											description: "Conheça nossa equipe executiva",
											href: "https://www.mongodb.com/pt-br/company/leadership"
										},
										{
											title: "Quem somos",
											description: "Saiba mais sobre quem somos",
											href: "https://www.mongodb.com/pt-br/company"
										}
									]
								}
							]
						}
					]
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "Fale conosco",
							description: "Entre em contato com o MongoDB",
							label: "Conecte-se com um especialista",
							href: "https://www.mongodb.com/pt-br/company/contact"
						},
						{
							title: "Investidores",
							description: "Visite nosso portal do investidor",
							label: "Saiba mais",
							href: "https://investors.mongodb.com/"
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Preços",
			target: "_self",
			href: "https://www.mongodb.com/pt-br/pricing"
		}
	],
	secondary: {
		"try": {
			title: "Teste Grátis",
			href: "https://www.mongodb.com/pt-br/cloud/atlas/register"
		},
		support: {
			title: "Support",
			target: "_self",
			href: "https://www.mongodb.com/pt-br/services/support"
		},
		login: {
			title: "Logar",
			href: "https://account.mongodb.com/account/login"
		},
		search: {
			submit: "Enviar",
			options: [
				{
					value: "Informações gerais",
					placeholder: "Pesquise produtos, whitepapers e muito mais...",
					universalKey: "DOTCOM"
				},
				{
					value: "Toda a documentação",
					placeholder: "Pesquise toda a documentação...",
					universalKey: "DOCS"
				},
				{
					value: "Artigos e tópicos do desenvolvedor",
					placeholder: "Pesquise artigos e tópicos...",
					universalKey: "DEVHUB"
				},
				{
					value: "Fóruns",
					placeholder: "Pesquise nos fóruns...",
					universalKey: "COMMUNITY"
				}
			]
		}
	}
};
var footer$7 = {
	copyright: "MongoDB, Inc.",
	sections: [
		{
			title: "Sobre",
			links: [
				{
					title: "Carreiras",
					target: "_self",
					href: "https://www.mongodb.com/careers"
				},
				{
					title: "Investidores",
					target: "_self",
					href: "https://investors.mongodb.com"
				},
				{
					title: "Legal",
					target: "_self",
					href: "https://www.mongodb.com/pt-br/legal"
				},
				{
					title: "Privacy Policy",
					target: "_self",
					href: "https://www.mongodb.com/legal/privacy/privacy-policy"
				},
				{
					title: "GitHub",
					target: "_self",
					href: "https://github.com/mongodb"
				},
				{
					title: "Informações de segurança",
					target: "_self",
					href: "https://www.mongodb.com/pt-br/company/contact/mongodb-vulnerability-disclosure-policy"
				},
				{
					title: "Central de confiança",
					target: "_self",
					href: "https://www.mongodb.com/pt-br/products/platform/trust"
				},
				{
					title: "Entre em contato conosco",
					target: "_self",
					href: "https://www.mongodb.com/company/contact/social-media-hub"
				},
				{
					title: "Mapa do site",
					target: "_self",
					href: "https://www.mongodb.com/pt-br/html-sitemap"
				}
			]
		},
		{
			title: "Suporte",
			links: [
				{
					title: "Contate-nos",
					target: "_self",
					href: "https://www.mongodb.com/pt-br/company/contact"
				},
				{
					title: "Portal do cliente",
					target: "_self",
					href: "https://support.mongodb.com/welcome"
				},
				{
					title: "Status do Atlas",
					target: "_self",
					href: "https://status.mongodb.com/"
				},
				{
					title: "Customer Support",
					target: "_self",
					href: "https://www.mongodb.com/pt-br/services/support"
				}
			]
		},
		{
			title: "Opções de implantação",
			links: [
				{
					title: "MongoDB Atlas",
					target: "_self",
					href: "https://www.mongodb.com/cloud/atlas/register"
				},
				{
					title: "Enterprise Advanced",
					target: "_self",
					href: "https://www.mongodb.com/try/download/enterprise"
				},
				{
					title: "Community Edition",
					target: "_self",
					href: " https://www.mongodb.com/try/download/community"
				}
			]
		},
		{
			title: "Data Basics",
			links: [
				{
					title: "Vector Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/vector-databases"
				},
				{
					title: "NoSQL Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/nosql-explained"
				},
				{
					title: "Document Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/document-databases"
				},
				{
					title: "RAG Database",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/artificial-intelligence/retrieval-augmented-generation"
				},
				{
					title: "ACID Transactions",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/acid-transactions"
				},
				{
					title: "MERN Stack",
					target: "_self",
					href: "https://www.mongodb.com/resources/languages/mern-stack"
				},
				{
					title: "MEAN Stack",
					target: "_self",
					href: " https://www.mongodb.com/resources/languages/mean-stack"
				}
			]
		}
	]
};
var ptBr = {
	nav: nav$7,
	footer: footer$7
};

var nav$6 = {
	primary: [
		{
			title: "Productos",
			dropdown: {
				mainSection: {
					columns: [
						{
							size: "large",
							subSections: [
								{
									title: "Plataforma",
									menuItems: [
										{
											title: "Atlas",
											description: "Desarrolle en una plataforma de datos para desarrolladores",
											brandedIconName: "atlas_product_family",
											href: "https://www.mongodb.com/es/atlas"
										}
									]
								},
								{
									title: "Plataforma De Servicios",
									menuItems: [
										{
											title: "Base de Datos",
											description: "Implemente una base de datos multicloud",
											brandedIconName: "atlas_database",
											href: "https://www.mongodb.com/es/products/platform/atlas-database"
										},
										{
											title: "Búsqueda",
											description: "Brinde experiencias de búsqueda interactivas",
											brandedIconName: "atlas_search",
											href: "https://www.mongodb.com/es/products/platform/atlas-search"
										},
										{
											title: "Vector Search",
											description: "Diseñe apps inteligentes con gen AI",
											brandedIconName: "mdb_vector_search",
											href: "https://www.mongodb.com/es/products/platform/atlas-vector-search"
										},
										{
											title: "Stream Processing",
											description: "Integrar MongoDB y Kafka",
											brandedIconName: "atlas_stream_processing",
											href: "https://www.mongodb.com/es/products/platform/atlas-stream-processing"
										}
									]
								}
							]
						},
						{
							size: "large",
							subSections: [
								{
									title: "Autogestionado",
									menuItems: [
										{
											title: "Enterprise Advanced",
											description: "Ejecute y gestione MongoDB usted mismo",
											brandedIconName: "enterprise_advanced_product family",
											href: "https://www.mongodb.com/es/products/self-managed/enterprise-advanced"
										},
										{
											title: "Community Edition",
											description: "Desarrolle a nivel local con MongoDB",
											brandedIconName: "community_edition_product_family",
											href: "https://www.mongodb.com/products/self-managed/community-edition"
										}
									]
								},
								{
									title: "Herramientas",
									menuItems: [
										{
											title: "Compass",
											description: "Trabaje con datos de MongoDB en una interfaz gráfica de usuario",
											brandedIconName: "mdb_compass",
											href: "https://www.mongodb.com/es/products/tools/compass"
										},
										{
											title: "Integraciones",
											description: "Conéctese a servicios de terceros",
											brandedIconName: "atlas_integration",
											href: "https://cloud.mongodb.com/ecosystem/?filter=integration"
										},
										{
											title: "Relational Migrator",
											description: "Migre a MongoDB con confianza",
											brandedIconName: "mdb_migrator",
											href: "https://www.mongodb.com/es/products/tools/relational-migrator"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "Ver todos los productos",
					description: "Explora nuestra suite completa para desarrolladores",
					href: " https://www.mongodb.com/products"
				},
				footerAdditionalSection: {
					title: "MongoDB 8.0",
					description: "Nuestra versión más rápida hasta la fecha",
					href: "https://www.mongodb.com/products/updates/version-release"
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "Desarrolle con MongoDB Atlas",
							description: "Comience gratis en minutos",
							label: "Regístrese",
							href: "https://www.mongodb.com/cloud/atlas/register",
							isButtonType: true
						},
						{
							title: "Pruebe Enterprise Advanced",
							description: "Desarrolle con MongoDB en las instalaciones",
							label: "Descargar",
							href: "https://www.mongodb.com/try/download/enterprise",
							isButtonType: true,
							onlyDesktop: true
						},
						{
							title: "Pruebe Community Edition",
							description: "Explore la versión más reciente de MongoDB",
							label: "Descargar",
							href: "https://www.mongodb.com/try/download/community",
							isButtonType: true,
							onlyDesktop: true
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Recursos",
			dropdown: {
				mainSection: {
					columns: [
						{
							subSections: [
								{
									title: "Documentación",
									menuItems: [
										{
											title: "Documentación de Atlas",
											description: "Empiece a usar Atlas",
											href: "https://www.mongodb.com/docs/atlas/"
										},
										{
											title: "Documentación de servidores",
											description: "Aprenda a usar MongoDB",
											href: "https://www.mongodb.com/docs/manual/"
										}
									]
								}
							]
						},
						{
							subSections: [
								{
									title: " ",
									menuItems: [
										{
											title: "Herramientas y conectores",
											description: "Aprenda cómo conectarse a MongoDB",
											href: "https://www.mongodb.com/docs/tools-and-connectors/"
										},
										{
											title: "MongoDB Drivers",
											description: "Use controladores y bibliotecas para MongoDB",
											href: "https://www.mongodb.com/docs/drivers/"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "Centro de recursos",
					description: "Obtenga ayuda para construir el próximo gran avance con MongoDB",
					href: "https://www.mongodb.com/resources"
				},
				helperSection: {
					subSections: [
						{
							title: "Conecte",
							menuItems: [
								{
									title: "Community",
									description: "Únase a una comunidad global de desarrolladores",
									brandedIconName: "general_events_ask_the_experts",
									href: "https://www.mongodb.com/community/"
								},
								{
									title: "Cursos y certificaciones",
									description: "Aprenda gratis de MongoDB",
									brandedIconName: "general_content_tutorial",
									href: "https://learn.mongodb.com/"
								},
								{
									title: "Eventos y seminarios web",
									description: "Encuentre un evento o seminario sitio web cerca de usted",
									brandedIconName: "general_events_session",
									href: "https://www.mongodb.com/events"
								}
							]
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Soluciones",
			dropdown: {
				mainSection: {
					columns: [
						{
							size: "small",
							subSections: [
								{
									title: "Casos De Uso",
									menuItems: [
										{
											title: "Inteligencia artificial",
											href: "https://www.mongodb.com/es/solutions/use-cases/artificial-intelligence"
										},
										{
											title: "Modernización",
											href: "https://www.mongodb.com/es/solutions/use-cases/modernize"
										},
										{
											title: "Pagos",
											href: "https://www.mongodb.com/es/solutions/use-cases/payments"
										},
										{
											title: "Serverless Development",
											href: "https://www.mongodb.com/es/solutions/use-cases/serverless"
										},
										{
											title: "Juegos",
											href: "https://www.mongodb.com/solutions/use-cases/gaming"
										}
									]
								}
							]
						},
						{
							size: "small",
							subSections: [
								{
									title: "Industrias",
									menuItems: [
										{
											title: "Servicios financieros",
											href: "https://www.mongodb.com/es/solutions/industries/financial-services"
										},
										{
											title: "Telecomunicaciones",
											href: "https://www.mongodb.com/es/solutions/industries/telecommunications"
										},
										{
											title: "Atención sanitaria",
											href: "https://www.mongodb.com/es/solutions/industries/healthcare"
										},
										{
											title: "Comercio minorista",
											href: "https://www.mongodb.com/es/solutions/industries/retail"
										},
										{
											title: "Sector público",
											href: "https://www.mongodb.com/es/solutions/industries/public-sector"
										},
										{
											title: "Fabricación",
											href: "https://www.mongodb.com/es/solutions/industries/manufacturing"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "Biblioteca de soluciones",
					description: "Soluciones organizadas y personalizadas para iniciar proyectos",
					href: "https://www.mongodb.com/docs/atlas/architecture/current/solutions-library"
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "Startups e innovadores en IA",
							description: "Para ideas que cambian el mundo y pioneros de la IA",
							label: "Obtén más información",
							href: "https://www.mongodb.com/es/solutions/startups"
						},
						{
							title: "Estudios de casos de clientes",
							description: "Escuche directamente de nuestros usuarios",
							label: "Ver historias",
							href: "https://www.mongodb.com/solutions/customer-case-studies"
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Empresa",
			dropdown: {
				mainSection: {
					columns: [
						{
							subSections: [
								{
									menuItems: [
										{
											title: "Empleo",
											description: "Comience su próxima aventura",
											href: "https://www.mongodb.com/company/careers"
										},
										{
											title: "Blog",
											description: "Lea artículos y anuncios",
											href: "https://www.mongodb.com/blog"
										},
										{
											title: "Sala de redacción",
											description: "Lea comunicados de prensa y noticias",
											href: "https://www.mongodb.com/company/newsroom"
										}
									]
								}
							]
						},
						{
							subSections: [
								{
									menuItems: [
										{
											title: "Partners",
											description: "Más información sobre nuestro ecosistema de socios",
											href: "https://www.mongodb.com/es/company/partners"
										},
										{
											title: "Leadership",
											description: "Conozca a nuestro equipo ejecutivo",
											href: "https://www.mongodb.com/company/leadership"
										},
										{
											title: "Sobre nosotros",
											description: "Más información sobre quiénes somos",
											href: "https://www.mongodb.com/es/company"
										}
									]
								}
							]
						}
					]
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "Contáctenos",
							description: "Comuníquese con MongoDB",
							label: "Conéctese con un experto",
							href: "https://www.mongodb.com/es/company/contact"
						},
						{
							title: "Inversores",
							description: "Visite nuestro portal de inversores",
							label: "Más información",
							href: "https://investors.mongodb.com/"
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Precios",
			target: "_self",
			href: "https://www.mongodb.com/es/pricing"
		}
	],
	secondary: {
		"try": {
			title: "Prueba gratuita",
			href: "https://www.mongodb.com/es/cloud/atlas/register"
		},
		support: {
			title: "Support",
			target: "_self",
			href: "https://www.mongodb.com/es/services/support"
		},
		login: {
			title: "Iniciar sesión",
			href: "https://account.mongodb.com/account/login"
		},
		search: {
			submit: "Enviar",
			options: [
				{
					value: "Información general",
					placeholder: "Buscar productos, informes técnicos y mucho más...",
					universalKey: "DOTCOM"
				},
				{
					value: "Toda la documentación",
					placeholder: "Buscar en toda la documentación...",
					universalKey: "DOCS"
				},
				{
					value: "Artículos y temas para desarrolladores",
					placeholder: "Buscar en artículos y temas...",
					universalKey: "DEVHUB"
				},
				{
					value: "Foros de la comunidad",
					placeholder: "Buscar foros de la comunidad...",
					universalKey: "COMMUNITY"
				}
			]
		}
	}
};
var footer$6 = {
	copyright: "MongoDB, Inc.",
	sections: [
		{
			title: "Acerca de",
			links: [
				{
					title: "Empleo",
					target: "_self",
					href: "https://www.mongodb.com/careers"
				},
				{
					title: "Inversores",
					target: "_self",
					href: "https://investors.mongodb.com"
				},
				{
					title: "Legal",
					target: "_self",
					href: "https://www.mongodb.com/es/legal"
				},
				{
					title: "Privacy Policy",
					target: "_self",
					href: "https://www.mongodb.com/legal/privacy/privacy-policy"
				},
				{
					title: "GitHub",
					target: "_self",
					href: "https://github.com/mongodb"
				},
				{
					title: "Información sobre seguridad",
					target: "_self",
					href: "https://www.mongodb.com/es/company/contact/mongodb-vulnerability-disclosure-policy"
				},
				{
					title: "Centro de confianza",
					target: "_self",
					href: "https://www.mongodb.com/es/products/platform/trust"
				},
				{
					title: "Conéctate con nosotros",
					target: "_self",
					href: "https://www.mongodb.com/company/contact/social-media-hub"
				},
				{
					title: "Mapa del sitio",
					target: "_self",
					href: "https://www.mongodb.com/es/html-sitemap"
				}
			]
		},
		{
			title: "Soporte",
			links: [
				{
					title: "Contacto",
					target: "_self",
					href: "https://www.mongodb.com/es/company/contact"
				},
				{
					title: "Portal de clientes",
					target: "_self",
					href: "https://support.mongodb.com/welcome"
				},
				{
					title: "Atlas Status",
					target: "_self",
					href: "https://status.mongodb.com/"
				},
				{
					title: "Customer Support",
					target: "_self",
					href: "https://www.mongodb.com/es/services/support"
				},
				{
					id: "manage-cookies",
					title: "Gestionar Cookies",
					target: "_self",
					href: "#"
				}
			]
		},
		{
			title: "Opciones de implementación",
			links: [
				{
					title: "MongoDB Atlas",
					target: "_self",
					href: "https://www.mongodb.com/cloud/atlas/register"
				},
				{
					title: "Enterprise Advanced",
					target: "_self",
					href: "https://www.mongodb.com/try/download/enterprise"
				},
				{
					title: "Community Edition",
					target: "_self",
					href: " https://www.mongodb.com/try/download/community"
				}
			]
		},
		{
			title: "Data Basics",
			links: [
				{
					title: "Vector Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/vector-databases"
				},
				{
					title: "NoSQL Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/nosql-explained"
				},
				{
					title: "Document Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/document-databases"
				},
				{
					title: "RAG Database",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/artificial-intelligence/retrieval-augmented-generation"
				},
				{
					title: "ACID Transactions",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/acid-transactions"
				},
				{
					title: "MERN Stack",
					target: "_self",
					href: "https://www.mongodb.com/resources/languages/mern-stack"
				},
				{
					title: "MEAN Stack",
					target: "_self",
					href: " https://www.mongodb.com/resources/languages/mean-stack"
				}
			]
		}
	]
};
var es = {
	nav: nav$6,
	footer: footer$6
};

var nav$5 = {
	primary: [
		{
			title: "제품",
			dropdown: {
				mainSection: {
					columns: [
						{
							size: "large",
							subSections: [
								{
									title: "플랫폼",
									menuItems: [
										{
											title: "Atlas",
											description: "개발자 데이터 플랫폼을 기반으로 구축",
											brandedIconName: "atlas_product_family",
											href: "https://www.mongodb.com/ko-kr/atlas"
										}
									]
								},
								{
									title: "플랫폼 서비스",
									menuItems: [
										{
											title: "데이터베이스",
											description: "멀티 클라우드 데이터베이스 배포",
											brandedIconName: "atlas_database",
											href: "https://www.mongodb.com/ko-kr/products/platform/atlas-database"
										},
										{
											title: "검색",
											description: "흥미로운 검색 경험 제공",
											brandedIconName: "atlas_search",
											href: "https://www.mongodb.com/ko-kr/products/platform/atlas-search"
										},
										{
											title: "Vector Search",
											description: "gen AI로 지능형 앱 설계",
											brandedIconName: "mdb_vector_search",
											href: "https://www.mongodb.com/ko-kr/products/platform/atlas-vector-search"
										},
										{
											title: "Stream Processing",
											description: "MongoDB와 Kafka 통합",
											brandedIconName: "atlas_stream_processing",
											href: "https://www.mongodb.com/ko-kr/products/platform/atlas-stream-processing"
										}
									]
								}
							]
						},
						{
							size: "large",
							subSections: [
								{
									title: "자체 관리",
									menuItems: [
										{
											title: "Enterprise Advanced",
											description: "MongoDB 직접 실행 및 관리하기",
											brandedIconName: "enterprise_advanced_product family",
											href: "https://www.mongodb.com/ko-kr/products/self-managed/enterprise-advanced"
										},
										{
											title: "커뮤니티 에디션",
											description: "MongoDB로 로컬 개발하기",
											brandedIconName: "community_edition_product_family",
											href: "https://www.mongodb.com/products/self-managed/community-edition"
										}
									]
								},
								{
									title: "도구",
									menuItems: [
										{
											title: "Compass",
											description: "GUI에서 MongoDB 데이터로 작업하기",
											brandedIconName: "mdb_compass",
											href: "https://www.mongodb.com/ko-kr/products/tools/compass"
										},
										{
											title: "Integrations",
											description: "타사 서비스에 연결",
											brandedIconName: "atlas_integration",
											href: "https://cloud.mongodb.com/ecosystem/?filter=integration"
										},
										{
											title: "Relational Migrator",
											description: "MongoDB로 안전하게 마이그레이션하세요",
											brandedIconName: "mdb_migrator",
											href: "https://www.mongodb.com/ko-kr/products/tools/relational-migrator"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "모든 제품 보기",
					description: "전체 개발자 제품군 살펴보기",
					href: " https://www.mongodb.com/products"
				},
				footerAdditionalSection: {
					title: "MongoDB 8.0",
					description: "지금까지 가장 빠른 버전",
					href: "https://www.mongodb.com/products/updates/version-release"
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "MongoDB Atlas로 구축하기",
							description: "지금 바로 무료로 시작하기",
							label: "등록하기",
							href: "https://www.mongodb.com/ko-kr/cloud/atlas/register",
							isButtonType: true
						},
						{
							title: "Enterprise Advanced 테스트",
							description: "온프레미스에서 MongoDB로 개발하기",
							label: "다운로드",
							href: "https://www.mongodb.com/try/download/enterprise",
							isButtonType: true,
							onlyDesktop: true
						},
						{
							title: "커뮤니티 에디션 체험",
							description: "최신 버전의 MongoDB 살펴보기",
							label: "다운로드",
							href: "https://www.mongodb.com/try/download/community",
							isButtonType: true,
							onlyDesktop: true
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "리소스",
			dropdown: {
				mainSection: {
					columns: [
						{
							subSections: [
								{
									title: "문서",
									menuItems: [
										{
											title: "Atlas ",
											description: "Atlas 사용 시작하기",
											href: "https://www.mongodb.com/docs/atlas/"
										},
										{
											title: "서버",
											description: "MongoDB 사용 방법 알아보기",
											href: "https://www.mongodb.com/docs/manual/"
										}
									]
								}
							]
						},
						{
							subSections: [
								{
									title: " ",
									menuItems: [
										{
											title: "도구 및 커넥터",
											description: "MongoDB에 연결하는 방법 알아보기",
											href: "https://www.mongodb.com/docs/tools-and-connectors/"
										},
										{
											title: "MongoDB 드라이버",
											description: "MongoDB용 드라이버 및 라이브러리 사용",
											href: "https://www.mongodb.com/docs/drivers/"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "리소스 허브",
					description: "MongoDB로 차세대 혁신을 구축하는 데 도움을 받으세요",
					href: "https://www.mongodb.com/resources"
				},
				helperSection: {
					subSections: [
						{
							title: "커뮤니티",
							menuItems: [
								{
									title: "커뮤니티",
									description: "글로벌 개발자 커뮤니티에 참여하기",
									brandedIconName: "general_events_ask_the_experts",
									href: "https://www.mongodb.com/community/"
								},
								{
									title: "교육 과정 및 자격증",
									description: "MongoDB에서 무료로 학습하기",
									brandedIconName: "general_content_tutorial",
									href: "https://learn.mongodb.com/"
								},
								{
									title: "이벤트 및 웨비나",
									description: "가까운 이벤트나 웨비나 찾기",
									brandedIconName: "general_events_session",
									href: "https://www.mongodb.com/events"
								}
							]
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "솔루션",
			dropdown: {
				mainSection: {
					columns: [
						{
							size: "small",
							subSections: [
								{
									title: "사용 사례별",
									menuItems: [
										{
											title: "인공 지능 (AI)",
											href: "https://www.mongodb.com/ko-kr/solutions/use-cases/artificial-intelligence"
										},
										{
											title: "현대화",
											href: "https://www.mongodb.com/ko-kr/solutions/use-cases/modernize"
										},
										{
											title: "결제 (Payment)",
											href: "https://www.mongodb.com/ko-kr/solutions/use-cases/payments"
										},
										{
											title: "서버리스 개발",
											href: "https://www.mongodb.com/ko-kr/solutions/use-cases/serverless"
										},
										{
											title: "게임",
											href: "https://www.mongodb.com/solutions/use-cases/gaming"
										}
									]
								}
							]
						},
						{
							size: "small",
							subSections: [
								{
									title: "산업별",
									menuItems: [
										{
											title: "금융 서비스",
											href: "https://www.mongodb.com/ko-kr/solutions/industries/financial-services"
										},
										{
											title: "통신",
											href: "https://www.mongodb.com/ko-kr/solutions/industries/telecommunications"
										},
										{
											title: "의료",
											href: "https://www.mongodb.com/ko-kr/solutions/industries/healthcare"
										},
										{
											title: "소매",
											href: "https://www.mongodb.com/ko-kr/solutions/industries/retail"
										},
										{
											title: "공공 기관",
											href: "https://www.mongodb.com/ko-kr/solutions/industries/public-sector"
										},
										{
											title: "제조",
											href: "https://www.mongodb.com/ko-kr/solutions/industries/manufacturing"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "솔루션 라이브러리",
					description: "사용사례별 맞춤 솔루션을 살펴보세요",
					href: "https://www.mongodb.com/docs/atlas/architecture/current/solutions-library"
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "스타트업 및 AI 혁신기업",
							description: "세상을 바꾸는 아이디어와 AI 개척자를 위한 프로그램",
							label: "자세히 알아보기",
							href: "https://www.mongodb.com/ko-kr/solutions/startups"
						},
						{
							title: "고객 성공 사례",
							description: "비즈니스 혁신 사례를 확인하세요",
							label: "전체 성공 사례",
							href: "https://www.mongodb.com/solutions/customer-case-studies"
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "회사",
			dropdown: {
				mainSection: {
					columns: [
						{
							subSections: [
								{
									menuItems: [
										{
											title: "인재채용",
											description: "새로운 모험을 시작하세요.",
											href: "https://www.mongodb.com/company/careers"
										},
										{
											title: "블로그",
											description: "기사 및 공지사항 읽기",
											href: "https://www.mongodb.com/blog"
										},
										{
											title: "뉴스룸",
											description: "보도 자료 및 뉴스 기사 읽기",
											href: "https://www.mongodb.com/company/newsroom"
										}
									]
								}
							]
						},
						{
							subSections: [
								{
									menuItems: [
										{
											title: "파트너",
											description: "파트너 에코시스템 알아보기",
											href: "https://www.mongodb.com/ko-kr/company/partners"
										},
										{
											title: "리더십",
											description: "경영진 소개",
											href: "https://www.mongodb.com/ko-kr/company/leadership"
										},
										{
											title: "회사 소개",
											description: "MongoDB에 대해 자세히 알아보기",
											href: "https://www.mongodb.com/ko-kr/company"
										}
									]
								}
							]
						}
					]
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "문의처",
							description: "MongoDB에 문의하기",
							label: "전문가와 상담하기",
							href: "https://www.mongodb.com/ko-kr/company/contact"
						},
						{
							title: "투자자",
							description: "투자자 포털 방문하기",
							label: "자세히 알아보기",
							href: "https://investors.mongodb.com/"
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "가격",
			target: "_self",
			href: "https://www.mongodb.com/ko-kr/pricing"
		}
	],
	secondary: {
		"try": {
			title: "무료 체험판 다운로드",
			href: "https://www.mongodb.com/ko-kr/cloud/atlas/register"
		},
		support: {
			title: "Support",
			target: "_self",
			href: "https://www.mongodb.com/ko-kr/services/support"
		},
		login: {
			title: "등록",
			href: "https://account.mongodb.com/account/login"
		},
		search: {
			submit: "제출",
			options: [
				{
					value: "일반 정보",
					placeholder: "제품, 백서 및 추가 검색 중...",
					universalKey: "DOTCOM"
				},
				{
					value: "모든 문서",
					placeholder: "모든 문서 검색 중...",
					universalKey: "DOCS"
				},
				{
					value: "개발자 기사 및 주제",
					placeholder: "기사 및 주제 검색 중...",
					universalKey: "DEVHUB"
				},
				{
					value: "커뮤니티 포럼",
					placeholder: "커뮤니티 포럼 검색 중...",
					universalKey: "COMMUNITY"
				}
			]
		}
	}
};
var footer$5 = {
	copyright: "MongoDB, Inc.",
	sections: [
		{
			title: "회사정보",
			links: [
				{
					title: "인재채용",
					target: "_self",
					href: "https://www.mongodb.com/careers"
				},
				{
					title: "투자자",
					target: "_self",
					href: "https://investors.mongodb.com"
				},
				{
					title: "합법적인",
					target: "_self",
					href: "https://www.mongodb.com/ko-kr/legal"
				},
				{
					title: "Privacy Policy",
					target: "_self",
					href: "https://www.mongodb.com/legal/privacy/privacy-policy"
				},
				{
					title: "GitHub",
					target: "_self",
					href: "https://github.com/mongodb"
				},
				{
					title: "보안 정보",
					target: "_self",
					href: "https://www.mongodb.com/ko-kr/company/contact/mongodb-vulnerability-disclosure-policy"
				},
				{
					title: "트러스트 센터",
					target: "_self",
					href: "https://www.mongodb.com/ko-kr/products/platform/trust"
				},
				{
					title: "문의처",
					target: "_self",
					href: "https://www.mongodb.com/company/contact/social-media-hub"
				}
			]
		},
		{
			title: "지원",
			links: [
				{
					title: "문의처",
					target: "_self",
					href: "https://www.mongodb.com/ko-kr/company/contact"
				},
				{
					title: "고객 포털",
					target: "_self",
					href: "https://support.mongodb.com/welcome"
				},
				{
					title: "Atlas 상태",
					target: "_self",
					href: "https://status.mongodb.com/"
				},
				{
					title: "Customer Support",
					target: "_self",
					href: "https://www.mongodb.com/ko-kr/services/support"
				},
				{
					id: "manage-cookies",
					title: "쿠리 관리",
					target: "_self",
					href: "#"
				}
			]
		},
		{
			title: "배포 옵션",
			links: [
				{
					title: "MongoDB Atlas",
					target: "_self",
					href: "https://www.mongodb.com/cloud/atlas/register"
				},
				{
					title: "Enterprise Advanced",
					target: "_self",
					href: "https://www.mongodb.com/try/download/enterprise"
				},
				{
					title: "커뮤니티 에디션",
					target: "_self",
					href: " https://www.mongodb.com/try/download/community"
				}
			]
		},
		{
			title: "Data Basics",
			links: [
				{
					title: "Vector Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/vector-databases"
				},
				{
					title: "NoSQL Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/nosql-explained"
				},
				{
					title: "Document Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/document-databases"
				},
				{
					title: "RAG Database",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/artificial-intelligence/retrieval-augmented-generation"
				},
				{
					title: "ACID Transactions",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/acid-transactions"
				},
				{
					title: "MERN Stack",
					target: "_self",
					href: "https://www.mongodb.com/resources/languages/mern-stack"
				},
				{
					title: "MEAN Stack",
					target: "_self",
					href: " https://www.mongodb.com/resources/languages/mean-stack"
				}
			]
		}
	]
};
var koKr = {
	nav: nav$5,
	footer: footer$5
};

var nav$4 = {
	primary: [
		{
			title: "Prodotti",
			dropdown: {
				mainSection: {
					columns: [
						{
							size: "large",
							subSections: [
								{
									title: "Piattaforma",
									menuItems: [
										{
											title: "Atlas",
											description: "Lavora sulla piattaforma dati per sviluppatori",
											brandedIconName: "atlas_product_family",
											href: "https://www.mongodb.com/it-it/atlas"
										}
									]
								},
								{
									title: "Platform Services",
									menuItems: [
										{
											title: "Database",
											description: "Distribuisci un database multi-cloud",
											brandedIconName: "atlas_database",
											href: "https://www.mongodb.com/it-it/products/platform/atlas-database"
										},
										{
											title: "Cerca",
											description: "Offri esperienze di ricerca coinvolgenti",
											brandedIconName: "atlas_search",
											href: "https://www.mongodb.com/it-it/products/platform/atlas-search"
										},
										{
											title: "Ricerca vettoriale",
											description: "Progetta app intelligenti con la gen AI",
											brandedIconName: "mdb_vector_search",
											href: "https://www.mongodb.com/it-it/products/platform/atlas-vector-search"
										},
										{
											title: "Stream Processing",
											description: "Integra MongoDB e Kafka",
											brandedIconName: "atlas_stream_processing",
											href: "https://www.mongodb.com/it-it/products/platform/atlas-stream-processing"
										}
									]
								}
							]
						},
						{
							size: "large",
							subSections: [
								{
									title: "Autogestito",
									menuItems: [
										{
											title: "Enterprise Advanced",
											description: "Esegui e gestisci MongoDB in autonomia",
											brandedIconName: "enterprise_advanced_product family",
											href: "https://www.mongodb.com/it-it/products/self-managed/enterprise-advanced"
										},
										{
											title: "Community Edition",
											description: "Sviluppa localmente con MongoDB",
											brandedIconName: "community_edition_product_family",
											href: "https://www.mongodb.com/products/self-managed/community-edition"
										}
									]
								},
								{
									title: "Strumenti",
									menuItems: [
										{
											title: "Compass",
											description: "Lavora con i dati MongoDB in una GUI",
											brandedIconName: "mdb_compass",
											href: "https://www.mongodb.com/it-it/products/tools/compass"
										},
										{
											title: "Integrazioni",
											description: "Connettiti a servizi terzi",
											brandedIconName: "atlas_integration",
											href: "https://cloud.mongodb.com/ecosystem/?filter=integration"
										},
										{
											title: "Relational Migrator",
											description: "Passa a MongoDB in tutta sicurezza",
											brandedIconName: "mdb_migrator",
											href: "https://www.mongodb.com/it-it/products/tools/relational-migrator"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "Guarda tutti i prodotti",
					description: "Esplora la nostra suite completa per sviluppatori",
					href: " https://www.mongodb.com/products"
				},
				footerAdditionalSection: {
					title: "MongoDB 8.0",
					description: "La nostra versione più rapida di sempre",
					href: "https://www.mongodb.com/products/updates/version-release"
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "Crea con MongoDB Atlas",
							description: "Inizia gratis in pochi minuti",
							label: "Registrati",
							href: "https://www.mongodb.com/it-it/cloud/atlas/register",
							isButtonType: true
						},
						{
							title: "Testa Enterprise Advanced",
							description: "Sviluppa con MongoDB on-premise",
							label: "Scarica",
							href: "https://www.mongodb.com/try/download/enterprise",
							isButtonType: true,
							onlyDesktop: true
						},
						{
							title: "Prova la Community Edition",
							description: "Scopri l'ultima versione di MongoDB",
							label: "Scarica",
							href: "https://www.mongodb.com/try/download/community",
							isButtonType: true,
							onlyDesktop: true
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Risorse",
			dropdown: {
				mainSection: {
					columns: [
						{
							subSections: [
								{
									title: "Documentazione",
									menuItems: [
										{
											title: "Documentazione Atlas",
											description: "Inizia a utilizzare Atlas",
											href: "https://www.mongodb.com/docs/atlas/"
										},
										{
											title: "Documentazione server",
											description: "Impara a usare MongoDB",
											href: "https://www.mongodb.com/docs/manual/"
										}
									]
								}
							]
						},
						{
							subSections: [
								{
									title: " ",
									menuItems: [
										{
											title: "Strumenti e connector",
											description: "Scopri come connetterti a MongoDB",
											href: "https://www.mongodb.com/docs/tools-and-connectors/"
										},
										{
											title: "Driver MongoDB",
											description: "Usa driver e librerie per MongoDB",
											href: "https://www.mongodb.com/docs/drivers/"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "Hub Risorsa",
					description: "Ottieni aiuto per costruire la prossima grande novità con MongoDB",
					href: "https://www.mongodb.com/resources"
				},
				helperSection: {
					subSections: [
						{
							title: "Connettiti",
							menuItems: [
								{
									title: "Community",
									description: "Unisciti a una community globale di sviluppatori",
									brandedIconName: "general_events_ask_the_experts",
									href: "https://www.mongodb.com/community/"
								},
								{
									title: "Corsi e certificazioni",
									description: "Impara gratuitamente da MongoDB",
									brandedIconName: "general_content_tutorial",
									href: "https://learn.mongodb.com/"
								},
								{
									title: "Eventi e webinar",
									description: "Trova un evento o un webinar vicino a te",
									brandedIconName: "general_events_session",
									href: "https://www.mongodb.com/events"
								}
							]
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Soluzioni",
			dropdown: {
				mainSection: {
					columns: [
						{
							size: "small",
							subSections: [
								{
									title: "Casi D'Uso",
									menuItems: [
										{
											title: "Intelligenza artificiale",
											href: "https://www.mongodb.com/it-it/solutions/use-cases/artificial-intelligence"
										},
										{
											title: "Modernizzazione",
											href: "https://www.mongodb.com/it-it/solutions/use-cases/modernize"
										},
										{
											title: "Pagamenti",
											href: "https://www.mongodb.com/it-it/solutions/use-cases/payments"
										},
										{
											title: "Serverless Development",
											href: "https://www.mongodb.com/it-it/solutions/use-cases/serverless"
										},
										{
											title: "Gaming",
											href: "https://www.mongodb.com/solutions/use-cases/gaming"
										}
									]
								}
							]
						},
						{
							size: "small",
							subSections: [
								{
									title: "Settori",
									menuItems: [
										{
											title: "Servizi Finanziari",
											href: "https://www.mongodb.com/it-it/solutions/industries/financial-services"
										},
										{
											title: "Telecomunicazioni",
											href: "https://www.mongodb.com/it-it/solutions/industries/telecommunications"
										},
										{
											title: "Settore sanitario",
											href: "https://www.mongodb.com/it-it/solutions/industries/healthcare"
										},
										{
											title: "Commercio al Dettaglio",
											href: "https://www.mongodb.com/it-it/solutions/industries/retail"
										},
										{
											title: "Settore pubblico",
											href: "https://www.mongodb.com/it-it/solutions/industries/public-sector"
										},
										{
											title: "Produzione",
											href: "https://www.mongodb.com/it-it/solutions/industries/manufacturing"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "Solutions Library",
					description: "Soluzioni organizzate e su misura per dare il via ai tuoi progetti",
					href: "https://www.mongodb.com/docs/atlas/architecture/current/solutions-library"
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "Startup e AI Innovators",
							description: "Per idee che cambieranno il mondo e pionieri dell'AI",
							label: "Ulteriori Informazioni",
							href: "https://www.mongodb.com/it-it/solutions/startups"
						},
						{
							title: "Customer Case Study",
							description: "Scopri le esperienze de nostri clienti",
							label: "Vai ai case study",
							href: "https://www.mongodb.com/solutions/customer-case-studies"
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Azienda",
			dropdown: {
				mainSection: {
					columns: [
						{
							subSections: [
								{
									menuItems: [
										{
											title: "Opportunità di Lavoro",
											description: "Inizia la tua prossima avventura",
											href: "https://www.mongodb.com/company/careers"
										},
										{
											title: "Blog",
											description: "Leggi articoli e annunci",
											href: "https://www.mongodb.com/blog"
										},
										{
											title: "Sala stampa",
											description: "Leggi comunicati stampa e notizie",
											href: "https://www.mongodb.com/company/newsroom"
										}
									]
								}
							]
						},
						{
							subSections: [
								{
									menuItems: [
										{
											title: "Partners",
											description: "Scopri di più sul nostro ecosistema di partner",
											href: "https://www.mongodb.com/company/partners"
										},
										{
											title: "Direzione",
											description: "Incontra il nostro team di Executive",
											href: "https://www.mongodb.com/it-it/company/leadership"
										},
										{
											title: "Chi Siamo",
											description: "Scopri di più su chi siamo",
											href: "https://www.mongodb.com/it-it/company"
										}
									]
								}
							]
						}
					]
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "Contattaci",
							description: "Contatta MongoDB",
							label: "Entra in contatto con un esperto",
							href: "https://www.mongodb.com/it-it/company/contact"
						},
						{
							title: "Investitori",
							description: "Visita il nostro portale per gli investitori",
							label: "Ulteriori Informazioni",
							href: "https://investors.mongodb.com/"
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Prezzi",
			target: "_self",
			href: "https://www.mongodb.com/it-it/pricing"
		}
	],
	secondary: {
		"try": {
			title: "Prova gratuita",
			href: "https://www.mongodb.com/it-it/cloud/atlas/register"
		},
		support: {
			title: "Support",
			target: "_self",
			href: "https://www.mongodb.com/it-it/services/support"
		},
		login: {
			title: "Accedi",
			href: "https://account.mongodb.com/account/login"
		},
		search: {
			submit: "Invio",
			options: [
				{
					value: "Informazioni generali",
					placeholder: "Cerca in prodotti, whitepaper e altro...",
					universalKey: "DOTCOM"
				},
				{
					value: "Tutta la documentazione",
					placeholder: "Cerca in tutta la documentazione...",
					universalKey: "DOCS"
				},
				{
					value: "Articoli e argomenti per sviluppatori",
					placeholder: "Cerca in articoli e argomenti...",
					universalKey: "DEVHUB"
				},
				{
					value: "Forum della community",
					placeholder: "Cerca nei forum della community...",
					universalKey: "COMMUNITY"
				}
			]
		}
	}
};
var footer$4 = {
	copyright: "MongoDB, Inc.",
	sections: [
		{
			title: "Informazioni",
			links: [
				{
					title: "Posizioni",
					target: "_self",
					href: "https://www.mongodb.com/careers"
				},
				{
					title: "Investitori",
					target: "_self",
					href: "https://investors.mongodb.com"
				},
				{
					title: "Legale",
					target: "_self",
					href: "https://www.mongodb.com/it-it/legal"
				},
				{
					title: "Privacy Policy",
					target: "_self",
					href: "https://www.mongodb.com/legal/privacy/privacy-policy"
				},
				{
					title: "GitHub",
					target: "_self",
					href: "https://github.com/mongodb"
				},
				{
					title: "Informazioni sulla sicurezza",
					target: "_self",
					href: "https://www.mongodb.com/it-it/company/contact/mongodb-vulnerability-disclosure-policy"
				},
				{
					title: "Centro protezione",
					target: "_self",
					href: "https://www.mongodb.com/it-it/products/platform/trust"
				},
				{
					title: "Contattaci",
					target: "_self",
					href: "https://www.mongodb.com/company/contact/social-media-hub"
				}
			]
		},
		{
			title: "Supporto",
			links: [
				{
					title: "Contattaci",
					target: "_self",
					href: "https://www.mongodb.com/it-it/company/contact"
				},
				{
					title: "Portale dei clienti",
					target: "_self",
					href: "https://support.mongodb.com/welcome"
				},
				{
					title: "Atlas Status",
					target: "_self",
					href: "https://status.mongodb.com/"
				},
				{
					title: "Customer Support",
					target: "_self",
					href: "https://www.mongodb.com/it-it/services/support"
				},
				{
					id: "manage-cookies",
					title: "Gestisci Cookie",
					target: "_self",
					href: "#"
				}
			]
		},
		{
			title: "Opzioni di implementazione",
			links: [
				{
					title: "MongoDB Atlas",
					target: "_self",
					href: "https://www.mongodb.com/cloud/atlas/register"
				},
				{
					title: "Enterprise Advanced",
					target: "_self",
					href: "https://www.mongodb.com/try/download/enterprise"
				},
				{
					title: "Community Edition",
					target: "_self",
					href: " https://www.mongodb.com/try/download/community"
				}
			]
		},
		{
			title: "Data Basics",
			links: [
				{
					title: "Vector Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/vector-databases"
				},
				{
					title: "NoSQL Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/nosql-explained"
				},
				{
					title: "Document Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/document-databases"
				},
				{
					title: "RAG Database",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/artificial-intelligence/retrieval-augmented-generation"
				},
				{
					title: "ACID Transactions",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/acid-transactions"
				},
				{
					title: "MERN Stack",
					target: "_self",
					href: "https://www.mongodb.com/resources/languages/mern-stack"
				},
				{
					title: "MEAN Stack",
					target: "_self",
					href: " https://www.mongodb.com/resources/languages/mean-stack"
				}
			]
		}
	]
};
var itIt = {
	nav: nav$4,
	footer: footer$4
};

var nav$3 = {
	primary: [
		{
			title: "Produkte",
			dropdown: {
				mainSection: {
					columns: [
						{
							size: "large",
							subSections: [
								{
									title: "Plattform",
									menuItems: [
										{
											title: "Atlas",
											description: "Bauen Sie auf einer Entwicklerdatenplattform auf",
											brandedIconName: "atlas_product_family",
											href: "https://www.mongodb.com/de-de/atlas"
										}
									]
								},
								{
									title: "Plattform Dienstleistungen",
									menuItems: [
										{
											title: "Datenbank",
											description: "Bereitstellen einer Multi-Cloud-Datenbank",
											brandedIconName: "atlas_database",
											href: "https://www.mongodb.com/de-de/products/platform/atlas-database"
										},
										{
											title: "Suche",
											description: "Bieten Sie ansprechende Sucherlebnisse",
											brandedIconName: "atlas_search",
											href: "https://www.mongodb.com/de-de/products/platform/atlas-search"
										},
										{
											title: "Vektorsuche",
											description: "Entwerfen Sie intelligente Apps mit gen AI",
											brandedIconName: "mdb_vector_search",
											href: "https://www.mongodb.com/de-de/products/platform/atlas-vector-search"
										},
										{
											title: "Stream-Verarbeitung",
											description: "MongoDB und Kafka integrieren",
											brandedIconName: "atlas_stream_processing",
											href: "https://www.mongodb.com/de-de/products/platform/atlas-stream-processing"
										}
									]
								}
							]
						},
						{
							size: "large",
							subSections: [
								{
									title: "Self-Managed",
									menuItems: [
										{
											title: "Enterprise Advanced",
											description: "MongoDB selbst ausführen und managen",
											brandedIconName: "enterprise_advanced_product family",
											href: "https://www.mongodb.com/de-de/products/self-managed/enterprise-advanced"
										},
										{
											title: "Community Edition",
											description: "Lokale Entwicklung mit MongoDB",
											brandedIconName: "community_edition_product_family",
											href: "https://www.mongodb.com/products/self-managed/community-edition"
										}
									]
								},
								{
									title: "WERKZEUGE",
									menuItems: [
										{
											title: "Compass",
											description: "Arbeiten mit MongoDB-Daten in einer grafischen Benutzeroberfläche",
											brandedIconName: "mdb_compass",
											href: "https://www.mongodb.com/de-de/products/tools/compass"
										},
										{
											title: "Integrationen",
											description: "Verbindung zu Diensten Dritter",
											brandedIconName: "atlas_integration",
											href: "https://cloud.mongodb.com/ecosystem/?filter=integration"
										},
										{
											title: "Relational Migrator",
											description: "Migrieren Sie mit Zuversicht zu MongoDB",
											brandedIconName: "mdb_migrator",
											href: "https://www.mongodb.com/de-de/products/tools/relational-migrator"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "Alle Produkte anzeigen",
					description: "Entdecken Sie unsere komplette Entwicklersuite",
					href: " https://www.mongodb.com/products"
				},
				footerAdditionalSection: {
					title: "MongoDB 8.0",
					description: "Unsere schnellste Version aller Zeiten",
					href: "https://www.mongodb.com/products/updates/version-release"
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "Mit MongoDB Atlas erstellen",
							description: "Starten Sie in wenigen Minuten kostenlos",
							label: "Registrieren",
							href: "https://www.mongodb.com/de-de/cloud/atlas/register",
							isButtonType: true
						},
						{
							title: "Test Enterprise Advanced",
							description: "Entwicklung mit MongoDB On-Premise",
							label: "Herunterladen",
							href: "https://www.mongodb.com/try/download/enterprise",
							isButtonType: true,
							onlyDesktop: true
						},
						{
							title: "Community Edition ausprobieren",
							description: "Entdecken Sie die neueste Version von MongoDB",
							label: "Herunterladen",
							href: "https://www.mongodb.com/try/download/community",
							isButtonType: true,
							onlyDesktop: true
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Ressourcen",
			dropdown: {
				mainSection: {
					columns: [
						{
							subSections: [
								{
									title: "Dokumentation",
									menuItems: [
										{
											title: "Atlas-Dokumentation",
											description: "Erste Schritte mit Atlas",
											href: "https://www.mongodb.com/docs/atlas/"
										},
										{
											title: "Server-Dokumentation",
											description: "Lernen Sie MongoDB zu benutzen",
											href: "https://www.mongodb.com/docs/manual/"
										}
									]
								}
							]
						},
						{
							subSections: [
								{
									title: " ",
									menuItems: [
										{
											title: "Tools und Connectors",
											description: "Erfahren Sie, wie Sie eine Verbindung zu MongoDB herstellen",
											href: "https://www.mongodb.com/docs/tools-and-connectors/"
										},
										{
											title: "MongoDB-Treiber",
											description: "Verwenden Sie Treiber und Bibliotheken für MongoDB",
											href: "https://www.mongodb.com/docs/drivers/"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "Ressourcenzentrum",
					description: "Holen Sie sich Hilfe beim Aufbau des nächsten großen Dings mit MongoDB",
					href: "https://www.mongodb.com/resources"
				},
				helperSection: {
					subSections: [
						{
							title: "Verbinden",
							menuItems: [
								{
									title: "Nutzer-Community",
									description: "Treten Sie einer globalen Community von Entwicklern bei",
									brandedIconName: "general_events_ask_the_experts",
									href: "https://www.mongodb.com/community/"
								},
								{
									title: "Kurse und Zertifizierung",
									description: "Kostenlos von MongoDB lernen",
									brandedIconName: "general_content_tutorial",
									href: "https://learn.mongodb.com/"
								},
								{
									title: "Veranstaltungen und Webinare",
									description: "Finden Sie eine Veranstaltung oder ein Webinar in Ihrer Nähe",
									brandedIconName: "general_events_session",
									href: "https://www.mongodb.com/events"
								}
							]
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Lösungen",
			dropdown: {
				mainSection: {
					columns: [
						{
							size: "small",
							subSections: [
								{
									title: "Anwendungsfälle",
									menuItems: [
										{
											title: "Künstliche Intelligenz",
											href: "https://www.mongodb.com/de-de/solutions/use-cases/artificial-intelligence"
										},
										{
											title: "Modernisierung",
											href: "https://www.mongodb.com/de-de/solutions/use-cases/modernize"
										},
										{
											title: "Zahlungen",
											href: "https://www.mongodb.com/de-de/solutions/use-cases/payments"
										},
										{
											title: "Serverless-Development",
											href: "https://www.mongodb.com/de-de/solutions/use-cases/serverless"
										},
										{
											title: "Gaming",
											href: "https://www.mongodb.com/solutions/use-cases/gaming"
										}
									]
								}
							]
						},
						{
							size: "small",
							subSections: [
								{
									title: "Industrien",
									menuItems: [
										{
											title: "Finanzdienstleistungen",
											href: "https://www.mongodb.com/de-de/solutions/industries/financial-services"
										},
										{
											title: "Telekommunikation",
											href: "https://www.mongodb.com/de-de/solutions/industries/telecommunications"
										},
										{
											title: "Gesundheitswesen",
											href: "https://www.mongodb.com/de-de/solutions/industries/healthcare"
										},
										{
											title: "Einzelhandel",
											href: "https://www.mongodb.com/de-de/solutions/industries/retail"
										},
										{
											title: "Öffentlicher Sektor",
											href: "https://www.mongodb.com/de-de/solutions/industries/public-sector"
										},
										{
											title: "Fertigung",
											href: "https://www.mongodb.com/de-de/solutions/industries/manufacturing"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "Lösungsbibliothek",
					description: "Organisierte und zugeschnittene Lösungen für den Projektstart",
					href: "https://www.mongodb.com/docs/atlas/architecture/current/solutions-library"
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "Start-ups und KI Innovatoren",
							description: "Für weltverändernde Ideen und KI Pioniere",
							label: "Weitere Informationen",
							href: "https://www.mongodb.com/de-de/solutions/startups"
						},
						{
							title: "Fallstudien von Kunden",
							description: "Hör direkt von unseren Usern",
							label: "Berichte finden Sie hier",
							href: "https://www.mongodb.com/solutions/customer-case-studies"
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Unternehmen",
			dropdown: {
				mainSection: {
					columns: [
						{
							subSections: [
								{
									menuItems: [
										{
											title: "Karriere",
											description: "Starten Sie Ihr nächstes Abenteuer",
											href: "https://www.mongodb.com/company/careers"
										},
										{
											title: "Blog",
											description: "Artikel und Ankündigungen lesen",
											href: "https://www.mongodb.com/blog"
										},
										{
											title: "Newsroom",
											description: "Presseveröffentlichungen und Nachrichten lesen",
											href: "https://www.mongodb.com/company/newsroom"
										}
									]
								}
							]
						},
						{
							subSections: [
								{
									menuItems: [
										{
											title: "Partner",
											description: "Erfahren Sie mehr über unser Partner-Ökosystem",
											href: "https://www.mongodb.com/company/partners"
										},
										{
											title: "Führung",
											description: "Lernen Sie unser Führungsteam kennen",
											href: "https://www.mongodb.com/de-de/company/leadership"
										},
										{
											title: "Über Uns",
											description: "Erfahren Sie mehr darüber, wer wir sind",
											href: "https://www.mongodb.com/de-de/company"
										}
									]
								}
							]
						}
					]
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "Kontakt",
							description: "Kontaktaufnahme mit MongoDB",
							label: "Mit einem Experten in Kontakt treten",
							href: "https://www.mongodb.com/de-de/company/contact"
						},
						{
							title: "Investoren",
							description: "Besuchen Sie unser Investorenportal",
							label: "Weitere Informationen",
							href: "https://investors.mongodb.com/"
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Preise",
			target: "_self",
			href: "https://www.mongodb.com/de-de/pricing"
		}
	],
	secondary: {
		"try": {
			title: "Kostenlos testen",
			href: "https://www.mongodb.com/de-de/cloud/atlas/register"
		},
		support: {
			title: "Support",
			target: "_self",
			href: "https://www.mongodb.com/de-de/services/support"
		},
		login: {
			title: "Anmelden",
			href: "https://account.mongodb.com/account/login"
		},
		search: {
			submit: "Absenden",
			options: [
				{
					value: "Allgemeine Informationen",
					placeholder: "Produkte, Whitepaper und mehr ansehen...",
					universalKey: "DOTCOM"
				},
				{
					value: "Gesamte Dokumentation",
					placeholder: "Gesamte Dokumentation durchsuchen...",
					universalKey: "DOCS"
				},
				{
					value: "Artikel und Themen für Entwickler",
					placeholder: "Artikel und Themen durchsuchen...",
					universalKey: "DEVHUB"
				},
				{
					value: "Community-Foren",
					placeholder: "Community-Foren durchsuchen...",
					universalKey: "COMMUNITY"
				}
			]
		}
	}
};
var footer$3 = {
	copyright: "MongoDB, Inc.",
	sections: [
		{
			title: "Über uns",
			links: [
				{
					title: "Karriere",
					target: "_self",
					href: "https://www.mongodb.com/careers"
				},
				{
					title: "Investoren",
					target: "_self",
					href: "https://investors.mongodb.com"
				},
				{
					title: "Rechtliches",
					target: "_self",
					href: "https://www.mongodb.com/de-de/legal"
				},
				{
					title: "Privacy Policy",
					target: "_self",
					href: "https://www.mongodb.com/legal/privacy/privacy-policy"
				},
				{
					title: "GitHub",
					target: "_self",
					href: "https://github.com/mongodb"
				},
				{
					title: "Sicherheitsinformationen",
					target: "_self",
					href: "https://www.mongodb.com/de-de/company/contact/mongodb-vulnerability-disclosure-policy"
				},
				{
					title: "Trust Center",
					target: "_self",
					href: "https://www.mongodb.com/de-de/products/platform/trust"
				},
				{
					title: "Kontaktieren Sie uns",
					target: "_self",
					href: "https://www.mongodb.com/company/contact/social-media-hub"
				},
				{
					title: "Sitemap",
					target: "_self",
					href: "https://www.mongodb.com/de-de/html-sitemap"
				},
				{
					title: "Impressum",
					target: "_self",
					href: "https://www.mongodb.com/de-de/company#impressum"
				}
			]
		},
		{
			title: "Support",
			links: [
				{
					title: "Kontakt",
					target: "_self",
					href: "https://www.mongodb.com/de-de/company/contact"
				},
				{
					title: "Kunden-Portal",
					target: "_self",
					href: "https://support.mongodb.com/welcome"
				},
				{
					title: "Atlas Status",
					target: "_self",
					href: "https://status.mongodb.com/"
				},
				{
					title: "Customer Support",
					target: "_self",
					href: "https://www.mongodb.com/de-de/services/support"
				},
				{
					id: "manage-cookies",
					title: "Cookies verwalten",
					target: "_self",
					href: "#"
				}
			]
		},
		{
			title: "Bereitstellungsoptionen",
			links: [
				{
					title: "MongoDB Atlas",
					target: "_self",
					href: "https://www.mongodb.com/cloud/atlas/register"
				},
				{
					title: "Enterprise Advanced",
					target: "_self",
					href: "https://www.mongodb.com/try/download/enterprise"
				},
				{
					title: "Community Edition",
					target: "_self",
					href: " https://www.mongodb.com/try/download/community"
				}
			]
		},
		{
			title: "Data Basics",
			links: [
				{
					title: "Vector Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/vector-databases"
				},
				{
					title: "NoSQL Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/nosql-explained"
				},
				{
					title: "Document Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/document-databases"
				},
				{
					title: "RAG Database",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/artificial-intelligence/retrieval-augmented-generation"
				},
				{
					title: "ACID Transactions",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/acid-transactions"
				},
				{
					title: "MERN Stack",
					target: "_self",
					href: "https://www.mongodb.com/resources/languages/mern-stack"
				},
				{
					title: "MEAN Stack",
					target: "_self",
					href: " https://www.mongodb.com/resources/languages/mean-stack"
				}
			]
		}
	]
};
var deDe = {
	nav: nav$3,
	footer: footer$3
};

var nav$2 = {
	primary: [
		{
			title: "Produits",
			dropdown: {
				mainSection: {
					columns: [
						{
							size: "large",
							subSections: [
								{
									title: "Plateforme",
									menuItems: [
										{
											title: "Atlas",
											description: "Construisez sur une Developer Data Platform",
											brandedIconName: "atlas_product_family",
											href: "https://www.mongodb.com/fr-fr/atlas"
										}
									]
								},
								{
									title: "Plateforme De Services",
									menuItems: [
										{
											title: "Base de données",
											description: "Déployez une base de données multicloud",
											brandedIconName: "atlas_database",
											href: "https://www.mongodb.com/fr-fr/products/platform/atlas-database"
										},
										{
											title: "Recherche",
											description: "Offrez des expériences de recherche attrayantes",
											brandedIconName: "atlas_search",
											href: "https://www.mongodb.com/fr-fr/products/platform/atlas-search"
										},
										{
											title: "Vector Search",
											description: "Créez des applications intelligentes avec l'IA générative",
											brandedIconName: "mdb_vector_search",
											href: "https://www.mongodb.com/fr-fr/products/platform/atlas-vector-search"
										},
										{
											title: "Stream Processing",
											description: "Intégrer MongoDB et Kafka",
											brandedIconName: "atlas_stream_processing",
											href: "https://www.mongodb.com/fr-fr/products/platform/atlas-stream-processing"
										}
									]
								}
							]
						},
						{
							size: "large",
							subSections: [
								{
									title: "Autogestion",
									menuItems: [
										{
											title: "Enterprise Advanced",
											description: "Exécutez et gérez MongoDB vous-même",
											brandedIconName: "enterprise_advanced_product family",
											href: "https://www.mongodb.com/fr-fr/products/self-managed/enterprise-advanced"
										},
										{
											title: "Community Edition",
											description: "Développez localement avec MongoDB",
											brandedIconName: "community_edition_product_family",
											href: "https://www.mongodb.com/products/self-managed/community-edition"
										}
									]
								},
								{
									title: "Outils",
									menuItems: [
										{
											title: "Compass",
											description: "Travaillez avec des données MongoDB dans une GUI",
											brandedIconName: "mdb_compass",
											href: "https://www.mongodb.com/fr-fr/products/tools/compass"
										},
										{
											title: "Intégrations",
											description: "Connectez-vous à des services tiers",
											brandedIconName: "atlas_integration",
											href: "https://cloud.mongodb.com/ecosystem/?filter=integration"
										},
										{
											title: "Relational Migrator",
											description: "Migrez vers MongoDB en toute confiance",
											brandedIconName: "mdb_migrator",
											href: "https://www.mongodb.com/fr-fr/products/tools/relational-migrator"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "Voir tous nos produits",
					description: "Explorez notre suite complète pour développeurs",
					href: " https://www.mongodb.com/products"
				},
				footerAdditionalSection: {
					title: "MongoDB 8.0",
					description: "Notre version la plus rapide à ce jour",
					href: "https://www.mongodb.com/products/updates/version-release"
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "Concevez avec MongoDB Atlas",
							description: "Démarrez gratuitement, en quelques minutes",
							label: "S'inscrire",
							href: "https://www.mongodb.com/fr-fr/cloud/atlas/register",
							isButtonType: true
						},
						{
							title: "Test Enterprise Advanced",
							description: "Développez sur site avec MongoDB",
							label: "Télécharger",
							href: "https://www.mongodb.com/try/download/enterprise",
							isButtonType: true,
							onlyDesktop: true
						},
						{
							title: "Testez l'Edition Community",
							description: "Découvrez la dernière version de MongoDB",
							label: "Télécharger",
							href: "https://www.mongodb.com/try/download/community",
							isButtonType: true,
							onlyDesktop: true
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Ressources",
			dropdown: {
				mainSection: {
					columns: [
						{
							subSections: [
								{
									title: "Documentation",
									menuItems: [
										{
											title: "Documentation Atlas",
											description: "Démarrer avec Atlas",
											href: "https://www.mongodb.com/docs/atlas/"
										},
										{
											title: "Documentation du serveur",
											description: "Apprenez à utiliser MongoDB",
											href: "https://www.mongodb.com/docs/manual/"
										}
									]
								}
							]
						},
						{
							subSections: [
								{
									title: " ",
									menuItems: [
										{
											title: "Outils et connecteurs",
											description: "Découvrez comment vous connecter à MongoDB",
											href: "https://www.mongodb.com/docs/tools-and-connectors/"
										},
										{
											title: "MongoDB Drivers",
											description: "Utilisez des drivers et des bibliothèques pour MongoDB",
											href: "https://www.mongodb.com/docs/drivers/"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "Hub Ressources",
					description: "Obtenez de l'aide pour créer la prochaine grande nouveauté avec MongoDB",
					href: "https://www.mongodb.com/resources"
				},
				helperSection: {
					subSections: [
						{
							title: "Connecter",
							menuItems: [
								{
									title: "Communauté",
									description: "Rejoignez une communauté mondiale de développeurs",
									brandedIconName: "general_events_ask_the_experts",
									href: "https://www.mongodb.com/community/"
								},
								{
									title: "Cours et certification",
									description: "Apprenez gratuitement avec MongoDB",
									brandedIconName: "general_content_tutorial",
									href: "https://learn.mongodb.com/"
								},
								{
									title: "Événements et webinaires",
									description: "Trouvez un événement ou un webinaire dans votre région",
									brandedIconName: "general_events_session",
									href: "https://www.mongodb.com/events"
								}
							]
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Solutions",
			dropdown: {
				mainSection: {
					columns: [
						{
							size: "small",
							subSections: [
								{
									title: "Cas D'Utilisation",
									menuItems: [
										{
											title: "Intelligence artificielle",
											href: "https://www.mongodb.com/fr-fr/solutions/use-cases/artificial-intelligence"
										},
										{
											title: "Modernisation",
											href: "https://www.mongodb.com/fr-fr/solutions/use-cases/modernize"
										},
										{
											title: "Paiements",
											href: "https://www.mongodb.com/fr-fr/solutions/use-cases/payments"
										},
										{
											title: "Développement Serverless",
											href: "https://www.mongodb.com/fr-fr/solutions/use-cases/serverless"
										},
										{
											title: "Jeux",
											href: "https://www.mongodb.com/solutions/use-cases/gaming"
										}
									]
								}
							]
						},
						{
							size: "small",
							subSections: [
								{
									title: "Secteurs D'Activité",
									menuItems: [
										{
											title: "Services Financiers",
											href: "https://www.mongodb.com/fr-fr/solutions/industries/financial-services"
										},
										{
											title: "Télécommunications",
											href: "https://www.mongodb.com/fr-fr/solutions/industries/telecommunications"
										},
										{
											title: "Santé",
											href: "https://www.mongodb.com/fr-fr/solutions/industries/healthcare"
										},
										{
											title: "Commerce de Détail",
											href: "https://www.mongodb.com/fr-fr/solutions/industries/retail"
										},
										{
											title: "Secteur public",
											href: "https://www.mongodb.com/fr-fr/solutions/industries/public-sector"
										},
										{
											title: "Secteur de l'industrie",
											href: "https://www.mongodb.com/fr-fr/solutions/industries/manufacturing"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "Portfolio de solutions",
					description: "Des solutions adaptées pour lancer des projets rapidement",
					href: "https://www.mongodb.com/docs/atlas/architecture/current/solutions-library"
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "Startups et innovateurs en IA",
							description: "Pour des idées qui changent le monde et pour les pionniers de l'IA",
							label: "En Savoir Plus",
							href: "https://www.mongodb.com/fr-fr/solutions/startups"
						},
						{
							title: "Cas clients",
							description: "Écouter directement nos utilisateurs",
							label: "Voir les témoignages",
							href: "https://www.mongodb.com/solutions/customer-case-studies"
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Entreprise",
			dropdown: {
				mainSection: {
					columns: [
						{
							subSections: [
								{
									menuItems: [
										{
											title: "Carrières",
											description: "Commencez votre prochaine aventure",
											href: "https://www.mongodb.com/company/careers"
										},
										{
											title: "Blog",
											description: "Lisez les articles et les annonces",
											href: "https://www.mongodb.com/blog"
										},
										{
											title: "Salle de presse",
											description: "Lisez les communiqués de presse et les actualités",
											href: "https://www.mongodb.com/company/newsroom"
										}
									]
								}
							]
						},
						{
							subSections: [
								{
									menuItems: [
										{
											title: "Partenaires",
											description: "Découvrez notre écosystème de partenaires",
											href: "https://www.mongodb.com/company/partners"
										},
										{
											title: "Direction",
											description: "Rencontrez notre équipe de direction",
											href: "https://www.mongodb.com/fr-fr/company/leadership"
										},
										{
											title: "Qui Sommes-nous",
											description: "Découvrez qui nous sommes",
											href: "https://www.mongodb.com/fr-fr/company"
										}
									]
								}
							]
						}
					]
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "Nous contacter",
							description: "Contactez MongoDB",
							label: "Contactez un expert",
							href: "https://www.mongodb.com/fr-fr/company/contact"
						},
						{
							title: "Investisseurs",
							description: "Consultez notre portail investisseurs",
							label: "En Savoir Plus",
							href: "https://investors.mongodb.com/"
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "Tarifs",
			target: "_self",
			href: "https://www.mongodb.com/fr-fr/pricing"
		}
	],
	secondary: {
		"try": {
			title: "Essayez gratuitement",
			target: "_self",
			href: "https://www.mongodb.com/fr-fr/cloud/atlas/register"
		},
		support: {
			title: "Support",
			target: "_self",
			href: "https://www.mongodb.com/fr-fr/services/support"
		},
		login: {
			title: "Connexion",
			target: "_self",
			href: "https://account.mongodb.com/account/login"
		},
		search: {
			submit: "Recherche",
			options: [
				{
					value: "Informations générales",
					placeholder: "Rechercher des produits, des livres blancs etc...",
					universalKey: "DOTCOM"
				},
				{
					value: "Toute la documentation",
					placeholder: "Rechercher dans toute la documentation...",
					universalKey: "DOCS"
				},
				{
					value: "Articles et sujets développeur",
					placeholder: "Rechercher dans les articles et sujets...",
					universalKey: "DEVHUB"
				},
				{
					value: "Forums communautaires",
					placeholder: "Rechercher dans les forums communautaires...",
					universalKey: "COMMUNITY"
				}
			]
		}
	}
};
var footer$2 = {
	copyright: "MongoDB, Inc.",
	sections: [
		{
			title: "À propos",
			links: [
				{
					title: "Carrières",
					target: "_self",
					href: "https://www.mongodb.com/careers"
				},
				{
					title: "Investisseurs",
					target: "_self",
					href: "https://investors.mongodb.com"
				},
				{
					title: "Légal",
					target: "_self",
					href: "https://www.mongodb.com/fr-fr/legal"
				},
				{
					title: "Privacy Policy",
					target: "_self",
					href: "https://www.mongodb.com/legal/privacy/privacy-policy"
				},
				{
					title: "GitHub",
					target: "_self",
					href: "https://github.com/mongodb"
				},
				{
					title: "Information de sécurité",
					target: "_self",
					href: "https://www.mongodb.com/fr-fr/company/contact/mongodb-vulnerability-disclosure-policy"
				},
				{
					title: "Centre de gestion de la confidentialité",
					target: "_self",
					href: "https://www.mongodb.com/fr-fr/products/platform/trust"
				},
				{
					title: "Connectez-vous avec nous",
					target: "_self",
					href: "https://www.mongodb.com/company/contact/social-media-hub"
				},
				{
					title: "Plan du site",
					target: "_self",
					href: "https://www.mongodb.com/fr-fr/html-sitemap"
				}
			]
		},
		{
			title: "Support",
			links: [
				{
					title: "Nous Contacter",
					target: "_self",
					href: "https://www.mongodb.com/fr-fr/company/contact"
				},
				{
					title: "Portail client",
					target: "_self",
					href: "https://support.mongodb.com/welcome"
				},
				{
					title: "Statut d'Atlas",
					target: "_self",
					href: "https://status.mongodb.com/"
				},
				{
					title: "Customer Support",
					target: "_self",
					href: "https://www.mongodb.com/fr-fr/services/support"
				},
				{
					id: "manage-cookies",
					title: "Paramètres des cookies",
					target: "_self",
					href: "#"
				}
			]
		},
		{
			title: "Options de déploiement",
			links: [
				{
					title: "MongoDB Atlas",
					target: "_self",
					href: "https://www.mongodb.com/cloud/atlas/register"
				},
				{
					title: "Enterprise Advanced",
					target: "_self",
					href: "https://www.mongodb.com/try/download/enterprise"
				},
				{
					title: "Community Edition",
					target: "_self",
					href: " https://www.mongodb.com/try/download/community"
				}
			]
		},
		{
			title: "Data Basics",
			links: [
				{
					title: "Vector Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/vector-databases"
				},
				{
					title: "NoSQL Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/nosql-explained"
				},
				{
					title: "Document Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/document-databases"
				},
				{
					title: "RAG Database",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/artificial-intelligence/retrieval-augmented-generation"
				},
				{
					title: "ACID Transactions",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/acid-transactions"
				},
				{
					title: "MERN Stack",
					target: "_self",
					href: "https://www.mongodb.com/resources/languages/mern-stack"
				},
				{
					title: "MEAN Stack",
					target: "_self",
					href: " https://www.mongodb.com/resources/languages/mean-stack"
				}
			]
		}
	]
};
var frFr = {
	nav: nav$2,
	footer: footer$2
};

var nav$1 = {
	primary: [
		{
			title: "产品",
			dropdown: {
				mainSection: {
					columns: [
						{
							size: "large",
							subSections: [
								{
									title: "平台",
									menuItems: [
										{
											title: "Atlas",
											description: "基于开发者数据平台构建",
											brandedIconName: "atlas_product_family",
											href: "https://www.mongodb.com/zh-cn/atlas"
										}
									]
								},
								{
									title: "数据平台服务",
									menuItems: [
										{
											title: "数据库",
											description: "部署多云数据库",
											brandedIconName: "atlas_database",
											href: "https://www.mongodb.com/zh-cn/products/platform/atlas-database"
										},
										{
											title: "搜索",
											description: "提供引人入胜的搜索体验",
											brandedIconName: "atlas_search",
											href: "https://www.mongodb.com/zh-cn/products/platform/atlas-search"
										},
										{
											title: "Vector Search",
											description: "使用 gen AI 设计智能应用程序",
											brandedIconName: "mdb_vector_search",
											href: "https://www.mongodb.com/zh-cn/products/platform/atlas-vector-search"
										},
										{
											title: "流处理",
											description: "集成 MongoDB 与 Kafka",
											brandedIconName: "atlas_stream_processing",
											href: "https://www.mongodb.com/zh-cn/products/platform/atlas-stream-processing"
										}
									]
								}
							]
						},
						{
							size: "large",
							subSections: [
								{
									title: "自我管理",
									menuItems: [
										{
											title: "Enterprise Advanced",
											description: "自行运行并管理 MongoDB",
											brandedIconName: "enterprise_advanced_product family",
											href: "https://www.mongodb.com/zh-cn/products/self-managed/enterprise-advanced"
										},
										{
											title: "社区版",
											description: "使用 MongoDB 进行本地开发",
											brandedIconName: "community_edition_product_family",
											href: "https://www.mongodb.com/products/self-managed/community-edition"
										}
									]
								},
								{
									title: "工具",
									menuItems: [
										{
											title: "Compass",
											description: "在 GUI 中处理 MongoDB 数据",
											brandedIconName: "mdb_compass",
											href: "https://www.mongodb.com/zh-cn/products/tools/compass"
										},
										{
											title: "集成",
											description: "连接第三方服务",
											brandedIconName: "atlas_integration",
											href: "https://cloud.mongodb.com/ecosystem/?filter=integration"
										},
										{
											title: "Relational Migrator",
											description: "自信地迁移到 MongoDB",
											brandedIconName: "mdb_migrator",
											href: "https://www.mongodb.com/zh-cn/products/tools/relational-migrator"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "查看所有产品",
					description: "探索我们的完整开发套件",
					href: " https://www.mongodb.com/products"
				},
				footerAdditionalSection: {
					title: "MongoDB 8.0",
					description: "我们有史以来速度最快的版本",
					href: "https://www.mongodb.com/products/updates/version-release"
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "使用 MongoDB Atlas 构建",
							description: "几分钟内即可免费开始使用",
							label: "注册",
							href: "https://www.mongodb.com/zh-cn/cloud/atlas/register",
							isButtonType: true
						},
						{
							title: "测试 Enterprise Advanced",
							description: "使用 MongoDB 在本地进行开发",
							label: "立即下载",
							href: "https://www.mongodb.com/try/download/enterprise",
							isButtonType: true,
							onlyDesktop: true
						},
						{
							title: "试用社区版",
							description: "探索 MongoDB 的最新版本",
							label: "立即下载",
							href: "https://www.mongodb.com/try/download/community",
							isButtonType: true,
							onlyDesktop: true
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "资源",
			dropdown: {
				mainSection: {
					columns: [
						{
							subSections: [
								{
									title: "文档",
									menuItems: [
										{
											title: "Atlas 文档",
											description: "开始使用 Atlas",
											href: "https://www.mongodb.com/docs/atlas/"
										},
										{
											title: "服务器文档",
											description: "学习使用 MongoDB",
											href: "https://www.mongodb.com/docs/manual/"
										}
									]
								}
							]
						},
						{
							subSections: [
								{
									title: " ",
									menuItems: [
										{
											title: "工具和连接器",
											description: "了解如何连接到 MongoDB",
											href: "https://www.mongodb.com/docs/tools-and-connectors/"
										},
										{
											title: "MongoDB 驱动",
											description: "使用 MongoDB 的驱动程序和库",
											href: "https://www.mongodb.com/docs/drivers/"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "资源中心",
					description: "获取帮助，利用 MongoDB 构建下一个重大项目",
					href: "https://www.mongodb.com/resources"
				},
				helperSection: {
					subSections: [
						{
							title: "链接",
							menuItems: [
								{
									title: "社区",
									description: "加入全球开发者社区",
									brandedIconName: "general_events_ask_the_experts",
									href: "https://www.mongodb.com/community/"
								},
								{
									title: "课程和认证",
									description: "免费学习 MongoDB 的资源",
									brandedIconName: "general_content_tutorial",
									href: "https://learn.mongodb.com/"
								},
								{
									title: "活动与网络研讨会",
									description: "查找您附近的活动或网络研讨会",
									brandedIconName: "general_events_session",
									href: "https://www.mongodb.com/events"
								}
							]
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "解决方案",
			dropdown: {
				mainSection: {
					columns: [
						{
							size: "small",
							subSections: [
								{
									title: "使用案例",
									menuItems: [
										{
											title: "人工智能",
											href: "https://www.mongodb.com/zh-cn/solutions/use-cases/artificial-intelligence"
										},
										{
											title: "现代化",
											href: "https://www.mongodb.com/zh-cn/solutions/use-cases/modernize"
										},
										{
											title: "支付",
											href: "https://www.mongodb.com/zh-cn/solutions/use-cases/payments"
										},
										{
											title: "无服务器开发",
											href: "https://www.mongodb.com/zh-cn/solutions/use-cases/serverless"
										},
										{
											title: "游戏",
											href: "https://www.mongodb.com/solutions/use-cases/gaming"
										}
									]
								}
							]
						},
						{
							size: "small",
							subSections: [
								{
									title: "行业",
									menuItems: [
										{
											title: "金融服务",
											href: "https://www.mongodb.com/zh-cn/solutions/industries/financial-services"
										},
										{
											title: "电信",
											href: "https://www.mongodb.com/zh-cn/solutions/industries/telecommunications"
										},
										{
											title: "医疗保健",
											href: "https://www.mongodb.com/zh-cn/solutions/industries/healthcare"
										},
										{
											title: "零售",
											href: "https://www.mongodb.com/zh-cn/solutions/industries/retail"
										},
										{
											title: "公共部门",
											href: "https://www.mongodb.com/zh-cn/solutions/industries/public-sector"
										},
										{
											title: "制造",
											href: "https://www.mongodb.com/zh-cn/solutions/industries/manufacturing"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "解决方案",
					description: "定制化解决方案加速您的项目启动",
					href: "https://www.mongodb.com/docs/atlas/architecture/current/solutions-library"
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "创业公司和AI创新者",
							description: "为改变世界的伟大想法和AI先驱保驾护航",
							label: "了解详情",
							href: "https://www.mongodb.com/zh-cn/solutions/startups"
						},
						{
							title: "客户案例",
							description: "用户的评价和反馈",
							label: "查看详情",
							href: "https://www.mongodb.com/solutions/customer-case-studies"
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "公司",
			dropdown: {
				mainSection: {
					columns: [
						{
							subSections: [
								{
									menuItems: [
										{
											title: "招聘",
											description: "开始您的下一次冒险",
											href: "https://www.mongodb.com/company/careers"
										},
										{
											title: "博客",
											description: "阅读文章和公告",
											href: "https://www.mongodb.com/blog"
										},
										{
											title: "新闻",
											description: "阅读新闻稿和新闻报道",
											href: "https://www.mongodb.com/company/newsroom"
										}
									]
								}
							]
						},
						{
							subSections: [
								{
									menuItems: [
										{
											title: "合作伙伴",
											description: "了解我们的合作伙伴生态系统",
											href: "https://www.mongodb.com/zh-cn/company/partners"
										},
										{
											title: "领导层",
											description: "认识我们的执行团队",
											href: "https://www.mongodb.com/zh-cn/company/leadership"
										},
										{
											title: "关于我们",
											description: "详细了解我们",
											href: "https://www.mongodb.com/zh-cn/company"
										}
									]
								}
							]
						}
					]
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "联系我们",
							description: "联系 MongoDB",
							label: "与专家联系",
							href: "https://www.mongodb.com/zh-cn/company/contact"
						},
						{
							title: "Investors",
							description: "访问我们的投资者门户网站",
							label: "了解详情",
							href: "https://investors.mongodb.com/"
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "定价",
			target: "_self",
			href: "https://www.mongodb.com/zh-cn/pricing"
		}
	],
	secondary: {
		"try": {
			title: "免费试用",
			href: "https://www.mongodb.com/zh-cn/cloud/atlas/register"
		},
		support: {
			title: "Support",
			target: "_self",
			href: "https://www.mongodb.com/zh-cn/services/support"
		},
		login: {
			title: "登录",
			href: "https://account.mongodb.com/account/login"
		},
		search: {
			submit: "提交",
			options: [
				{
					value: "基本信息",
					placeholder: "搜索产品、白皮书等...",
					universalKey: "DOTCOM"
				},
				{
					value: "所有文档",
					placeholder: "搜索所有文档...",
					universalKey: "DOCS"
				},
				{
					value: "开发者文章和话题",
					placeholder: "搜索文章和话题...",
					universalKey: "DEVHUB"
				},
				{
					value: "社区论坛",
					placeholder: "搜索社区论坛...",
					universalKey: "COMMUNITY"
				}
			]
		}
	}
};
var footer$1 = {
	copyright: "MongoDB, Inc.",
	sections: [
		{
			title: "关于MongoDB",
			links: [
				{
					title: "招贤纳士",
					target: "_self",
					href: "https://www.mongodb.com/careers"
				},
				{
					title: "投资者关系",
					target: "_self",
					href: "https://investors.mongodb.com"
				},
				{
					title: "合法的",
					target: "_self",
					href: "https://www.mongodb.com/zh-cn/legal"
				},
				{
					title: "Privacy Policy",
					target: "_self",
					href: "https://www.mongodb.com/legal/privacy/privacy-policy"
				},
				{
					title: "GitHub",
					target: "_self",
					href: "https://github.com/mongodb"
				},
				{
					title: "安全信息",
					target: "_self",
					href: "https://www.mongodb.com/zh-cn/company/contact/mongodb-vulnerability-disclosure-policy"
				},
				{
					title: "信任中心",
					target: "_self",
					href: "https://www.mongodb.com/zh-cn/products/platform/trust"
				},
				{
					title: "联系我们",
					target: "_self",
					href: "https://www.mongodb.com/company/contact/social-media-hub"
				}
			]
		},
		{
			title: "支持",
			links: [
				{
					title: "联系我们",
					target: "_self",
					href: "https://www.mongodb.com/zh-cn/company/contact"
				},
				{
					title: "客户门户",
					target: "_self",
					href: "https://support.mongodb.com/welcome"
				},
				{
					title: "Atlas 状态",
					target: "_self",
					href: "https://status.mongodb.com/"
				},
				{
					title: "Customer Support",
					target: "_self",
					href: "https://www.mongodb.com/zh-cn/services/support"
				},
				{
					id: "manage-cookies",
					title: "管理 Cookie",
					target: "_self",
					href: "#"
				}
			]
		},
		{
			title: "部署选项",
			links: [
				{
					title: "MongoDB Atlas",
					target: "_self",
					href: "https://www.mongodb.com/cloud/atlas/register"
				},
				{
					title: "Enterprise Advanced",
					target: "_self",
					href: "https://www.mongodb.com/try/download/enterprise"
				},
				{
					title: "社区版",
					target: "_self",
					href: " https://www.mongodb.com/try/download/community"
				}
			]
		},
		{
			title: "Data Basics",
			links: [
				{
					title: "Vector Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/vector-databases"
				},
				{
					title: "NoSQL Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/nosql-explained"
				},
				{
					title: "Document Databases",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/document-databases"
				},
				{
					title: "RAG Database",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/artificial-intelligence/retrieval-augmented-generation"
				},
				{
					title: "ACID Transactions",
					target: "_self",
					href: "https://www.mongodb.com/resources/basics/databases/acid-transactions"
				},
				{
					title: "MERN Stack",
					target: "_self",
					href: "https://www.mongodb.com/resources/languages/mern-stack"
				},
				{
					title: "MEAN Stack",
					target: "_self",
					href: " https://www.mongodb.com/resources/languages/mean-stack"
				}
			]
		}
	]
};
var zhCn = {
	nav: nav$1,
	footer: footer$1
};

var nav = {
	primary: [
		{
			title: "製品",
			dropdown: {
				mainSection: {
					columns: [
						{
							size: "large",
							subSections: [
								{
									title: "プラットフォーム",
									menuItems: [
										{
											title: "Atlas",
											description: "開発者向けデータプラットフォーム",
											brandedIconName: "atlas_product_family",
											href: "https://www.mongodb.com/ja-jp/atlas"
										}
									]
								},
								{
									title: "プラットフォームサービス",
									menuItems: [
										{
											title: "データベース",
											description: "マルチクラウドデータベース",
											brandedIconName: "atlas_database",
											href: "https://www.mongodb.com/ja-jp/products/platform/atlas-database"
										},
										{
											title: "検索",
											description: "優れた検索エクスペリエンス",
											brandedIconName: "atlas_search",
											href: "https://www.mongodb.com/ja-jp/atlas/search"
										},
										{
											title: "ベクトル検索（プレビュー）",
											description: "生成 AI でインテリジェントなアプリを設計",
											brandedIconName: "mdb_vector_search",
											href: "https://www.mongodb.com/ja-jp/products/platform/atlas-vector-search"
										},
										{
											title: "ストリーム処理（プレビュー）",
											description: "MongoDB と Kafka の統合",
											brandedIconName: "atlas_stream_processing",
											href: "https://www.mongodb.com/ja-jp/products/platform/atlas-stream-processing"
										}
									]
								}
							]
						},
						{
							size: "large",
							subSections: [
								{
									title: "セルフサービス",
									menuItems: [
										{
											title: "Enterprise Advanced",
											description: "セルフサービスで MongoDB を実行・管理",
											brandedIconName: "enterprise_advanced_product family",
											href: "https://www.mongodb.com/ja-jp/products/self-managed/enterprise-advanced"
										},
										{
											title: "Community Edition",
											description: "MongoDB を活用してローカル環境で開発",
											brandedIconName: "community_edition_product_family",
											href: "https://www.mongodb.com/ja-jp/products/self-managed/community-edition"
										}
									]
								},
								{
									title: "ツール",
									menuItems: [
										{
											title: "Compass",
											description: "MongoDB データのための GUI",
											brandedIconName: "mdb_compass",
											href: "https://www.mongodb.com/ja-jp/products/tools/compass"
										},
										{
											title: "統合",
											description: "サードパーティのサービスとの統合",
											brandedIconName: "atlas_integration",
											href: "https://cloud.mongodb.com/ja-jp/ecosystem/integrations"
										},
										{
											title: "Relational Migrator",
											description: "MongoDB へのスムーズな移行",
											brandedIconName: "mdb_migrator",
											href: "https://www.mongodb.com/ja-jp/products/tools/relational-migrator"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "製品一覧のページへ",
					description: "開発者向けフルスイートをチェック！",
					href: " https://www.mongodb.com/products"
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "MongoDB Atlas で構築",
							description: "今すぐ無料で利用できます！",
							label: "ご登録",
							href: "https://www.mongodb.com/ja-jp/cloud/atlas/register",
							isButtonType: true
						},
						{
							title: "Enterprise Advanced のお試し",
							description: "MongoDB をオンプレミスで",
							label: "ダウンロード",
							href: "https://www.mongodb.com/try/download/enterprise",
							isButtonType: true,
							onlyDesktop: true
						},
						{
							title: "Community Edition のお試し",
							description: "MongoDB の最新版をお試しください！",
							label: "ダウンロード",
							href: "https://www.mongodb.com/try/download/community",
							isButtonType: true,
							onlyDesktop: true
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "リソース",
			dropdown: {
				mainSection: {
					columns: [
						{
							subSections: [
								{
									title: "ドキュメント",
									menuItems: [
										{
											title: "Atlas に関するドキュメント",
											description: "Atlas の概要と使用方法",
											href: "https://www.mongodb.com/ja-jp/docs/atlas/"
										},
										{
											title: "サーバーに関するドキュメント",
											description: "MongoDB の概要と使用方法",
											href: "https://www.mongodb.com/ja-jp/docs/manual/"
										},
										{
											title: "導入・利用の手引き",
											description: "手順を追って導入方法を解説",
											href: "https://www.mongodb.com/ja-jp/docs/guides/"
										}
									]
								}
							]
						},
						{
							subSections: [
								{
									title: " ",
									menuItems: [
										{
											title: "ツールとコネクタ",
											description: "MongoDB への接続方法",
											href: "https://www.mongodb.com/ja-jp/docs/tools-and-connectors/"
										},
										{
											title: "MongoDB ドライバー",
											description: "サポート対象のドライバーとライブラリ",
											href: "https://www.mongodb.com/ja-jp/docs/drivers/"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "リソースハブ",
					description: "MongoDB で構築するプロジェクトにお役立てください！",
					href: "https://www.mongodb.com/resources"
				},
				helperSection: {
					subSections: [
						{
							title: "MongoDB あれこれ",
							menuItems: [
								{
									title: "コミュニティ",
									description: "グローバルな開発者コミュニティ",
									brandedIconName: "general_events_ask_the_experts",
									href: "https://www.mongodb.com/ja-jp/community/"
								},
								{
									title: "コース・認定",
									description: "MongoDB を無料で学べます！",
									brandedIconName: "general_content_tutorial",
									href: "https://learn.mongodb.com/"
								},
								{
									title: "イベント",
									description: "イベントや Web セミナーをチェック！",
									brandedIconName: "general_events_session",
									href: "https://www.mongodb.com/ja-jp/events"
								}
							]
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "ソリューション",
			dropdown: {
				mainSection: {
					columns: [
						{
							size: "small",
							subSections: [
								{
									title: "ユースケース",
									menuItems: [
										{
											title: "AI（人工知能）",
											href: "https://www.mongodb.com/ja-jp/solutions/use-cases/artificial-intelligence"
										},
										{
											title: "エッジコンピューティング",
											href: "https://www.mongodb.com/use-cases/atlas-for-the-edge"
										},
										{
											title: "IoT（モノのインターネット）",
											href: "https://www.mongodb.com/ja-jp/solutions/use-cases/internet-of-things"
										},
										{
											title: "モバイル",
											href: "https://www.mongodb.com/ja-jp/solutions/use-cases/mobile"
										},
										{
											title: "支払い処理",
											href: "https://www.mongodb.com/ja-jp/solutions/use-cases/payments"
										},
										{
											title: "サーバーレス開発",
											href: "https://www.mongodb.com/ja-jp/solutions/use-cases/serverless"
										},
										{
											title: "ゲーム",
											href: "https://www.mongodb.com/solutions/use-cases/gaming"
										}
									]
								}
							]
						},
						{
							size: "small",
							subSections: [
								{
									title: "業界",
									menuItems: [
										{
											title: "金融サービス",
											href: "https://www.mongodb.com/ja-jp/solutions/industries/financial-services"
										},
										{
											title: "テレコム",
											href: "https://www.mongodb.com/ja-jp/solutions/industries/telecommunications"
										},
										{
											title: "医療・ヘルスケア",
											href: "https://www.mongodb.com/ja-jp/solutions/industries/healthcare"
										},
										{
											title: "リテール（小売）",
											href: "https://www.mongodb.com/ja-jp/solutions/industries/retail"
										},
										{
											title: "公共機関",
											href: "https://www.mongodb.com/ja-jp/solutions/industries/public-sector"
										},
										{
											title: "製造",
											href: "https://www.mongodb.com/ja-jp/solutions/industries/manufacturing"
										}
									]
								}
							]
						}
					]
				},
				footerSection: {
					title: "ソリューションライブラリ",
					description: "プロジェクトの始動をカスタムソリューションで支援",
					href: "https://www.mongodb.com/ja-jp/solutions/solutions-library"
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "スタートアップ・AI イノベーター",
							description: "AI をはじめとする革新的なアイデアを支援",
							label: "詳しく見る",
							href: "https://www.mongodb.com/ja-jp/solutions/startups"
						},
						{
							title: "導入事例",
							description: "お客さまの声",
							label: "詳しく見る",
							href: "https://www.mongodb.com/library/customer-case-studies"
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "企業情報",
			dropdown: {
				mainSection: {
					columns: [
						{
							subSections: [
								{
									menuItems: [
										{
											title: "採用情報",
											description: "新たな冒険を始めませんか？",
											href: "https://www.mongodb.com/ja-jp/company/careers"
										},
										{
											title: "ブログ",
											description: "最新情報を含む多様なコンテンツ",
											href: "https://www.mongodb.com/blog"
										},
										{
											title: "ニュースルーム",
											description: "プレスリリースとニュース記事",
											href: "https://www.mongodb.com/company/newsroom"
										}
									]
								}
							]
						},
						{
							subSections: [
								{
									menuItems: [
										{
											title: "パートナー",
											description: "MongoDB のパートナーエコシステム",
											href: "https://www.mongodb.com/ja-jp/docs/"
										},
										{
											title: "経営陣",
											description: "経営陣のご紹介",
											href: "https://www.mongodb.com/ja-jp/company/leadership"
										},
										{
											title: "会社概要",
											description: "MongoDB について",
											href: "https://www.mongodb.com/ja-jp/company"
										}
									]
								}
							]
						}
					]
				},
				helperSection: {
					helperSectionItems: [
						{
							title: "ご相談・お問い合わせ",
							description: "MongoDB へのお問い合わせ",
							label: "お問い合わせページへ",
							href: "https://www.mongodb.com/ja-jp/company/contact"
						},
						{
							title: "投資家向け情報",
							description: "インベスターポータル",
							label: "詳しく見る",
							href: "https://investors.mongodb.com/"
						}
					]
				}
			},
			highlightUrls: null
		},
		{
			title: "価格情報",
			target: "_self",
			href: "https://www.mongodb.com/pricing"
		}
	],
	secondary: {
		"try": {
			title: "無料トライアル",
			target: "_self",
			href: "https://www.mongodb.com/cloud/atlas/register"
		},
		support: {
			title: "サポート",
			target: "_self",
			href: "https://www.mongodb.com/services/support"
		},
		login: {
			title: "サインイン",
			target: "_self",
			href: "https://account.mongodb.com/account/login"
		},
		search: {
			submit: "Search",
			options: [
				{
					value: "General Information",
					placeholder: "Search products, whitepapers, & more...",
					universalKey: "DOTCOM"
				},
				{
					value: "Documentation",
					placeholder: "Search documentation...",
					universalKey: "DOCS"
				},
				{
					value: "Developer Articles & Topics",
					placeholder: "Search articles and topics...",
					universalKey: "DEVHUB"
				},
				{
					value: "Community Forums",
					placeholder: "Search community forums...",
					universalKey: "COMMUNITY"
				},
				{
					value: "Blog",
					placeholder: "Search blog...",
					universalKey: "BLOG"
				},
				{
					value: "University",
					placeholder: "Search university...",
					universalKey: "UNIVERSITY"
				}
			]
		}
	}
};
var footer = {
	copyright: "MongoDB, Inc.",
	sections: [
		{
			title: "About",
			links: [
				{
					title: "Careers",
					target: "_self",
					href: "https://www.mongodb.com/careers"
				},
				{
					title: "Investor Relations",
					target: "_self",
					href: "https://investors.mongodb.com"
				},
				{
					title: "Legal",
					target: "_self",
					href: "https://www.mongodb.com/legal"
				},
				{
					title: "Privacy Policy",
					target: "_self",
					href: "https://www.mongodb.com/legal/privacy/privacy-policy"
				},
				{
					title: "GitHub",
					target: "_self",
					href: "https://github.com/mongodb"
				},
				{
					title: "Security Information",
					target: "_self",
					href: "https://www.mongodb.com/company/contact/mongodb-vulnerability-disclosure-policy"
				},
				{
					title: "Trust Center",
					target: "_self",
					href: "https://www.mongodb.com/products/platform/trust"
				},
				{
					title: "Connect with Us",
					target: "_self",
					href: "https://www.mongodb.com/company/contact/social-media-hub"
				},
				{
					title: "Saudi Arabian VAT Certificate",
					target: "_blank",
					href: "https://webassets.mongodb.com/_com_assets/cms/lcqodf8rajwqnn9uw-MongoBD%20VAT%20certificate_ZATCA_KSA.pdf",
					hide: true
				}
			]
		},
		{
			title: "Support",
			links: [
				{
					title: "Contact Us",
					target: "_self",
					href: "https://www.mongodb.com/company/contact"
				},
				{
					title: "Customer Portal",
					target: "_self",
					href: "https://support.mongodb.com/welcome"
				},
				{
					title: "Atlas Status",
					target: "_self",
					href: "https://status.mongodb.com/"
				},
				{
					title: "Customer Support",
					target: "_self",
					href: "https://www.mongodb.com/services/support"
				},
				{
					id: "manage-cookies",
					title: "Manage Cookies",
					target: "_self",
					href: "#"
				}
			]
		},
		{
			title: "Deployment Options",
			links: [
				{
					title: "MongoDB Atlas",
					target: "_self",
					href: "https://www.mongodb.com/cloud/atlas/register"
				},
				{
					title: "Enterprise Advanced",
					target: "_self",
					href: "https://www.mongodb.com/try/download/enterprise"
				},
				{
					title: "Community Edition",
					target: "_self",
					href: " https://www.mongodb.com/try/download/community"
				}
			]
		}
	]
};
var jaJp = {
	nav: nav,
	footer: footer
};

/**
 * Temporarily convert docs.mongodb.com urls (and other docs-related subdomains)
 * to a dotcom url format. The hope is to change all hardcoded docs.mongodb.com
 * links to become www.mongodb.com/docs links once QA is complete.
 * @param {string} url The original URL.
 * @param {string | undefined} dotcomBaseUrl The base URL to be used in place of docs.mongodb.com.
 */
const standardizeDocsUrl = (url, dotcomBaseUrl) => {
  if (!dotcomBaseUrl) {
    return url;
  }

  const decomposedUrl = url.split(".");
  const subdomainProduct =
    decomposedUrl[1] !== "mongodb" ? decomposedUrl[1] : null;
  if (!decomposedUrl[0].includes("docs")) {
    return url;
  }

  if (subdomainProduct) {
    dotcomBaseUrl = `${dotcomBaseUrl}/${subdomainProduct}`;
  }

  let pathname = url.split(".mongodb.com")[1];
  pathname = pathname.split("/").slice(1).join("/");
  return pathname.length >= 1
    ? `${dotcomBaseUrl}/${pathname}`
    : `${dotcomBaseUrl}/`;
};

const handleDocUrls = (data, docsBaseUrl) => {
  data.footer.sections.forEach((value) => {
    value.links.forEach((link) => {
      if (link.standardizeDocsUrl) {
        link.href = standardizeDocsUrl(link.href, docsBaseUrl);
      }
    });
  });
  return data;
};

const getData = (docsBaseUrl) => {
  return {
    "en-us": handleDocUrls(enUs, docsBaseUrl),
    "pt-br": handleDocUrls(ptBr, docsBaseUrl),
    es: handleDocUrls(es, docsBaseUrl),
    "ko-kr": handleDocUrls(koKr, docsBaseUrl),
    "it-it": handleDocUrls(itIt, docsBaseUrl),
    "de-de": handleDocUrls(deDe, docsBaseUrl),
    "fr-fr": handleDocUrls(frFr, docsBaseUrl),
    "zh-cn": handleDocUrls(zhCn, docsBaseUrl),
    "ja-jp": handleDocUrls(jaJp, docsBaseUrl),
  };
};

const properties = [
    "DOTCOM",
    "REALM",
    "DOCS",
    "DEVHUB",
    "COMMUNITY",
];
function isProperty(val) {
    return properties.includes(val);
}
const getContent = (docsBaseUrl) => getData(docsBaseUrl);
const testData = getData();
/**
 *
 * @param data i18n data from json files
 * @returns a map where the keys are the value and the values are the universal keys for each
 * nav dropdown option
 *
 * e.g. "All Documentation" -> "DOCS"
 * This is used to map the selectedProperty in the NavSearch component.
 */
const getValueToPropertyMap = (data) => {
    const map = new Map();
    Object.values(data).forEach(({ nav }) => {
        const { options } = nav.secondary.search;
        options.forEach(({ value, universalKey }) => {
            // theoretically, universalKey should be a part of the Property type literal,
            // but is of type string here
            // using a type guard to make typescript happy
            if (isProperty(universalKey)) {
                map.set(value, universalKey);
            }
        });
    });
    return map;
};
const valueToPropertyOptionsMap = getValueToPropertyMap(testData);
const getOptionUniversalKey = (val) => {
    return valueToPropertyOptionsMap.get(val);
};

var ESelectVariants;
(function (ESelectVariants) {
    ESelectVariants["DEFAULT"] = "default";
    ESelectVariants["MULTISELECT"] = "multi-select";
})(ESelectVariants || (ESelectVariants = {}));

const getIconColor = (inverse, disabled) => {
    if (inverse) {
        return disabled ? "icon.system.inverseNeutral" : "icon.system.inverse";
    }
    return disabled ? "icon.system.defaultNeutral" : "icon.system.default";
};
const Icon = ({ disabled, inverse, open, theme: theme$2, }) => {
    const selectedTheme = theme$2 === "legacy" ? theme : theme$1;
    return (jsx("div", { sx: { padding: `0 ${selectedTheme.space.inc30}` }, children: jsx("svg", { "data-testid": "icon", width: "16", height: "9", viewBox: "0 0 16 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", sx: {
                transform: open ? "rotateZ(90deg)" : "rotateZ(0.5deg)",
                transition: "transform .15s ease-in-out",
                zIndex: 0,
            }, children: jsx("path", { d: "M1.06689 0.799988L8.00023 7.73332L14.9336 0.799988", strokeLinecap: "round", strokeLinejoin: "round", sx: {
                    stroke: getIconColor(inverse, disabled),
                } }) }) }));
};

const getLabelColor = (open, invalid, inverse, disabled, darkMode) => {
    if (darkMode)
        return "black00";
    if (inverse) {
        if (open || disabled) {
            return "input.inverse.textSecondary";
        }
        return invalid ? "input.inverse.textError" : "input.inverse.text";
    }
    return disabled ? "text.neutral" : "input.default.text";
};
const getBackgroundColor = (inverse, disabled, darkMode) => {
    if (darkMode) {
        return "black70";
    }
    if (inverse) {
        return disabled
            ? "background.selectedInverseLighter"
            : "background.containerInverse";
    }
    return disabled ? "background.container" : "background.body";
};
const SelectButton = ({ ...props }) => {
    const { id, open, variant, hoverValue, value, multiSelectValues, disabled, inverse, invalid, border, width, children, theme: theme$1, ariaLabel, darkMode, } = props;
    let selected;
    const selectedTheme = theme;
    if (variant === ESelectVariants.MULTISELECT) {
        selected = multiSelectValues;
    }
    else {
        selected = value || hoverValue;
    }
    return (jsx(ThemeProvider, { theme: selectedTheme, children: jsxs("button", { id: id, role: "button", type: "button", "aria-label": ariaLabel, sx: {
                position: "relative",
                display: "flex",
                justifyContent: open || value || multiSelectValues.length > 0
                    ? "space-between"
                    : "flex-end",
                alignItems: "center",
                width: width || "280px",
                height: "48px",
                border: border === "none"
                    ? "none"
                    : `1px solid ${invalid
                        ? selectedTheme.colors.input.default.borderError
                        : selectedTheme.colors.input.default.border}`,
                borderRadius: "input",
                boxSizing: "border-box",
                cursor: disabled ? "not-allowed" : "pointer",
                fontWeight: "300",
                bg: border === "none"
                    ? "transparent"
                    : getBackgroundColor(inverse, disabled, darkMode),
                paddingLeft: "0",
                color: darkMode ? "black00" : "black70",
                borderColor: darkMode ? "black50" : "black30",
            }, children: [children && (jsx("div", { sx: {
                        display: "flex",
                        pointerEvents: open ? null : "none",
                        cursor: disabled ? "not-allowed" : "default",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        position: "absolute",
                        left: "0",
                        willChange: "transform, color, font-size",
                        maxWidth: `calc(100% - ${open || value || multiSelectValues.length > 0
                            ? selectedTheme.space.inc40
                            : selectedTheme.space.inc50})`,
                        transform: `translateY(${open || value || multiSelectValues.length > 0
                            ? `-${selectedTheme.space.inc40}`
                            : "0px"}) translateX(${open || value || multiSelectValues.length > 0
                            ? selectedTheme.space.base
                            : selectedTheme.space.inc30})`,
                        transition: "transform 200ms cubic-bezier(0.25, 0.1, 0.25, 1) 0ms, color 200ms cubic-bezier(0.25, 0.1, 0.25, 1) 0ms, font-size 200ms cubic-bezier(0.25, 0.1, 0.25, 1) 0ms",
                        padding: `0 ${selectedTheme.space.base}`,
                        lineHeight: "inc00",
                        fontFamily: selectedTheme.fonts.body,
                        fontSize: open || value || multiSelectValues.length > 0
                            ? "inc00"
                            : "inc20",
                        color: getLabelColor(open, invalid, inverse, disabled, darkMode),
                        bg: getBackgroundColor(inverse, disabled, darkMode),
                    }, children: children })), hoverValue && open && !multiSelectValues.length && (jsx("span", { "data-testid": "hover-value", sx: {
                        fontFamily: selectedTheme.fonts.body,
                        fontSize: "inc20",
                        lineHeight: "inc00",
                        color: darkMode
                            ? "black00"
                            : inverse
                                ? "text.inverse"
                                : "text.default",
                        paddingLeft: "inc30",
                        width: width || "100%",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textAlign: "left",
                    }, children: hoverValue })), value && !open && (jsx("span", { "data-testid": "selected-value", sx: {
                        fontFamily: selectedTheme.fonts.body,
                        fontSize: "inc20",
                        lineHeight: "inc00",
                        color: darkMode
                            ? "black00"
                            : inverse
                                ? "text.inverse"
                                : "text.default",
                        paddingLeft: "inc30",
                        width: width || "100%",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textAlign: "left",
                    }, children: selected })), multiSelectValues.length !== 0 && (jsx("span", { "data-testid": "multi-select-values", sx: {
                        fontFamily: selectedTheme.fonts.body,
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        fontSize: "inc20",
                        lineHeight: "inc00",
                        color: darkMode
                            ? "black00"
                            : inverse
                                ? "text.inverse"
                                : "text.default",
                        paddingLeft: "inc30",
                    }, children: `(${multiSelectValues.length}) ${multiSelectValues.join(", ")}` })), jsx(Icon, { disabled: disabled, open: open, inverse: darkMode !== null && darkMode !== void 0 ? darkMode : inverse, theme: theme$1 })] }) }));
};

const MultiSelectOption = ({ option, inverse, values, theme: theme$1 = "default", hover, multiSelectItems, multiSelectToggle, }) => {
    const selectedTheme = theme;
    const [selected, setSelected] = useState(values.some((value) => value === option));
    const toggleCheckboxStyles = () => {
        setSelected(!selected);
    };
    return (jsx(ThemeProvider, { theme: selectedTheme, children: jsxs("li", { role: "option", tabIndex: 0, sx: {
                position: "relative",
                padding: selectedTheme.space.base,
                "&:not(:last-child)": {
                    marginBottom: selectedTheme.space.base,
                },
            }, onMouseEnter: () => hover(option), onKeyPress: (e) => {
                if (e.key === "Enter") {
                    toggleCheckboxStyles();
                    multiSelectToggle(option);
                }
            }, children: [jsx("input", { type: "checkbox", tabIndex: -1, id: option, name: option, sx: {
                        position: "absolute",
                        opacity: 0,
                        "& ~ label > span": selected && {
                            border: `1px solid ${selectedTheme.colors.green50}`,
                        },
                        "& ~ label > span::after": selected && {
                            content: '""',
                        },
                    } }), jsxs("label", { htmlFor: option, tabIndex: -1, sx: {
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                    }, onClick: () => {
                        toggleCheckboxStyles();
                        multiSelectToggle(option);
                        multiSelectItems(values);
                    }, children: [jsx("span", { sx: {
                                cursor: "pointer",
                                position: "relative",
                                display: "inline-block",
                                width: selectedTheme.space.inc40,
                                height: selectedTheme.space.inc40,
                                marginRight: selectedTheme.space.base,
                                border: `1px solid ${selectedTheme.colors.border.default}`,
                                borderRadius: "input",
                                overflow: "hidden",
                                "&::before": {
                                    content: '""',
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    bg: inverse ? "background.containerInverse" : "background.body",
                                    cursor: "pointer",
                                    position: "absolute",
                                    left: 0,
                                    top: 0,
                                },
                                "&::after": {
                                    width: "100%",
                                    height: "100%",
                                    backgroundColor: "background.selected",
                                    backgroundImage: 'url("https://webimages.mongodb.com/_com_assets/cms/kq9tpkyancd805sjx-Path.svg?auto=format%252Ccompress")',
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center center",
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                },
                            } }), option] })] }) }));
};

const getInverseHoverStyles = (inverse, darkMode) => {
    if (darkMode) {
        return {
            bg: "green40",
            color: "green80",
        };
    }
    else if (inverse) {
        return {
            bg: "background.selectedInverseLighter",
            color: "green40",
        };
    }
    return {
        bg: "green10",
        color: "text.selected",
    };
};
const Option = ({ option, inverse, theme: theme$2, hover, selected, darkMode, }) => {
    const selectedTheme = theme$2 === "legacy" ? theme : theme$1;
    const getValue = (event) => {
        const el = event.target;
        return el.innerText;
    };
    return (jsx(ThemeProvider, { theme: selectedTheme, children: jsx("li", { role: "option", tabIndex: 0, sx: {
                cursor: "pointer",
                padding: selectedTheme.space.base,
                "&:not(:last-child)": {
                    marginBottom: selectedTheme.space.base,
                },
                "&:hover": {
                    borderRadius: "inc10",
                    ...getInverseHoverStyles(inverse, darkMode),
                },
            }, onMouseEnter: () => hover(option), onClick: (e) => {
                e.stopPropagation();
                const value = getValue(e);
                selected(value);
            }, onKeyPress: (e) => {
                if (e.key === "Enter") {
                    const value = getValue(e);
                    selected(value);
                }
            }, children: option }) }));
};

const pxToInt = (px) => {
    return Number(px.split("px")[0]);
};

const Dropdown = ({ id, options, open, variant, inverse, width, menuPlacement, wrapperHeight, wrapperOffsetTop, theme: theme$1, onHover, onSelect, onMultiSelect, darkMode, }) => {
    const selectedTheme = theme;
    const [selectedValues, setSelectedValues] = useState([]);
    const [placement, setPlacement] = useState(undefined);
    const dropdownRef = useRef(null);
    const toggleMultiSelectValues = (value) => {
        if (selectedValues.includes(value)) {
            setSelectedValues(selectedValues.filter((option) => option !== value));
        }
        else {
            setSelectedValues([...selectedValues, value]);
        }
    };
    useEffect(() => {
        onMultiSelect(selectedValues);
    }, [selectedValues]);
    useEffect(() => {
        if (menuPlacement === "auto") {
            if (open &&
                dropdownRef &&
                dropdownRef.current &&
                wrapperOffsetTop &&
                wrapperHeight) {
                const spaceAfterSelect = document.body.offsetHeight - wrapperOffsetTop - wrapperHeight;
                if (spaceAfterSelect < dropdownRef.current.offsetHeight) {
                    setPlacement("top");
                }
                else {
                    setPlacement("bottom");
                }
            }
            else
                setPlacement(undefined);
        }
        else
            setPlacement(menuPlacement);
    }, [open]);
    return (jsx(ThemeProvider, { theme: selectedTheme, children: jsx("div", { ref: dropdownRef, sx: {
                visibility: placement ? "visible" : "hidden",
                position: "absolute",
                zIndex: 1000,
                display: open ? "block" : "none",
                width: "100%",
                minWidth: width || "280px",
                marginTop: placement === "bottom" && "inc20",
                bottom: placement === "top" &&
                    wrapperHeight &&
                    wrapperHeight + pxToInt(selectedTheme.sizes.inc10),
                padding: "inc30",
                lineHeight: "inc00",
                fontSize: "inc20",
                color: darkMode
                    ? "black00"
                    : inverse
                        ? "text.inverse"
                        : "text.default",
                fontFamily: selectedTheme.fonts.body,
                bg: darkMode
                    ? "black70"
                    : inverse
                        ? "background.containerInverse"
                        : "background.body",
                border: `1px solid ${darkMode ? "black50" : selectedTheme.colors.input.default.border}`,
                borderRadius: "inc30",
                boxSizing: "border-box",
                boxShadow: "0px 3px 9px rgba(0, 0, 0, 0.15)",
            }, children: jsx("ul", { "data-testid": "options", role: "listbox", "aria-labelledby": id, sx: {
                    listStyleType: "none",
                    margin: 0,
                    padding: 0,
                }, children: options.map((option, index) => {
                    return variant === ESelectVariants.DEFAULT ? (jsx(Option, { option: option, inverse: inverse, theme: theme$1, hover: onHover, selected: onSelect, darkMode: darkMode }, index)) : (jsx(MultiSelectOption, { option: option, inverse: darkMode !== null && darkMode !== void 0 ? darkMode : inverse, values: selectedValues, hover: onHover, theme: theme$1, multiSelectItems: onMultiSelect, multiSelectToggle: toggleMultiSelectValues }, index));
                }) }) }) }));
};

const getColor$3 = (inverse, invalid) => {
    if (inverse) {
        return invalid ? "text.errorInverse" : "text.inverseSecondary";
    }
    return invalid ? "text.error" : "text.secondary";
};
const Helper$1 = ({ text, open, invalid, inverse, theme: theme$2, }) => {
    const selectedTheme = theme$2 === "legacy" ? theme : theme$1;
    return (jsx(ThemeProvider, { theme: selectedTheme, children: jsx("span", { sx: {
                visibility: open ? "hidden" : "visible",
                color: getColor$3(inverse, invalid),
                textTransform: "capitalize",
                fontFamily: selectedTheme.fonts.body,
                display: "block",
                marginTop: "inc20",
                fontSize: "inc10",
                lineHeight: "inc20",
            }, children: text }) }));
};

const Select = ({ id, name, options, className, theme: theme$2 = "default", disabled = false, helper, menuPlacement = "bottom", inverse = false, invalid = false, border = "default", value = undefined, width, onSelect, onOpen, variant = ESelectVariants.DEFAULT, ariaLabel, darkMode, }) => {
    var _a, _b;
    const idValue = id || (name === null || name === void 0 ? void 0 : name.toLowerCase().replace(/\s/g, ""));
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [hoverValue, setHoverValue] = useState(options[0]);
    const [selectedValue, setSelectedValue] = useState(value);
    const [multiSelectValues, setMultiSelectValues] = useState([]);
    const wrapperRef = useRef(null);
    useEffect(() => {
        if (selectedValue !== value) {
            setSelectedValue(value);
        }
    }, [value, selectedValue]);
    useEffect(() => {
        function handleClickOutside(event) {
            if (isDropdownOpen &&
                (wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) &&
                !(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current.contains(event.target))) {
                setIsDropdownOpen(false);
            }
        }
        if (isDropdownOpen) {
            document.addEventListener("click", handleClickOutside);
        }
        else {
            document.removeEventListener("click", handleClickOutside);
        }
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [wrapperRef, isDropdownOpen, setIsDropdownOpen]);
    const wrapperHeight = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight;
    const wrapperOffsetTop = (_b = wrapperRef.current) === null || _b === void 0 ? void 0 : _b.offsetTop;
    return (jsx(ThemeProvider, { theme: theme$2 === "legacy" ? theme : theme$1, children: jsxs("div", { ref: wrapperRef, className: className, sx: {
                width: width || "280px",
                display: "inline-block",
                position: "relative",
            }, onClick: () => {
                if (!disabled) {
                    if (!isDropdownOpen && onOpen)
                        onOpen();
                    setIsDropdownOpen(!isDropdownOpen);
                }
            }, children: [jsx(SelectButton, { id: idValue, open: isDropdownOpen, variant: variant, hoverValue: hoverValue, value: selectedValue, multiSelectValues: multiSelectValues, border: border, disabled: disabled, width: width, inverse: inverse, darkMode: darkMode, invalid: invalid, theme: theme$2, ariaLabel: ariaLabel, children: name }), jsx(Dropdown, { id: idValue, options: options, menuPlacement: menuPlacement, wrapperHeight: wrapperHeight, wrapperOffsetTop: wrapperOffsetTop, open: isDropdownOpen, width: width, variant: variant, inverse: inverse, theme: theme$2, onHover: setHoverValue, darkMode: darkMode, onSelect: (value) => {
                        setSelectedValue(value);
                        setIsDropdownOpen(!isDropdownOpen);
                        if (onSelect) {
                            onSelect(value);
                        }
                    }, onMultiSelect: setMultiSelectValues }), helper && (jsx(Helper$1, { text: helper, open: isDropdownOpen, invalid: invalid, inverse: inverse, theme: theme$2 }))] }) }));
};

const getColor$2 = (invalid, disabled, inverse) => {
    if (inverse) {
        if (invalid) {
            return "input.inverse.textError";
        }
        return disabled ? "input.inverse.textSecondary" : "input.inverse.text";
    }
    if (invalid) {
        return "input.default.textError";
    }
    return disabled ? "text.neutral" : "input.default.text";
};
const getVariantStyles$1 = ({ invalid = false, disabled = false, inverse = false, darkMode = false, }) => {
    if (darkMode) {
        return {
            bg: "background.selectedInverseLighter",
            borderColor: "input.inverse.border",
            color: "input.inverse.text",
        };
    }
    if (inverse) {
        return {
            bg: disabled ? "input.inverse.bgDisabled" : "input.inverse.bg",
            borderColor: invalid
                ? "input.inverse.borderError"
                : "input.inverse.border",
            color: getColor$2(invalid, disabled, true),
        };
    }
    return {
        bg: disabled ? "input.default.bgDisabled" : "input.default.bg",
        borderColor: invalid ? "input.default.borderError" : "input.default.border",
        color: getColor$2(invalid, disabled),
    };
};
const Input = forwardRef(({ id, theme: theme$1, name, value, placeholder, className, invalid, disabled, inverse, darkMode, onFocus, onBlur, onChange, }, ref) => {
    const inputHTMLAttributes = {
        id,
        placeholder,
        className,
        disabled,
        name,
        value,
        onFocus,
        onChange,
        onBlur,
    };
    return (jsx(ThemeProvider, { theme: theme, children: jsx("input", { ref: ref, type: "text", ...inputHTMLAttributes, sx: {
                // we need these because we need token values in calculations
                "--input-padding": (theme) => (theme.space || {})["inc30"],
                "--invalid-input-padding": (theme) => (theme.space || {})["inc70"],
                "--border-width": (theme) => (theme.borderWidths || {})["inc10"],
                "&": {
                    cursor: disabled ? "not-allowed" : "default",
                    outline: "none",
                    fontSize: "inc20",
                    fontFamily: "body",
                    fontWeight: "300",
                    lineHeight: "inc00",
                    borderRadius: "input",
                    borderStyle: "solid",
                    borderWidth: "inc10",
                    boxSizing: "border-box",
                    height: "inc50",
                    py: "calc(var(--input-padding) - var(--border-width))",
                    paddingLeft: "calc(var(--input-padding) - var(--border-width))",
                    paddingRight: `calc(var(--${invalid ? "invalid-input-padding" : "input-padding"}) - var(--border-width))`,
                },
                "&::placeholder": {
                    fontWeight: "300",
                    color: inverse || darkMode
                        ? "input.inverse.text"
                        : "input.default.text",
                },
                ...getVariantStyles$1({ invalid, disabled, inverse, darkMode }),
            } }) }));
});
Input.displayName = "Input";

const getColor$1 = (small, invalid, disabled, inverse) => {
    if (inverse) {
        if (small) {
            return "input.inverse.textSecondary";
        }
        if (disabled) {
            return "input.inverse.textSecondary";
        }
        return invalid ? "input.inverse.textError" : "input.inverse.text";
    }
    if (small) {
        return "input.default.textSecondary";
    }
    if (disabled) {
        return "text.neutral";
    }
    return invalid ? "input.default.textError" : "input.default.text";
};
const getVariantStyles = ({ inverse, disabled, invalid = false, small = false, }) => {
    if (inverse) {
        return {
            color: getColor$1(small, invalid, disabled, true),
            "::before": {
                bg: disabled ? "input.inverse.bgDisabled" : "input.inverse.bg",
            },
        };
    }
    return {
        color: getColor$1(small, invalid, disabled),
        "::before": {
            bg: disabled ? "input.default.bgDisabled" : "input.default.bg",
        },
    };
};
const Label = ({ children, small, invalid, inverse, disabled, htmlFor, }) => {
    const { color, "::before": before } = getVariantStyles({
        inverse,
        disabled,
        invalid,
        small,
    });
    return (jsx("label", { htmlFor: htmlFor, sx: {
            "--translate-x": (theme = {}) => small ? (theme.space || {})["inc20"] : (theme.space || {})["inc30"],
            "--max-width": (theme = {}) => small ? (theme.space || {})["inc40"] : (theme.space || {})["inc50"],
            zIndex: "0",
            pointerEvents: small ? null : "none",
            textTransform: "capitalize",
            cursor: disabled ? "not-allowed" : "default",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            paddingLeft: small ? "inc20" : 0,
            paddingRight: small ? "inc20" : "inc30",
            position: "absolute",
            willChange: "transform, color, font-size",
            maxWidth: "calc(100% - var(--max-width))",
            transform: `translateY(${small ? "-7px" : "15px"}) translateX(var(--translate-x))`,
            transition: "transform 200ms cubic-bezier(0.25, 0.1, 0.25, 1) 0ms, color 200ms cubic-bezier(0.25, 0.1, 0.25, 1) 0ms, font-size 200ms cubic-bezier(0.25, 0.1, 0.25, 1) 0ms",
            fontSize: small ? "inc00" : "inc20",
            fontFamily: "body",
            "::before": {
                content: "''",
                position: "absolute",
                zIndex: "-1",
                width: "100%",
                height: small ? "1px" : "0px",
                bottom: "6px",
                left: 0,
                ...before,
            },
            color,
        }, children: children }));
};

const X = ({ inverse }) => (jsxs("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", sx: {
        position: "absolute",
        transform: "translateY(17px) translateX(-32px)",
        stroke: inverse ? "icon.errorInverse" : "icon.error",
    }, children: [jsx("path", { d: "M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z" }), jsx("path", { d: "M10.0454 5.77875L5.77875 10.0454", strokeLinecap: "round", strokeLinejoin: "round" }), jsx("path", { d: "M5.77875 5.77875L10.0454 10.0454", strokeLinecap: "round", strokeLinejoin: "round" })] }));

const getColor = (inverse, invalid) => {
    if (inverse) {
        return invalid ? "text.errorInverse" : "text.inverseSecondary";
    }
    return invalid ? "text.error" : "text.secondary";
};
const Helper = ({ inverse = false, invalid = false, children, }) => (jsx("span", { sx: {
        color: getColor(inverse, invalid),
        textTransform: "capitalize",
        fontFamily: "body",
        display: "block",
        marginTop: "inc20",
        fontSize: "inc10",
        lineHeight: "inc20",
    }, children: children }));

const handleScrollPaddingTopFix = (focused = false) => {
    if (!focused) {
        document.documentElement.style["scroll-padding-top"] = "";
    }
    else if (focused) {
        document.documentElement.style["scroll-padding-top"] =
            "0px";
    }
};
const TextInput = forwardRef(({ inverse = false, theme: theme$2 = "default", id, darkMode, onChange, ...props }, ref) => {
    var _a;
    const [isFocused, setIsFocused] = useState(false);
    const [value, setValue] = useState(props.value);
    const idValue = id || ((_a = props.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().replace(/\s/g, ""));
    useEffect(() => {
        // to fix page scrolling issue on key press - WEBSITE-17145
        handleScrollPaddingTopFix(isFocused);
    }, [isFocused]);
    return (jsx(ThemeProvider, { theme: theme$2 === "legacy" ? theme : theme$1, children: jsxs("div", { sx: {
                display: "inline-block",
                position: "relative",
                ...props.wrapperStyles,
            }, children: [!props.placeholder && props.name && (jsx(Label, { htmlFor: idValue, disabled: props.disabled, small: isFocused || !!value, inverse: inverse, invalid: props.invalid, children: props.name })), jsx(Input, { ref: ref, id: idValue, inverse: inverse, placeholder: props.placeholder, sx: props.inputStyles, ...props, onChange: (e) => {
                        setValue(e.target.value);
                        if (onChange)
                            onChange(e);
                    }, onFocus: () => setIsFocused(true), onBlur: () => setIsFocused(false), theme: theme$2, darkMode: darkMode }), props.invalid && jsx(X, { inverse: inverse }), props.helper && (jsx(Helper, { invalid: props.invalid, inverse: inverse, children: props.helper }))] }) }));
});
TextInput.displayName = "TextInput";

var ENavLinkVariant;
(function (ENavLinkVariant) {
    ENavLinkVariant["HEADER"] = "header";
    ENavLinkVariant["SUBHEADER"] = "subheader";
})(ENavLinkVariant || (ENavLinkVariant = {}));

const getSearchURL = (property, options, docsBaseUrl) => {
    var _a;
    const optionKey = (_a = options.find((el) => el.value === property)) === null || _a === void 0 ? void 0 : _a.universalKey;
    const docsSearchUrl = `https://mongodb.com/docs/search/`;
    switch (optionKey) {
        case "DOTCOM":
            return `https://www.mongodb.com/search`;
        case "BLOG":
            return `https://www.mongodb.com/blog/search`;
        case "DOCS":
            return standardizeDocsUrl(docsSearchUrl, docsBaseUrl);
        case "REALM":
            return standardizeDocsUrl(docsSearchUrl, docsBaseUrl);
        case "DEVHUB":
            return `https://developer.mongodb.com/learn#main`;
        case "COMMUNITY":
            return `https://www.mongodb.com/community/forums/search`;
        case "UNIVERSITY":
            return `https://learn.mongodb.com/catalog`;
        default:
            return `https://www.mongodb.com/search`;
    }
};
const getQueryStrings = (property, query, options, searchParams) => {
    var _a;
    const optionKey = (_a = options.find((el) => el.value === property)) === null || _a === void 0 ? void 0 : _a.universalKey;
    let queryStrings = [];
    switch (optionKey) {
        case "DOTCOM":
            queryStrings = [{ param: "addsearch", value: query }];
            return [{ param: "addsearch", value: query }];
        case "BLOG":
            queryStrings = [{ param: undefined, value: query }];
            break;
        case "DOCS":
            queryStrings = [{ param: "q", value: query }];
            break;
        case "REALM":
            queryStrings = [
                { param: "q", value: query },
                { param: "searchProperty", value: "realm-master" },
            ];
            break;
        case "DEVHUB":
            queryStrings = [
                { param: "text", value: query },
                { param: `content`, value: "Articles" },
            ];
            break;
        case "COMMUNITY":
            queryStrings = [{ param: "q", value: query }];
            break;
        case "UNIVERSITY":
            queryStrings = [{ param: "query", value: query }];
            break;
        default:
            queryStrings = [{ param: "addsearch", value: query }];
    }
    // Prevent a property from overriding parameters specified within queryStrings.
    // Hardcoded queryStrings params are critical for expected site behavior.
    const uniqueParams = searchParams
        ? searchParams.filter((item) => !queryStrings.some((e) => e.param === item.param))
        : [];
    return [...queryStrings, ...uniqueParams];
};
const getPlaceholderText = (selectedProperty, options) => {
    var _a;
    return (_a = options.find((el) => el.value === selectedProperty)) === null || _a === void 0 ? void 0 : _a.placeholder;
};
const metadataParams = (name, property) => {
    const mappedName = getOptionUniversalKey(name);
    return mappedName === (property === null || property === void 0 ? void 0 : property.name) && (property === null || property === void 0 ? void 0 : property.name)
        ? property.searchParams
        : [];
};

function debounce(func, timeout = 600) {
    let timer;
    const debounced = (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func(...args);
        }, timeout);
    };
    debounced.cancel = () => {
        clearTimeout(timer);
    };
    return debounced;
}

const COMMON_NAVIGATION_TRACKING_PROPS = {
    category: "navigation",
};
const COMMON_FOOTER_TRACKING_PROPS = {
    category: "navigation footer",
};
var ETrackingEvents;
(function (ETrackingEvents) {
    ETrackingEvents["DROPDOWN_APPEARS"] = "Dropdown Appears";
    ETrackingEvents["LINK_CLICK"] = "Internal Click";
    ETrackingEvents["MOUSE_HOVER"] = "Mouse Hover";
    ETrackingEvents["SEARCH"] = "Search";
})(ETrackingEvents || (ETrackingEvents = {}));
const NAV_HEIGHT = "95px";

const localeMap = {
    English: "en-us",
    Português: "pt-br",
    Español: "es",
    한국어: "ko-kr",
    日本語: "ja-jp",
    Italiano: "it-it",
    Deutsch: "de-de",
    Français: "fr-fr",
    简体中文: "zh-cn",
};

const mdbTrack = (name, properties) => {
    var _a;
    if (window === null || window === void 0 ? void 0 : window.mdbTrack) {
        try {
            window.mdbTrack(name, { ...properties, url: (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href });
        }
        catch (e) {
            console.log(e, "mdbTrack");
        }
    }
};
// Function to generate the localeMap object based on the availableLocales array
const generateLocaleMap = (locales) => {
    return Object.entries(localeMap).reduce((acc, [key, value]) => {
        if (locales.includes(value)) {
            acc[key] = value;
        }
        return acc;
    }, {});
};
const generateUniqueKeys = (data) => {
    if (Array.isArray(data)) {
        return data.map((item) => {
            if (typeof item === "object" && item !== null) {
                // Add uniqueKey to each array item and recursively process its properties
                return generateUniqueKeys({
                    ...item,
                    uniqueKey: Math.random().toString(36).substr(2, 9),
                });
            }
            return item;
        });
    }
    else if (typeof data === "object" && data !== null) {
        const newObj = { ...data };
        for (const key in newObj) {
            if (Object.prototype.hasOwnProperty.call(newObj, key)) {
                // Recursively process each property
                newObj[key] = generateUniqueKeys(newObj[key]);
            }
        }
        return newObj;
    }
    return data;
};

const ButtonWrapper = ({ tabIndex, theme, variant, href, customWrapperStyles, customStyles, onMouseEnter, onClick, inverse, sx, target, type, children, className, }) => {
    return (jsx(ThemeProvider, { theme: theme$1, children: jsx(Button, { tabIndex: tabIndex, theme: theme, variant: variant, target: target, href: href, sx: sx, customWrapperStyles: customWrapperStyles, customStyles: customStyles, onMouseEnter: onMouseEnter, onClick: onClick, inverse: inverse, type: type, className: className, children: children }) }));
};

const NavSearch = forwardRef(({ className, content, animating, visible, property, floraTheme, docsBaseUrl, darkMode, }, ref) => {
    var _a;
    const options = content.secondary.search.options;
    const optionsArray = options.map((el) => el.value);
    const defaultOption = ((_a = options.find((el) => el.universalKey === (property === null || property === void 0 ? void 0 : property.name))) === null || _a === void 0 ? void 0 : _a.value) ||
        optionsArray[0];
    const [selectedProperty, setSelectedProperty] = useState(defaultOption);
    const [query, setQuery] = useState("");
    const inputRef = useRef(null);
    const boxRef = useRef(null);
    useImperativeHandle(ref, () => ({
        addEventListener: (type, listener, options) => {
            var _a;
            (_a = boxRef === null || boxRef === void 0 ? void 0 : boxRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener(type, listener, options);
        },
        focus: () => {
            setTimeout(() => {
                var _a;
                const originalScroll = window.scrollY;
                (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                window.scrollTo(0, originalScroll);
            }, 100);
        },
    }), []);
    useEffect(() => {
        setSelectedProperty(defaultOption);
    }, [content]);
    const handlePropertySelection = (value) => {
        mdbTrack(ETrackingEvents.SEARCH, {
            ...COMMON_NAVIGATION_TRACKING_PROPS,
            title: "Select Search Domain",
            text: value,
        });
        setSelectedProperty(value);
    };
    const startTyping = debounce((func, value) => {
        if (typeof func === "function")
            func(value);
    });
    const trackTyping = (query) => {
        mdbTrack(ETrackingEvents.SEARCH, {
            ...COMMON_NAVIGATION_TRACKING_PROPS,
            title: "Typing Search",
            query: query,
        });
    };
    const handleInputChange = useCallback((e) => {
        setQuery(e.currentTarget.value);
        startTyping(trackTyping, e.currentTarget.value);
    }, []);
    const selectedTheme = floraTheme === "legacy" ? theme : theme$1;
    return (jsxs(ThemeProvider, { theme: selectedTheme, children: [jsx(Box, { sx: {
                    backgroundColor: darkMode ? "blue80" : "black00",
                    opacity: visible ? "0.5" : "0",
                    transition: `opacity ${selectedTheme.motion.inc20}`,
                    width: "100%",
                    height: NAV_HEIGHT,
                    position: "absolute",
                    left: "0",
                    zIndex: !visible && !animating ? "-1" : "1",
                    top: "0",
                } }), jsx(Box, { sx: {
                    position: !visible && !animating ? "absolute" : "relative",
                    visibility: !visible && !animating ? "hidden" : "visible",
                    zIndex: !visible && !animating ? "-1" : "999",
                }, children: jsx("form", { role: "search", method: "GET", action: selectedProperty === "Blog"
                        ? getSearchURL(selectedProperty, options, docsBaseUrl) +
                            "/" +
                            query
                        : getSearchURL(selectedProperty, options, docsBaseUrl), className: className, onSubmit: () => {
                        mdbTrack(ETrackingEvents.SEARCH, {
                            ...COMMON_NAVIGATION_TRACKING_PROPS,
                            title: "Submit Search",
                            query,
                        });
                    }, sx: {
                        position: "relative",
                        width: "90%",
                        top: 0,
                        height: NAV_HEIGHT,
                        display: ["none", null, null, "flex"],
                        alignItems: "center",
                        paddingLeft: "inc30",
                        paddingRight: "inc40",
                    }, children: jsxs(Box, { sx: {
                            zIndex: "2",
                            marginTop: visible ? "1px" : "-500px",
                            transition: `margin-top ${selectedTheme.motion.inc20}`,
                            width: "100%",
                            display: "grid",
                            gridTemplateColumns: "3fr 1fr",
                            gridGap: "inc20",
                            paddingRight: "inc40",
                        }, ref: boxRef, children: [jsx(TextInput, { ref: inputRef, theme: "legacy", placeholder: getPlaceholderText(selectedProperty, options), inputStyles: { width: "100%" }, wrapperStyles: { width: "100%", zIndex: "2" }, value: query, onChange: handleInputChange, darkMode: darkMode }), jsxs(Box, { sx: { display: "flex", minWidth: "298px", zIndex: "2" }, children: [jsx(Select, { theme: "legacy", value: selectedProperty, onSelect: handlePropertySelection, width: "250px", inverse: false, invalid: false, variant: "default", options: optionsArray, darkMode: darkMode, onOpen: () => {
                                            mdbTrack(ETrackingEvents.SEARCH, {
                                                ...COMMON_NAVIGATION_TRACKING_PROPS,
                                                title: "Open Search Domain Selector",
                                            });
                                        } }, `navbar-property-select-${selectedProperty}`), getQueryStrings(selectedProperty, query, options, metadataParams(selectedProperty, property)).map((querystring) => querystring.param && (jsx("input", { type: "hidden", id: querystring.param, name: querystring.param, value: querystring.value }, `navsearch-form-${querystring.param}`))), jsx(ButtonWrapper, { variant: "secondary", inverse: darkMode, "aria-label": "Submit Search", customStyles: {
                                            padding: "14px 14px",
                                            marginLeft: "inc10",
                                        }, theme: "default", type: "submit", children: jsx("img", { sx: { maxWidth: "unset" }, alt: "search icon", src: darkMode
                                                ? "https://webimages.mongodb.com/_com_assets/cms/m0450tuy7vyyl4gcn-search_updated_black.svg?auto=format%252Ccompress"
                                                : "https://webimages.mongodb.com/_com_assets/cms/lyj1z1iiimsre0lsz-search_updated_white.svg?auto=format%252Ccompress", width: "18", height: "18" }) })] })] }) }) })] }));
});
NavSearch.displayName = "NavSearch";

const mainLinkStyles = {
    px: "8px",
    py: "10px",
    marginLeft: "-8px",
    display: "inline-flex",
    borderRadius: "8px",
    lineHeight: "16px",
    transition: "background 0.3s ease-out",
    marginBottom: ["4px", null, null, "12px"],
    "& .menu-title": {
        fontSize: ["14px", null, null, "16px"],
        lineHeight: ["14px", null, null, "16px"],
    },
};
const hoverStyles = {
    borderBottom: 0,
    textDecoration: "none",
};
const imageStyles$1 = {
    width: "32px",
    height: "32px",
    marginRight: "12px",
};
const descriptionStyles$1 = (darkMode) => ({
    display: "inline-block",
    fontSize: ["12px", null, null, "14px"],
    lineHeight: ["15px", null, null, "18px"],
    fontWeight: "400",
    color: darkMode ? "black30" : "black50",
    mt: "4px",
});
const MenuItem = ({ href, onClick, target = "_self", title, description, isHelper, brandedIconName, darkMode, }) => {
    const linkContentStyles = {
        fontWeight: "500",
        color: darkMode ? "black00" : "blue80",
        lineHeight: "16px",
        alignItems: brandedIconName && description ? "flex-start" : "center",
        ...hoverStyles,
        "&:hover": hoverStyles,
    };
    return (jsxs(Link, { customLinkContentStyles: linkContentStyles, sx: {
            ...mainLinkStyles,
            marginRight: isHelper ? "-8px" : undefined,
            "&:hover": { background: darkMode ? "black80" : "black10" },
        }, target: target, href: href, onClick: () => {
            if (href) {
                mdbTrack(ETrackingEvents.LINK_CLICK, {
                    ...COMMON_NAVIGATION_TRACKING_PROPS,
                    title,
                    href,
                    label: title,
                });
            }
            onClick === null || onClick === void 0 ? void 0 : onClick();
        }, children: [brandedIconName && (jsx(BrandedIcon, { name: brandedIconName, customStyles: imageStyles$1, inverse: darkMode })), jsx(ContentWrapper, { title: title, description: description, darkMode: darkMode })] }));
};
const ContentWrapper = ({ title, description, darkMode }) => (jsxs("span", { sx: {
        display: "flex",
        flexDirection: "column",
    }, children: [jsx("span", { className: "menu-title", children: title }), description && jsx("span", { sx: descriptionStyles$1(darkMode), children: description })] }));

const imageStyles = {
    width: "32px",
    height: "32px",
    marginRight: "12px",
};
const MenuFooterSectionItem = ({ href, onClick, target = "_self", title, description, isMobile, brandedIconName, darkMode, }) => {
    return (jsx("div", { sx: {
            width: "100%",
        }, children: jsxs(Link, { customStyles: {
                width: "100%",
            }, customLinkContentStyles: {
                borderBottom: 0,
                textDecoration: "none",
                fontWeight: "500",
                fontSize: "14px",
                lineHeight: "14px",
                alignItems: "center",
                justifyContent: "space-between",
                color: darkMode ? "black00" : "black70",
                width: "100%",
                "&:hover": {
                    borderBottom: 0,
                    textDecoration: "none",
                },
            }, sx: {
                pl: isMobile ? 0 : "32px",
                pr: isMobile ? 0 : "16px",
                py: "16px",
                borderTop: isMobile
                    ? "0px"
                    : `1px solid ${darkMode ? theme$1.colors.black50 : theme$1.colors.black20}`,
                display: "flex",
                width: "100%",
                boxSizing: "border-box",
                lineHeight: "14px",
                transition: "background 0.3s ease-out",
                "& > span": {
                    width: "100%",
                },
                "&:hover": {
                    background: darkMode ? "black80" : "black10",
                    "& svg": {
                        opacity: "1",
                    },
                },
                "& .menu-main": {},
                "& .menu-title": {
                    display: "inline-block",
                },
                "& .menu-description": {
                    display: "inline-block",
                    fontSize: "12px",
                    fontWeight: "400",
                    color: darkMode ? "black30" : "black50",
                    lineHeight: "15px",
                    mt: "4px",
                },
                "& svg": {
                    stroke: darkMode ? "blue50" : "blue60",
                    opacity: "0",
                    transition: "opacity 0.3s ease-out",
                },
            }, target: target, href: href, onClick: () => {
                if (href) {
                    mdbTrack(ETrackingEvents.LINK_CLICK, {
                        ...COMMON_NAVIGATION_TRACKING_PROPS,
                        title,
                        href,
                        label: title,
                    });
                }
                onClick === null || onClick === void 0 ? void 0 : onClick();
            }, children: [jsxs("span", { sx: { display: "flex", alignItems: "center" }, children: [brandedIconName && (jsx(BrandedIcon, { size: "small", name: brandedIconName, customStyles: imageStyles, inverse: darkMode })), jsxs("span", { sx: { display: "flex", flexDirection: "column" }, children: [jsx("span", { className: "menu-title", children: title }), description && (jsx("span", { className: "menu-description", children: description }))] })] }), jsx(SystemIcon, { size: "small", name: ESystemIconNames.ARROW_RIGHT })] }) }));
};

const subSectionStyles = {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    pb: "10px",
};
const titleStyles$1 = (darkMode) => ({
    fontSize: "12px",
    lineHeight: "12px",
    minHeight: "12px",
    fontWeight: "600",
    color: darkMode ? "black30" : "black60",
    mb: "14px",
    textTransform: "uppercase",
});
const SubSection = ({ title, list, isHelper, isMobile, darkMode, }) => {
    const _title = isMobile && title ? title.trim() : title;
    return (jsxs("div", { sx: { ...subSectionStyles, mt: !_title ? "-10px" : undefined }, children: [_title && jsx("div", { sx: titleStyles$1(darkMode), children: _title }), list === null || list === void 0 ? void 0 : list.map((item) => (jsx(MenuItem, { isHelper: isHelper, darkMode: darkMode, ...item }, item.uniqueKey)))] }));
};

const titleStyles = {
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "12px",
};
const descriptionStyles = {
    fontWeight: "400",
    fontSize: "12px",
    mt: "8px",
};
const buttonLinkStyles = {
    fontSize: "12px",
    lineHeight: "12px",
    width: "100%",
    border: `1px solid ${theme$1.colors.black30}`,
    py: "7px",
    borderRadius: "999px",
    transition: "background 0.2s ease-in, border 0.2s ease-in",
    display: "flex",
    justifyContent: "center",
    "&:hover": {
        borderColor: "blue60",
        color: "black00",
        background: "blue60",
    },
};
const arrowLinkStyles = {
    fontSize: "12px",
    lineHeight: "12px",
    color: "blue60",
    width: "100%",
    "& svg": {
        transition: "transform 0.2s",
    },
    "&:hover": {
        "& svg": {
            transform: "translateX(8px)",
        },
    },
};
const HelperSectionItem = ({ href, onClick, target = "_self", label, title, description, isButtonType = false, isMobile = false, darkMode, }) => {
    return (jsxs("div", { sx: {
            width: "100%",
            boxSizing: "border-box",
            flex: "1",
            p: "24px",
            pb: "18px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
        }, className: "helper-section-item", children: [jsx("div", { sx: {
                    ...titleStyles,
                    color: darkMode ? "black00" : "black70",
                }, children: title }), description && (jsx("div", { sx: {
                    ...descriptionStyles,
                    color: darkMode ? "black30" : "black50",
                    lineHeight: isButtonType && !isMobile ? "18px" : "15px",
                }, children: description })), jsx("div", { sx: { mt: "16px", display: "flex" }, children: isButtonType && !isMobile ? (jsx(ButtonLink, { ...{ href, onClick, target, label, darkMode } })) : (jsx(ArrowLink, { ...{ href, onClick, target, label, darkMode } })) })] }));
};
const ButtonLink = ({ href, onClick, target, label, darkMode, }) => (jsx(Link, { sx: {
        ...buttonLinkStyles,
        color: darkMode ? "blue50" : "blue60",
        "&:hover": {
            borderColor: darkMode ? "blue50" : "blue60",
            color: "black00",
            background: darkMode ? "blue50" : "blue60",
        },
    }, customLinkContentStyles: {
        fontSize: "12px",
        lineHeight: "16px",
        fontWeight: "500",
        color: "inherit",
        borderBottom: 0,
        transition: "color 0.2s ease-in",
        "&:hover": {
            borderBottom: 0,
        },
    }, href: href, onClick: () => {
        if (href) {
            mdbTrack(ETrackingEvents.LINK_CLICK, {
                ...COMMON_NAVIGATION_TRACKING_PROPS,
                title: label,
                href,
                label,
            });
        }
        onClick === null || onClick === void 0 ? void 0 : onClick();
    }, target: target, children: label }));
const ArrowLink = ({ href, onClick, target, label, darkMode, }) => (jsxs(Link, { sx: arrowLinkStyles, customLinkContentStyles: {
        fontSize: "12px",
        lineHeight: "12px",
        fontWeight: "500",
        color: darkMode ? "blue50" : "blue60",
        borderBottom: 0,
        width: ["auto", null, null, "100%"],
        justifyContent: "space-between",
        "&:hover": {
            borderBottom: 0,
        },
        "& svg": {
            stroke: darkMode ? "blue50" : "blue60",
            marginLeft: "8px",
        },
    }, href: href, onClick: () => {
        if (href) {
            mdbTrack(ETrackingEvents.LINK_CLICK, {
                ...COMMON_NAVIGATION_TRACKING_PROPS,
                title: label,
                href,
                label,
            });
        }
        onClick === null || onClick === void 0 ? void 0 : onClick();
    }, target: target, children: [label, jsx(SystemIcon, { name: ESystemIconNames.ARROW_RIGHT, size: "small" })] }));

const subSectionOverrideStyles = {
    maxWidth: ["100%", null, null, "320px"],
    pt: ["0px", null, null, "inc50"],
    px: ["0px", null, null, "inc40"],
    boxSizing: "border-box",
};
const HelperSection = ({ helperContent, isMobile = false, darkMode, }) => {
    var _a, _b, _c, _d;
    return (jsx("div", { sx: {
            display: "flex",
            borderLeft: isMobile
                ? "0px"
                : `6px solid ${darkMode ? theme$1.colors.black50 : theme$1.colors.black15}`,
            ...(isMobile && ((_a = helperContent.helperSectionItems) === null || _a === void 0 ? void 0 : _a.length)
                ? {
                    background: darkMode ? "blue80" : "black00",
                    mt: isMobile ? "8px" : undefined,
                    pb: "24px",
                    mb: "-24px",
                }
                : {}),
        }, children: jsxs("div", { sx: {
                display: "flex",
                flexDirection: "column",
                alignItems: isMobile ? "flex-start" : "center",
                justifyContent: "center",
                minWidth: "208px",
                maxWidth: "208px",
                ...(((_b = helperContent.subSections) === null || _b === void 0 ? void 0 : _b.length)
                    ? subSectionOverrideStyles
                    : {}),
                ...(isMobile
                    ? {
                        minWidth: "100%",
                        maxWidth: "100%",
                    }
                    : {}),
                "& > .helper-section-item": {
                    borderBottom: isMobile
                        ? "0px"
                        : `6px solid ${darkMode ? theme$1.colors.black50 : theme$1.colors.black15}`,
                    borderTop: isMobile
                        ? `6px solid ${darkMode ? theme$1.colors.black50 : theme$1.colors.black15}`
                        : "0px",
                    "&:last-of-type": {
                        borderBottom: 0,
                        pb: "24px",
                    },
                },
            }, children: [(_c = helperContent.helperSectionItems) === null || _c === void 0 ? void 0 : _c.filter((r) => !(isMobile && r.onlyDesktop)).map((helperSectionItem) => (jsx(HelperSectionItem, { isMobile: isMobile, darkMode: darkMode, ...helperSectionItem }, helperSectionItem.uniqueKey))), (_d = helperContent.subSections) === null || _d === void 0 ? void 0 : _d.map((subSection) => (jsx(SubSection, { title: subSection.title, list: subSection.menuItems, isHelper: !isMobile, darkMode: darkMode }, subSection.uniqueKey)))] }) }));
};

const leftSideStyles = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
};
const mainSectionStyles = {
    display: "flex",
    pl: "inc50",
    pr: "inc30",
    pt: "inc50",
};
const fadeIn$4 = keyframes `
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const fadeOut$4 = keyframes `
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
const getColumnWidth = (size = "medium") => {
    switch (size) {
        case "large":
            return "344px";
        case "medium":
            return "216px";
        case "small":
            return "192px";
    }
    return "216px";
};
const NavDropdown = ({ content, hidden = true, darkMode, }) => {
    const dropdownRef = useRef(null);
    const [isMounted, setIsMounted] = useState(false);
    const calculateLeftPosition = () => {
        const dropdownElement = dropdownRef.current;
        const parentElement = dropdownElement === null || dropdownElement === void 0 ? void 0 : dropdownElement.closest(".header-nav-menu-item");
        if (dropdownElement && parentElement) {
            const parentRect = parentElement.getBoundingClientRect();
            const bodyRect = document.body.getBoundingClientRect();
            const dropdownWidth = dropdownElement.offsetWidth; // dropdown width in px
            let leftPosition = parentRect.left + parentRect.width / 2 - dropdownWidth / 2;
            // Ensuring the dropdown doesn't go beyond the body boundaries
            if (leftPosition < 32) {
                leftPosition = 32;
            }
            else if (leftPosition + dropdownWidth > bodyRect.right) {
                leftPosition = bodyRect.right - dropdownWidth;
            }
            dropdownElement.style.left = `${leftPosition + 2}px`;
        }
    };
    useEffect(() => {
        let timeout;
        if (!hidden) {
            calculateLeftPosition();
            setIsMounted(true);
        }
        else {
            timeout = setTimeout(() => {
                setIsMounted(false);
            }, 200); // 200ms is the duration of your fade-out animation
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [hidden]);
    return (jsx("div", { ref: dropdownRef, sx: {
            borderRadius: "16px",
            boxShadow: "0px 3px 20px 0px rgba(0, 0, 0, 0.15)",
            position: "absolute",
            overflowY: "auto",
            overflowX: "hidden",
            scrollbarWidth: "thin",
            maxHeight: "calc(100vh - 88px)",
            maxWidth: "calc(100% - 34px)",
            top: "100%",
            left: "34px",
            marginTop: "-8px",
            background: darkMode ? "black70" : "black00",
            animation: `${!hidden ? fadeIn$4 : fadeOut$4} 0.2s ease-in-out forwards`,
            visibility: isMounted ? "visible" : "hidden",
            userSelect: isMounted ? undefined : "none",
            pointerEvents: isMounted ? undefined : "none",
        }, onClick: (e) => e.stopPropagation(), children: jsxs("div", { sx: {
                display: "flex",
                flexDirection: "row",
            }, children: [jsxs("div", { sx: leftSideStyles, children: [jsx("div", { sx: mainSectionStyles, children: content.mainSection.columns.map((col, i) => (jsx("div", { sx: {
                                    width: getColumnWidth(col.size),
                                    maxWidth: getColumnWidth(col.size),
                                    marginRight: i === 0
                                        ? col.size === "large"
                                            ? "40px"
                                            : "32px"
                                        : col.size !== "large"
                                            ? "10px"
                                            : undefined,
                                }, children: col.subSections.map((subSection) => (jsx(SubSection, { title: subSection.title, list: subSection.menuItems, darkMode: darkMode }, subSection.uniqueKey))) }, `column-${i}-${col.uniqueKey}`))) }), jsxs("div", { sx: {
                                display: "flex",
                                "& > div + div": {
                                    borderLeft: `1px solid ${darkMode ? theme$1.colors.black50 : theme$1.colors.black20}`,
                                },
                            }, children: [content.footerSection ? (jsx(MenuFooterSectionItem, { ...content.footerSection, darkMode: darkMode })) : null, content.footerAdditionalSection ? (jsx(MenuFooterSectionItem, { ...content.footerAdditionalSection, darkMode: darkMode })) : null] })] }), content.helperSection ? (jsx(HelperSection, { helperContent: content.helperSection, darkMode: darkMode })) : null] }) }));
};

const LanguageSelector = ({ ...props }) => {
    const { open, value, shrink, isMenuItem, onClick, darkMode } = props;
    const selectedTheme = theme$1;
    const renderValue = useMemo(() => {
        if (shrink && value) {
            if (value.length > 4) {
                return value.slice(0, 3);
            }
        }
        return value;
    }, [shrink, value]);
    return (jsx(ThemeProvider, { theme: selectedTheme, children: jsxs("button", { role: "button", type: "button", sx: {
                position: "relative",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                boxSizing: "border-box",
                cursor: "pointer",
                fontWeight: "300",
                padding: "0",
                bg: "transparent",
                border: "none",
                "&:hover": {
                    span: {
                        color: darkMode ? "blue50" : "green60",
                    },
                    svg: {
                        stroke: darkMode ? "blue50" : "green60",
                    },
                    img: {
                        ...(!darkMode && {
                            filter: "brightness(0) saturate(100%) invert(25%) sepia(98%) saturate(632%) hue-rotate(121deg) brightness(95%) contrast(101%)",
                        }),
                    },
                },
            }, onClick: onClick, children: [jsx("img", { src: darkMode
                        ? "https://webimages.mongodb.com/_com_assets/cms/lzsle5raf6v32fw36-language-selector-globe-dark-mode.svg?auto=format%252Ccompress"
                        : "https://webimages.mongodb.com/_com_assets/cms/lvz91dv3bugodsyau-language-selector-globe.svg?auto=format%252Ccompress", width: "16", height: "16", alt: "Language Selector Icon", style: {
                        height: "auto",
                        ...(isMenuItem
                            ? { marginTop: "1px", marginBottom: "-1px" }
                            : undefined),
                    } }), jsx("span", { sx: {
                        fontFamily: selectedTheme.fonts.body,
                        fontSize: "inc20",
                        lineHeight: "inc00",
                        color: darkMode ? "black00" : "text.default",
                        paddingLeft: "inc20",
                        paddingRight: "6px",
                        width: "100%",
                        whiteSpace: "nowrap",
                        textAlign: "left",
                    }, children: renderValue }), jsx("span", { sx: { display: "inline-flex", alignItems: "center" }, children: jsx("svg", { width: "9", height: "6", viewBox: "0 0 9 6", xmlns: "http://www.w3.org/2000/svg", sx: {
                            transform: isMenuItem
                                ? "rotateZ(-90deg)"
                                : open
                                    ? "rotateZ(180deg)"
                                    : "rotateZ(0.5deg)",
                            transition: "transform .15s ease-in-out",
                            transformOrigin: isMenuItem ? "5px 3px" : undefined,
                        }, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.01871 0.767799C1.13331 0.657535 1.28701 0.597283 1.44602 0.600283C1.60503 0.603283 1.75634 0.669291 1.86671 0.783799L4.83471 3.9342L7.80271 0.783799C7.85666 0.724324 7.92199 0.676282 7.99485 0.642521C8.06771 0.608761 8.1466 0.589968 8.22685 0.587256C8.30711 0.584545 8.38709 0.597969 8.46206 0.626735C8.53703 0.655501 8.60546 0.699023 8.6633 0.754722C8.72114 0.81042 8.76721 0.877162 8.79879 0.950993C8.83036 1.02482 8.84679 1.10424 8.84711 1.18454C8.84743 1.26484 8.83162 1.34438 8.80064 1.41846C8.76965 1.49254 8.7241 1.55965 8.66671 1.6158L5.26671 5.2158C5.21074 5.27387 5.14363 5.32006 5.06941 5.35161C4.99518 5.38315 4.91536 5.39942 4.83471 5.39942C4.75405 5.39942 4.67423 5.38315 4.6 5.35161C4.52578 5.32006 4.45868 5.27387 4.40271 5.2158L1.00271 1.6158C0.892442 1.50119 0.83219 1.3475 0.83519 1.18849C0.83819 1.02948 0.904197 0.878165 1.01871 0.767799Z", fill: darkMode ? "#FFF" : "#5D6C74" }) }) })] }) }));
};

const LanguageListOptions = ({ options, open, selectedValue, onSelect, customStyles, itemCustomStyles, darkMode, }) => {
    const dropdownRef = useRef(null);
    const getValue = (event) => {
        const el = event.target;
        return el.innerText;
    };
    return (jsx(ThemeProvider, { theme: theme$1, children: jsx("div", { ref: dropdownRef, sx: {
                display: open ? "block" : "none",
                width: "100%",
                paddingY: "12px",
                lineHeight: "inc00",
                fontSize: "inc20",
                color: darkMode ? "black00" : "text.default",
                fontFamily: theme$1.fonts.body,
                bg: darkMode ? "black70" : "black10",
                boxSizing: "border-box",
                overflow: "auto",
                ...customStyles,
            }, children: jsx("ul", { role: "listbox", sx: {
                    listStyleType: "none",
                    margin: 0,
                    padding: 0,
                }, children: options.map((option) => (jsx("li", { role: "option", tabIndex: 0, sx: {
                        cursor: "pointer",
                        padding: "12px 24px",
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "14px",
                        color: darkMode ? "black00" : "black60",
                        "&:hover": {
                            color: darkMode ? "blue50" : "blue80",
                        },
                        "&.active": {
                            fontWeight: "500",
                            color: darkMode ? "blue50" : "blue60",
                        },
                        ...itemCustomStyles,
                    }, onClick: (e) => {
                        e.stopPropagation();
                        const value = getValue(e);
                        onSelect(value);
                    }, onKeyPress: (e) => {
                        if (e.key === "Enter") {
                            const value = getValue(e);
                            onSelect(value);
                        }
                    }, className: option === selectedValue ? "active" : undefined, children: option }, option))) }) }) }));
};

const fadeIn$3 = keyframes `
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const fadeOut$3 = keyframes `
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
const customWrapperStyles = (isButtonsInBurgerMenu = false) => ({
    position: "relative",
    "@media screen and (min-width: 1281px)": {
        // this breakpoint is not tokenized yet
        display: isButtonsInBurgerMenu ? "block" : "none",
    },
});
const buttonIconStyles = (darkMode) => ({
    fill: darkMode ? "black00" : "blue80",
    stroke: darkMode ? "black00" : "blue80",
    borderWidth: 0,
    width: "36px",
    height: "36px",
    cursor: "pointer",
    "&.active, &:hover": {
        background: darkMode ? "black80" : "black20",
        fill: darkMode ? "black00" : "blue80",
        stroke: darkMode ? "black00" : "blue80",
    },
    "& > svg": {
        width: "24px",
        height: "24px",
    },
});
const helperButtonSx$1 = (darkMode) => ({
    color: darkMode ? "black00" : "blue80",
    borderBottom: 0,
    transition: `color ${theme$1.motion.inc10}, text-shadow ${theme$1.motion.inc10}`,
    lineHeight: "24px",
    "&:hover": {
        color: darkMode ? "green40" : "green60",
        textShadow: `0 0 1px rgba(0, 104, 74, 0.5)`,
        borderBottom: 0,
    },
});
const MenuDropdown = ({ content, signInUrl, disableSupport, disableSignIn, disableTryFree, showNavSearch, floraTheme, isButtonsInBurgerMenu, customStyles, showLanguageSelector, actualLocale, onSelectLocale, availableLocales = localeMap, darkMode, search, }) => {
    const menuDropdownRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [isMounted, setIsMounted] = useState(false);
    const [selectedValue, setSelectedValue] = useState(actualLocale);
    const [showLanguageList, setShowLanguageList] = useState(false);
    useEffect(() => {
        if (!showDropdown) {
            setShowLanguageList(false);
        }
        let timeout;
        if (showDropdown) {
            setIsMounted(true);
        }
        else {
            timeout = setTimeout(() => {
                setIsMounted(false);
            }, 200); // 200ms is the duration of your fade-out animation
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [showDropdown]);
    const onOpenDropdown = () => {
        setShowDropdown((prev) => !prev);
    };
    const handleClickOutside = (event) => {
        if (menuDropdownRef.current &&
            !menuDropdownRef.current.contains(event.target)) {
            setShowDropdown(false);
        }
    };
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    if (disableSignIn && disableSupport && disableTryFree)
        return null;
    return (jsxs("div", { ref: menuDropdownRef, sx: { ...customWrapperStyles(isButtonsInBurgerMenu), ...customStyles }, children: [jsx(ButtonIcon, { size: "small", variant: "outline", customStyles: buttonIconStyles(darkMode), iconName: ESystemIconNames.MENU_VERTICAL, onClick: onOpenDropdown, className: showDropdown ? "active" : "" }), isMounted && (jsxs(Fragment, { children: [jsxs("div", { sx: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "center",
                            p: "inc40",
                            gap: "inc40",
                            borderRadius: "8px",
                            boxShadow: "0px 3px 20px 0px rgba(0, 0, 0, 0.15)",
                            position: "absolute",
                            top: "100%",
                            right: "0",
                            marginTop: "8px",
                            background: darkMode ? "black70" : "black00",
                            minWidth: "140px",
                            animation: `${showDropdown && !showLanguageList ? fadeIn$3 : fadeOut$3} 0.2s ease-in-out forwards`,
                            pointerEvents: showDropdown && !showLanguageList ? undefined : "none",
                            "& a": {
                                whiteSpace: "nowrap",
                            },
                        }, children: [search && (jsx("div", { onClick: () => setShowDropdown(false), children: search })), showLanguageSelector ? (jsx(LanguageSelector, { value: selectedValue, onClick: () => {
                                    mdbTrack(ETrackingEvents.LINK_CLICK, {
                                        ...COMMON_FOOTER_TRACKING_PROPS,
                                        title: "Locale Selector Open",
                                    });
                                    setShowLanguageList(true);
                                }, isMenuItem: true, darkMode: darkMode })) : null, disableSupport ? null : (jsx(Link, { tabIndex: showNavSearch ? -1 : 0, navItem: true, variant: ELinkVariant.SMALL, href: content.secondary.support.href, customLinkContentStyles: helperButtonSx$1(darkMode), sx: {
                                    letterSpacing: "unset",
                                    textDecoration: "none",
                                }, onClick: () => {
                                    mdbTrack(ETrackingEvents.LINK_CLICK, {
                                        ...COMMON_NAVIGATION_TRACKING_PROPS,
                                        title: content.secondary.support.title,
                                        href: content.secondary.support.href,
                                        label: content.secondary.support.title,
                                    });
                                }, children: content.secondary.support.title })), disableSignIn ? null : (jsx(Link, { tabIndex: showNavSearch ? -1 : 0, navItem: true, variant: ELinkVariant.SMALL, href: signInUrl !== null && signInUrl !== void 0 ? signInUrl : content.secondary.login.href, customLinkContentStyles: helperButtonSx$1(darkMode), sx: {
                                    letterSpacing: "unset",
                                    textDecoration: "none",
                                }, onClick: () => {
                                    mdbTrack(ETrackingEvents.LINK_CLICK, {
                                        ...COMMON_NAVIGATION_TRACKING_PROPS,
                                        title: content.secondary.login.title,
                                        href: signInUrl !== null && signInUrl !== void 0 ? signInUrl : content.secondary.login.href,
                                        label: content.secondary.login.title,
                                    });
                                }, children: content.secondary.login.title })), isButtonsInBurgerMenu || disableTryFree ? null : (jsx(ButtonWrapper, { tabIndex: showNavSearch ? -1 : 0, theme: floraTheme, variant: "primary", href: content.secondary.try.href, customStyles: {
                                    letterSpacing: "0.16px",
                                    py: `calc(${theme$1.space.inc30} - 1px)`,
                                    px: `calc(${theme$1.space.inc70} - 1px)`,
                                    borderColor: "blue80",
                                    whiteSpace: "nowrap",
                                }, customWrapperStyles: {
                                    marginLeft: "-2px",
                                    marginRight: "-2px",
                                    marginBottom: "-5px",
                                }, onClick: () => {
                                    mdbTrack(ETrackingEvents.LINK_CLICK, {
                                        ...COMMON_NAVIGATION_TRACKING_PROPS,
                                        title: content.secondary.try.title,
                                        href: content.secondary.try.href,
                                        label: content.secondary.try.title,
                                    });
                                }, children: content.secondary.try.title }))] }), jsxs("div", { sx: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "8px",
                            boxShadow: "0px 3px 20px 0px rgba(0, 0, 0, 0.15)",
                            position: "absolute",
                            top: "100%",
                            minWidth: "200px",
                            overflow: "hidden",
                            right: "0",
                            marginTop: "8px",
                            background: "black00",
                            animation: `${showLanguageList ? fadeIn$3 : fadeOut$3} 0.2s ease-in-out forwards`,
                            pointerEvents: showLanguageList ? undefined : "none",
                            visibility: showLanguageList ? undefined : "hidden",
                            opacity: showLanguageList ? undefined : 0,
                            "& a": {
                                whiteSpace: "nowrap",
                            },
                        }, children: [jsxs(Link, { navItem: true, variant: ELinkVariant.SMALL, customLinkContentStyles: {
                                    borderBottom: 0,
                                    fontSize: 14,
                                    py: "15px",
                                    paddingLeft: "29px",
                                    fontWeight: "500",
                                    lineHeight: "14px",
                                    color: darkMode ? "black00" : "text.default",
                                    "&:hover": {
                                        borderBottom: 0,
                                    },
                                }, sx: {
                                    width: "100%",
                                    lineHeight: "14px",
                                    letterSpacing: "unset",
                                    textDecoration: "none",
                                    background: darkMode ? "black80" : "black00",
                                    "& svg": {
                                        stroke: darkMode ? "black00" : "text.default",
                                        marginRight: "3px",
                                        "& path": {
                                            strokeWidth: "3px",
                                        },
                                    },
                                    "&:hover": {
                                        svg: {
                                            stroke: darkMode ? "blue50" : "green60",
                                        },
                                        span: {
                                            color: darkMode ? "blue50" : "green60",
                                        },
                                    },
                                }, onClick: () => {
                                    setShowLanguageList(false);
                                }, children: [jsx(SystemIcon, { name: ESystemIconNames.CHEVRON_LEFT }), "Back"] }), jsx(LanguageListOptions, { options: Object.keys(availableLocales), open: showLanguageList, customStyles: {
                                    py: "4px",
                                }, itemCustomStyles: {
                                    padding: "12px 32px",
                                }, selectedValue: selectedValue, onSelect: (value) => {
                                    setSelectedValue(value);
                                    setShowLanguageList(false);
                                    mdbTrack(ETrackingEvents.LINK_CLICK, {
                                        ...COMMON_FOOTER_TRACKING_PROPS,
                                        title: "Locale Selector Selected",
                                        locale: value,
                                    });
                                    if (onSelectLocale)
                                        onSelectLocale(availableLocales[value]);
                                }, darkMode: darkMode })] })] }))] }));
};

const getNavChironColor = (greyed, active, darkMode) => {
    if (greyed)
        return darkMode ? "black30" : "black40";
    if (darkMode) {
        return "black00";
    }
    else {
        return active ? "blue80" : "black50";
    }
};
const Chevron = () => {
    return (jsx("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "nav-chevron", children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.18362 5.76804C4.29823 5.65778 4.45193 5.59753 4.61093 5.60053C4.76994 5.60353 4.92126 5.66953 5.03162 5.78404L7.99962 8.93444L10.9676 5.78404C11.0216 5.72457 11.0869 5.67653 11.1598 5.64277C11.2326 5.609 11.3115 5.59021 11.3918 5.5875C11.472 5.58479 11.552 5.59821 11.627 5.62698C11.7019 5.65575 11.7704 5.69927 11.8282 5.75497C11.8861 5.81066 11.9321 5.87741 11.9637 5.95124C11.9953 6.02507 12.0117 6.10449 12.012 6.18478C12.0123 6.26508 11.9965 6.34463 11.9656 6.41871C11.9346 6.49278 11.889 6.55989 11.8316 6.61604L8.43162 10.216C8.37565 10.2741 8.30855 10.3203 8.23432 10.3519C8.1601 10.3834 8.08028 10.3997 7.99962 10.3997C7.91897 10.3997 7.83915 10.3834 7.76492 10.3519C7.6907 10.3203 7.62359 10.2741 7.56762 10.216L4.16762 6.61604C4.05736 6.50144 3.99711 6.34774 4.00011 6.18873C4.00311 6.02972 4.06911 5.87841 4.18362 5.76804Z", fill: "inherit" }) }));
};
const NavListItem = ({ title, href, showNavSearch, content, active, greyed, onOpenDropdown, trackProps, darkMode, }) => {
    return (jsxs("li", { className: "header-nav-menu-item", sx: {
            px: "20px",
            "@media screen and (max-width: 1280px)": {
                // this breakpoint is not tokenized yet
                px: "inc30",
            },
        }, onClick: onOpenDropdown ? () => onOpenDropdown(title, trackProps) : undefined, "data-highlighted": !!active, children: [jsxs(Link, { tabIndex: showNavSearch ? -1 : 0, variant: ELinkVariant.SMALL, customLinkContentStyles: {
                    borderBottom: 0,
                    color: greyed
                        ? darkMode
                            ? "black30"
                            : "black50"
                        : darkMode
                            ? "black00"
                            : "blue80",
                    transition: `color ${theme$1.motion.inc10}, text-shadow ${theme$1.motion.inc10}`,
                    "@media screen and (max-width: 1416px)": {
                        // this breakpoint is not tokenized yet
                        fontSize: "15px",
                        lineHeight: "15px",
                    },
                    ":hover": {
                        borderBottom: 0,
                        color: darkMode ? "green40" : "green60",
                        textShadow: `0 0 1px rgba(0, 104, 74, 0.5)`,
                        "& .nav-chevron": {
                            fill: darkMode ? "green40" : "green60",
                        },
                    },
                }, navItem: true, sx: {
                    fontFamily: "Euclid Circular A,Noto Sans KR,Noto Sans SC,Noto Sans JP",
                    position: "relative",
                    height: NAV_HEIGHT,
                    display: "flex",
                    alignItems: "center",
                    textDecoration: "none",
                    letterSpacing: "unset",
                    minWidth: `calc(${theme$1.sizes.inc70} + 4px)`,
                    justifyContent: "center",
                    "& .nav-chevron": {
                        marginLeft: "2px",
                        fill: getNavChironColor(greyed, active, darkMode),
                        transition: `transform ${theme$1.motion.inc20}, fill ${theme$1.motion.inc10}`,
                        transform: active ? "rotate(180deg)" : undefined,
                    },
                    ":hover": {
                        textDecoration: "none",
                    },
                    ":focus-visible": {
                        outline: "-webkit-focus-ring-color auto 1px",
                    },
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                }, href: href, onClick: href
                    ? () => {
                        mdbTrack(ETrackingEvents.LINK_CLICK, {
                            ...COMMON_NAVIGATION_TRACKING_PROPS,
                            title,
                            href: href,
                            label: title,
                            position: trackProps.index,
                        });
                    }
                    : undefined, children: [title, content && jsx(Chevron, {})] }), content && (jsx(NavDropdown, { content: content, hidden: !active, darkMode: darkMode }))] }));
};

const NavList = ({ showNavSearch, content, isSearchAnimating, darkMode, }) => {
    const navListRef = useRef(null);
    const [activeDropdown, setActiveDropdown] = useState("");
    const onOpenDropdown = (title, trackProps) => {
        if (activeDropdown !== title && trackProps) {
            mdbTrack(ETrackingEvents.DROPDOWN_APPEARS, {
                ...COMMON_NAVIGATION_TRACKING_PROPS,
                title,
                label: title,
                position: trackProps.index,
                nonInteraction: 1,
            });
        }
        setActiveDropdown((prev) => (prev === title ? "" : title));
    };
    const handleClickOutside = (event) => {
        if (navListRef.current &&
            !navListRef.current.contains(event.target)) {
            setActiveDropdown("");
        }
    };
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return (jsx("ul", { ref: navListRef, sx: {
            margin: "0",
            marginLeft: "20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: NAV_HEIGHT,
            listStyle: "none",
            padding: "0",
            opacity: showNavSearch ? "0" : "1",
            pointerEvents: showNavSearch ? "none" : "initial",
            transition: `opacity ${theme$1.motion.inc20}`,
            position: showNavSearch || isSearchAnimating ? "absolute" : "unset",
            "@media screen and (max-width: 1280px)": {
                // this breakpoint is not tokenized yet
                marginLeft: "inc30",
            },
            animation: "fadeIn 0.5s forwards",
            "@global": {
                "@keyframes fadeIn": {
                    from: { opacity: 0 },
                    to: { opacity: 1 },
                },
                "@keyframes fadeOut": {
                    from: { opacity: 1 },
                    to: { opacity: 0 },
                },
            },
        }, className: "header-desktop-nav-list", children: content.primary.map(({ href, title, dropdown, uniqueKey }, index) => {
            const trackProps = {
                title,
                activeDropdown,
                href,
                index,
            };
            return (jsx(NavListItem, { title: title, href: href, showNavSearch: showNavSearch, onOpenDropdown: href ? undefined : onOpenDropdown, active: title === activeDropdown, greyed: activeDropdown ? title !== activeDropdown : undefined, content: dropdown, trackProps: trackProps, darkMode: darkMode }, uniqueKey));
        }) }));
};

const widthCache = {};
const INITIAL_WIDTH = 1280;
const useButtonsInBurgerMenu = () => {
    const [isButtonsInBurgerMenu, setIsButtonsInBurgerMenu] = useState(false);
    const [screenWidth, setScreenWidth] = useState(INITIAL_WIDTH + 1);
    // Get the width of an element based on its className.
    function getElementWidth(className, getFromCache = false) {
        if (getFromCache && widthCache[className])
            return widthCache[className];
        const elements = document === null || document === void 0 ? void 0 : document.querySelectorAll(`.${className}`);
        let totalWidth = 0;
        elements.forEach((element) => {
            if (element instanceof HTMLElement) {
                const style = window === null || window === void 0 ? void 0 : window.getComputedStyle(element);
                const width = element.offsetWidth;
                const marginLeft = parseFloat(style.marginLeft || "0");
                const marginRight = parseFloat(style.marginRight || "0");
                totalWidth += width + marginLeft + marginRight;
            }
        });
        if (!totalWidth && widthCache[className])
            return widthCache[className];
        widthCache[className] = totalWidth;
        return totalWidth;
    }
    // Update the state when the window is resized.
    const handleResize = debounce(() => {
        setScreenWidth((prev) => {
            if ((prev <= 1416 && (window === null || window === void 0 ? void 0 : window.innerWidth) > 1416) ||
                (prev > 1416 && (window === null || window === void 0 ? void 0 : window.innerWidth) <= 1416)) {
                // If we cross the 1416px breakpoint, clear the cache.
                Object.keys(widthCache).forEach((key) => {
                    delete widthCache[key];
                });
            }
            return window === null || window === void 0 ? void 0 : window.innerWidth;
        });
    }, 200);
    const calculateWidthsAndSetState = (getFromCache = false, retry = false) => {
        if (screenWidth > INITIAL_WIDTH) {
            const headerWidth = getElementWidth("header-desktop-buttons");
            const navListWidth = getElementWidth("header-desktop-nav-list", getFromCache);
            const buttonElementsWidth = getElementWidth("header-desktop-button", getFromCache);
            const linkElementsWidth = getElementWidth("header-desktop-link", getFromCache);
            if (navListWidth + buttonElementsWidth + linkElementsWidth + 12 >
                headerWidth) {
                setIsButtonsInBurgerMenu(true);
            }
            else {
                setIsButtonsInBurgerMenu(false);
                if (!linkElementsWidth && !retry) {
                    calculateWidthsAndSetState(false, true);
                }
            }
        }
        else {
            setIsButtonsInBurgerMenu(false);
        }
    };
    useEffect(() => {
        // Attach the event listener when the component mounts.
        window === null || window === void 0 ? void 0 : window.addEventListener("resize", handleResize);
        // To fix conflict regarding server side rendering
        setScreenWidth(window === null || window === void 0 ? void 0 : window.innerWidth);
        // Cleanup the event listener when the component unmounts.
        return () => {
            window === null || window === void 0 ? void 0 : window.removeEventListener("resize", handleResize);
            handleResize.cancel();
        };
    }, []);
    useEffect(() => {
        // to recalculate after fonts and styles are loaded
        const handleLoad = () => {
            calculateWidthsAndSetState(false);
            window === null || window === void 0 ? void 0 : window.removeEventListener("load", handleLoad);
        };
        window === null || window === void 0 ? void 0 : window.addEventListener("load", handleLoad);
        return () => {
            window === null || window === void 0 ? void 0 : window.removeEventListener("load", handleLoad);
        };
    }, []);
    useEffect(() => {
        setTimeout(() => {
            calculateWidthsAndSetState(true);
        }, 100);
    }, [screenWidth]);
    return isButtonsInBurgerMenu;
};

const fadeIn$2 = keyframes `
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const fadeOut$2 = keyframes `
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
const LanguageDropdown = ({ options, value = undefined, onSelect, onOpen, darkMode, }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isMounted, setIsMounted] = useState(false);
    const [selectedValue, setSelectedValue] = useState(value);
    const wrapperRef = useRef(null);
    useEffect(() => {
        let timeout;
        if (isDropdownOpen) {
            setIsMounted(true);
        }
        else {
            timeout = setTimeout(() => {
                setIsMounted(false);
            }, 200); // 200ms is the duration of your fade-out animation
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [isDropdownOpen]);
    useEffect(() => {
        function handleClickOutside(event) {
            if (isDropdownOpen &&
                (wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current) &&
                !(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current.contains(event.target))) {
                setIsDropdownOpen(false);
            }
        }
        if (isDropdownOpen) {
            document.addEventListener("click", handleClickOutside);
        }
        else {
            document.removeEventListener("click", handleClickOutside);
        }
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [wrapperRef, isDropdownOpen, setIsDropdownOpen]);
    return (jsx(ThemeProvider, { theme: theme$1, children: jsxs("div", { ref: wrapperRef, sx: {
                position: "relative",
            }, onClick: () => {
                if (!isDropdownOpen && onOpen)
                    onOpen();
                setIsDropdownOpen(!isDropdownOpen);
            }, className: "header-desktop-button", children: [jsx(LanguageSelector, { open: isDropdownOpen, value: value, darkMode: darkMode, shrink: true }), isMounted && (jsx("div", { sx: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "8px",
                        boxShadow: "0px 3px 20px 0px rgba(0, 0, 0, 0.15)",
                        overflow: "hidden",
                        position: "absolute",
                        top: "100%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        marginTop: "16px",
                        animation: `${isDropdownOpen ? fadeIn$2 : fadeOut$2} 0.2s ease-in-out forwards`,
                    }, children: jsx(LanguageListOptions, { options: options, open: isDropdownOpen, selectedValue: selectedValue, onSelect: (value) => {
                            setSelectedValue(value);
                            setIsDropdownOpen(!isDropdownOpen);
                            if (onSelect) {
                                onSelect(value);
                            }
                        }, darkMode: darkMode }) }))] }) }));
};

const MAX_WIDTH = "1480px";

const helperButtonSx = (darkMode) => ({
    color: darkMode ? "black00" : "blue80",
    borderBottom: 0,
    transition: `color ${theme$1.motion.inc10}, text-shadow ${theme$1.motion.inc10}`,
    "@media screen and (max-width: 1416px)": {
        // this breakpoint is not tokenized yet
        fontSize: "15px",
        lineHeight: "15px",
    },
    "&:hover": {
        color: darkMode ? "green40" : "green60",
        textShadow: `0 0 1px rgba(0, 104, 74, 0.5)`,
        borderBottom: 0,
    },
});
const Desktop = ({ className, content, property, signInUrl, hideTryFree, hideSignIn, hideSearch, hideSupport, floraTheme = "default", docsBaseUrl, fullWidth = false, showLanguageSelector = false, actualLocale, onSelectLocale, availableLocales = localeMap, darkMode, }) => {
    const [isSearchAnimating, setIsSearchAnimating] = useState(false);
    const [showNavSearch, setShowNavSearch] = useState(false);
    const isButtonsInBurgerMenu = useButtonsInBurgerMenu();
    const searchRef = useRef(null);
    const disableSignIn = hideSignIn || !content.secondary.login;
    const disableSearch = hideSearch || !content.secondary.search;
    const disableTryFree = hideTryFree || !content.secondary.try;
    const disableSupport = hideSupport || !content.secondary.support;
    const handleSetShowNavSearch = () => {
        var _a;
        if (!showNavSearch) {
            mdbTrack(ETrackingEvents.SEARCH, {
                ...COMMON_NAVIGATION_TRACKING_PROPS,
                title: "Open Search",
            });
            (_a = searchRef === null || searchRef === void 0 ? void 0 : searchRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        setIsSearchAnimating(true);
        setTimeout(() => {
            setIsSearchAnimating(false);
        }, 250);
        setShowNavSearch(!showNavSearch);
    };
    const Search = ({ withinDropdown }) => (jsxs("button", { onClick: handleSetShowNavSearch, "aria-label": showNavSearch && !withinDropdown ? "Close Search" : "Open Search", className: "header-desktop-button", sx: {
            border: "none",
            background: "none",
            outline: "none",
            marginRight: disableSupport &&
                disableSignIn &&
                disableTryFree &&
                !showLanguageSelector
                ? 0
                : "inc50",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            zIndex: "1",
            height: NAV_HEIGHT,
            padding: 0,
            "@media screen and (min-width: 1024px) and (max-width: 1280px)": {
                // this breakpoint is not tokenized yet
                height: "24px",
                display: !withinDropdown && !showNavSearch && "none",
            },
            "& > img": {
                maxWidth: "none",
                width: "20px",
                height: "20px",
            },
            ":focus-visible": {
                outline: "-webkit-focus-ring-color auto 1px",
            },
            ...(withinDropdown && {
                "&:hover": {
                    span: {
                        color: darkMode ? "blue50" : "green60",
                    },
                    svg: {
                        stroke: darkMode ? "blue50" : "green60",
                    },
                    img: {
                        ...(!darkMode && {
                            filter: "brightness(0) saturate(100%) invert(25%) sepia(98%) saturate(632%) hue-rotate(121deg) brightness(95%) contrast(101%)",
                        }),
                    },
                },
            }),
        }, children: [jsx("img", { alt: "Search", src: !showNavSearch || withinDropdown
                    ? darkMode
                        ? "https://webimages.mongodb.com/_com_assets/cms/lzslrve126rd6b305-search-dark-mode.svg?auto=format%252Ccompress"
                        : "https://webimages.mongodb.com/_com_assets/cms/lyekm5ifrkqjod0wu-search_updated.svg?auto=format%252Ccompress"
                    : darkMode
                        ? "https://webimages.mongodb.com/_com_assets/cms/lzsq23h72g4xnqyi9-close_x-dark-mode.svg?auto=format%252Ccompress"
                        : "https://webimages.mongodb.com/_com_assets/cms/kq2rzdva9b720s30j-close_x.svg?auto=format%252Ccompress", width: "20", height: "20" }), withinDropdown && (jsx("span", { sx: {
                    fontFamily: theme$1.fonts.body,
                    fontSize: "inc20",
                    lineHeight: "inc00",
                    color: darkMode ? "black00" : "text.default",
                    paddingLeft: "inc20",
                }, children: "Search" }))] }));
    return (jsx(ThemeProvider, { theme: theme$1, children: jsx(Box, { sx: {
                width: "100%",
                backgroundColor: darkMode ? "blue80" : "black00",
                display: "flex",
                justifyContent: "center",
                borderBottom: [
                    "0",
                    null,
                    null,
                    `1px solid ${darkMode
                        ? theme$1.colors.border.inverseDarker
                        : theme$1.colors.border.default}`,
                ],
            }, children: jsxs(Box, { sx: {
                    width: "100%",
                    maxWidth: fullWidth ? undefined : MAX_WIDTH,
                    backgroundColor: darkMode ? "blue80" : "black00",
                    display: "flex",
                    alignItems: "center",
                    fontFamily: "Euclid Circular A,Noto Sans KR,Noto Sans SC,Noto Sans JP",
                    fontWeight: "300",
                    height: NAV_HEIGHT,
                    px: "inc50",
                }, className: className, children: [jsx(MDBLogo, { theme: floraTheme, sx: {
                            fontSize: "inc10",
                            lineHeight: "37px",
                            height: "32px",
                            width: "126px",
                            maxWidth: "none",
                            display: "flex",
                            alignItems: "center",
                        }, width: "126", height: "32", variant: darkMode
                            ? ELogoVariant.HORIZONTAL_ALL_WHITE
                            : ELogoVariant.HORIZONTAL_DEFAULT, href: "https://www.mongodb.com" }), jsxs(Box, { sx: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                        }, className: "header-desktop-buttons", children: [disableSearch ? null : (jsx(NavSearch, { floraTheme: floraTheme, animating: isSearchAnimating, content: content, visible: showNavSearch, ref: searchRef, property: property, docsBaseUrl: docsBaseUrl, darkMode: darkMode })), jsx(NavList, { isSearchAnimating: isSearchAnimating, content: content, showNavSearch: showNavSearch, darkMode: darkMode }), jsxs(Box, { sx: {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0,
                                }, children: [disableSearch ? null : jsx(Search, {}), isButtonsInBurgerMenu && (jsx(MenuDropdown, { content: content, signInUrl: signInUrl, disableTryFree: disableTryFree, disableSignIn: disableSignIn, disableSupport: disableSupport, showLanguageSelector: showLanguageSelector, showNavSearch: showNavSearch, floraTheme: theme$1, isButtonsInBurgerMenu: isButtonsInBurgerMenu, actualLocale: actualLocale, onSelectLocale: onSelectLocale, availableLocales: availableLocales, customStyles: {
                                            "@media screen and (max-width: 1280px)": {
                                                display: "none !important",
                                            },
                                        }, darkMode: darkMode })), showLanguageSelector && !isButtonsInBurgerMenu ? (jsx(Box, { sx: {
                                            display: "flex",
                                            marginRight: disableSupport && disableSignIn && disableTryFree
                                                ? 0
                                                : "inc50",
                                            "@media screen and (max-width: 1280px)": {
                                                // this breakpoint is not tokenized yet
                                                display: "none",
                                            },
                                        }, children: jsx(LanguageDropdown, { options: Object.keys(availableLocales), value: actualLocale, onOpen: () => {
                                                mdbTrack(ETrackingEvents.LINK_CLICK, {
                                                    ...COMMON_FOOTER_TRACKING_PROPS,
                                                    title: "Locale Selector Open",
                                                });
                                            }, onSelect: (value) => {
                                                mdbTrack(ETrackingEvents.LINK_CLICK, {
                                                    ...COMMON_FOOTER_TRACKING_PROPS,
                                                    title: "Locale Selector Selected",
                                                    locale: value,
                                                });
                                                if (onSelectLocale)
                                                    onSelectLocale(availableLocales[value]);
                                            }, darkMode: darkMode }) })) : null, disableSupport || isButtonsInBurgerMenu ? null : (jsx(Link, { tabIndex: showNavSearch ? -1 : 0, navItem: true, variant: ELinkVariant.SMALL, href: content.secondary.support.href, customLinkContentStyles: helperButtonSx(darkMode), sx: {
                                            letterSpacing: "unset",
                                            marginRight: "inc50",
                                            textDecoration: "none",
                                            "@media screen and (max-width: 1280px)": {
                                                // this breakpoint is not tokenized yet
                                                display: "none",
                                            },
                                        }, onClick: () => {
                                            mdbTrack(ETrackingEvents.LINK_CLICK, {
                                                ...COMMON_NAVIGATION_TRACKING_PROPS,
                                                title: content.secondary.support.title,
                                                href: content.secondary.support.href,
                                                label: content.secondary.support.title,
                                            });
                                        }, className: "header-desktop-link", children: content.secondary.support.title })), disableSignIn || isButtonsInBurgerMenu ? null : (jsx(Link, { tabIndex: showNavSearch ? -1 : 0, navItem: true, variant: ELinkVariant.SMALL, href: signInUrl !== null && signInUrl !== void 0 ? signInUrl : content.secondary.login.href, customLinkContentStyles: helperButtonSx(darkMode), sx: {
                                            letterSpacing: "unset",
                                            marginRight: "inc60",
                                            textDecoration: "none",
                                            "@media screen and (max-width: 1280px)": {
                                                // this breakpoint is not tokenized yet
                                                display: "none",
                                            },
                                        }, onClick: () => {
                                            mdbTrack(ETrackingEvents.LINK_CLICK, {
                                                ...COMMON_NAVIGATION_TRACKING_PROPS,
                                                title: content.secondary.login.title,
                                                href: signInUrl !== null && signInUrl !== void 0 ? signInUrl : content.secondary.login.href,
                                                label: content.secondary.login.title,
                                            });
                                        }, className: "header-desktop-link", children: content.secondary.login.title })), jsx(MenuDropdown, { content: content, signInUrl: signInUrl, disableTryFree: !disableTryFree, disableSignIn: disableSignIn, disableSupport: disableSupport, showNavSearch: showNavSearch, floraTheme: theme$1, showLanguageSelector: showLanguageSelector, actualLocale: actualLocale, availableLocales: availableLocales, onSelectLocale: onSelectLocale, darkMode: darkMode, customStyles: {
                                            mr: "inc40",
                                            ml: "inc50",
                                        }, search: disableSearch ? null : jsx(Search, { withinDropdown: true }) }), disableTryFree ? null : (jsx(ButtonWrapper, { tabIndex: showNavSearch ? -1 : 0, theme: floraTheme, variant: "primary", href: content.secondary.try.href, customStyles: {
                                            mr: "0",
                                            letterSpacing: "0.16px",
                                            py: `calc(${theme$1.space.inc30} - 1px)`,
                                            px: `inc40`,
                                            borderColor: darkMode ? "green60" : "blue80",
                                        }, onClick: () => {
                                            mdbTrack(ETrackingEvents.LINK_CLICK, {
                                                ...COMMON_NAVIGATION_TRACKING_PROPS,
                                                title: content.secondary.try.title,
                                                href: content.secondary.try.href,
                                                label: content.secondary.try.title,
                                            });
                                        }, className: "header-desktop-button", children: content.secondary.try.title }))] })] })] }) }) }));
};

const slideIn$1 = keyframes `
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;
const slideOut$1 = keyframes `
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
`;
const NavListMobile = ({ content, show = true, darkMode, }) => {
    var _a, _b;
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        let timeout;
        if (show) {
            setIsMounted(true);
        }
        else {
            timeout = setTimeout(() => {
                setIsMounted(false);
            }, 200); // 200ms is the duration of your fade-out animation
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [show]);
    if (!isMounted)
        return null;
    return (jsxs(Box, { sx: {
            fontFamily: "Euclid Circular A,Noto Sans KR,Noto Sans SC,Noto Sans JP",
            position: "fixed",
            zIndex: "1000",
            right: 0,
            top: 55,
            width: "100%",
            maxWidth: "432px",
            height: "calc(100% - 55px)",
            overflow: "auto",
            background: darkMode ? "black70" : "black10",
            animation: `${show ? slideIn$1 : slideOut$1} 0.3s forwards`,
            display: "flex",
            flexDirection: "column",
            "@media screen and (max-width: 540px)": {
                maxWidth: "100%",
            },
        }, children: [jsxs(Box, { sx: { p: "24px", pb: "0px" }, children: [content.mainSection.columns.map((col, i) => (jsx("div", { children: col.subSections.map((subSection) => (jsx(SubSection, { title: subSection.title, list: subSection.menuItems, darkMode: darkMode, isMobile: true }, subSection.uniqueKey))) }, `column-${i}-${col.uniqueKey}`))), ((_a = content.helperSection) === null || _a === void 0 ? void 0 : _a.subSections) ? (jsx(HelperSection, { helperContent: {
                            subSections: content.helperSection.subSections,
                        }, darkMode: darkMode, isMobile: true })) : null, content.footerSection ? (jsxs(Fragment, { children: [content.footerSection.titleXs && (jsx("div", { sx: { ...titleStyles$1, mb: "8px" }, children: content.footerSection.titleXs })), jsx(MenuFooterSectionItem, { ...content.footerSection, darkMode: darkMode, isMobile: true })] })) : null, content.footerAdditionalSection ? (jsx(MenuFooterSectionItem, { ...content.footerAdditionalSection, darkMode: darkMode, isMobile: true })) : null] }), jsx(Box, { sx: { pb: "24px" }, children: ((_b = content.helperSection) === null || _b === void 0 ? void 0 : _b.helperSectionItems) ? (jsx(HelperSection, { helperContent: {
                        helperSectionItems: content.helperSection.helperSectionItems,
                    }, darkMode: darkMode, isMobile: true })) : null })] }));
};

const NavLanguageListMobile = ({ onSelect, value, availableLocales = localeMap, show = true, darkMode, }) => {
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        let timeout;
        if (show) {
            setIsMounted(true);
        }
        else {
            timeout = setTimeout(() => {
                setIsMounted(false);
            }, 200); // 200ms is the duration of your fade-out animation
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [show]);
    if (!isMounted)
        return null;
    return (jsx(Box, { sx: {
            fontFamily: "Euclid Circular A,Noto Sans KR,Noto Sans SC,Noto Sans JP",
            position: "fixed",
            zIndex: "1000",
            right: 0,
            top: 54,
            width: "100%",
            maxWidth: "432px",
            height: "calc(100% - 55px)",
            overflow: "auto",
            background: darkMode ? "black70" : "black10",
            animation: `${show ? slideIn$1 : slideOut$1} 0.3s forwards`,
            display: "flex",
            flexDirection: "column",
            "@media screen and (max-width: 540px)": {
                maxWidth: "100%",
            },
        }, children: jsx(LanguageListOptions, { options: Object.keys(availableLocales), open: true, customStyles: {
                pt: "12px",
            }, itemCustomStyles: {
                padding: "12px 16px",
            }, selectedValue: value, onSelect: onSelect, darkMode: darkMode }) }));
};

const linkStyles = (index, darkMode) => ({
    width: "100%",
    p: "24px",
    fontFamily: "Euclid Circular A,Noto Sans KR,Noto Sans SC,Noto Sans JP",
    height: "64px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    textDecoration: "none",
    letterSpacing: "unset",
    borderTop: index === 0 ? 0 : "1px solid",
    borderColor: darkMode ? "black50" : "black20",
    boxSizing: "border-box",
    cursor: "pointer",
    whiteSpace: "nowrap",
    "& > span": {
        width: "100%",
    },
    ":hover": {
        textDecoration: "none",
    },
    ":focus-visible": {
        outline: "-webkit-focus-ring-color auto 1px",
    },
    "& svg": {
        stroke: darkMode ? "black00" : "black60",
    },
});
const linkContentStyles = {
    borderBottom: 0,
    fontSize: "16px",
    lineHeight: "16px",
    fontWeight: "600",
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    ":hover": {
        borderBottom: 0,
    },
};
const slideIn = keyframes `
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;
const slideOut = keyframes `
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
`;
const fadeIn$1 = keyframes `
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const fadeOut$1 = keyframes `
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
const LANGUAGE_SELECTOR_MENU = "Language Selector";
const NavMenuMobile = ({ content, signInUrl, hideTryFree, hideSupport, hideSignIn, docsBaseUrl, floraTheme = "default", show, onClose, showLanguageSelector, onSelectLocale, actualLocale, availableLocales = localeMap, darkMode, }) => {
    const [isMounted, setIsMounted] = useState(false);
    const [activeMenu, setActiveMenu] = useState("");
    const [activeMenuContent, setActiveMenuContent] = useState();
    const [selectedValue, setSelectedValue] = useState(actualLocale);
    const [showLanguageList, setShowLanguageList] = useState(false);
    const onOpenDropdown = (title, trackProps) => {
        if (activeMenu !== title && trackProps) {
            mdbTrack(ETrackingEvents.DROPDOWN_APPEARS, {
                ...COMMON_NAVIGATION_TRACKING_PROPS,
                title,
                label: title,
                position: trackProps.index,
                nonInteraction: 1,
            });
        }
        setActiveMenu((prev) => (prev === title ? "" : title));
    };
    const onOpenLanguageSelector = () => {
        mdbTrack(ETrackingEvents.LINK_CLICK, {
            ...COMMON_FOOTER_TRACKING_PROPS,
            title: "Locale Selector Open",
        });
        setActiveMenu(LANGUAGE_SELECTOR_MENU);
    };
    useEffect(() => {
        let timeout;
        if (show) {
            setIsMounted(true);
        }
        else {
            timeout = setTimeout(() => {
                setIsMounted(false);
            }, 200); // 200ms is the duration of your fade-out animation
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [show]);
    useEffect(() => {
        var _a;
        if (activeMenu) {
            if (activeMenu === LANGUAGE_SELECTOR_MENU) {
                setShowLanguageList(true);
            }
            else {
                const _content = (_a = content.primary.find((v) => v.title === activeMenu)) === null || _a === void 0 ? void 0 : _a.dropdown;
                if (_content) {
                    setActiveMenuContent(_content);
                }
            }
        }
        else {
            setTimeout(() => {
                setShowLanguageList(false);
            }, 300);
        }
    }, [activeMenu]);
    useEffect(() => {
        if (!isMounted) {
            setActiveMenu("");
        }
    }, [isMounted]);
    const disableSignIn = hideSignIn || !content.secondary.login;
    const disableTryFree = hideTryFree || !content.secondary.try;
    const disableSupport = hideSupport || !content.secondary.support;
    if (!isMounted)
        return null;
    return (jsxs(Fragment, { children: [jsx("div", { sx: {
                    width: "100%",
                    maxWidth: "432px",
                    position: "fixed",
                    zIndex: "0",
                    right: 0,
                    top: 0,
                    height: "55px",
                    opacity: show && activeMenu ? "1" : "0",
                    pointerEvents: show && activeMenu ? undefined : "none",
                    transition: "opacity 0.2s",
                    borderLeft: "1px solid",
                    borderColor: "black20",
                    "@media screen and (max-width: 540px)": {
                        zIndex: "1000",
                        width: "130px",
                        left: 0,
                        right: "auto",
                        borderLeft: 0,
                    },
                }, children: jsxs(Link, { navItem: true, variant: ELinkVariant.SMALL, customLinkContentStyles: {
                        borderBottom: 0,
                        fontSize: 14,
                        paddingTop: "16px",
                        paddingLeft: "20px",
                        fontWeight: "500",
                        lineHeight: "24px",
                        color: darkMode ? "blue50" : "text.default",
                        "&:hover": {
                            borderBottom: 0,
                        },
                    }, sx: {
                        width: "130px",
                        lineHeight: "24px",
                        letterSpacing: "unset",
                        textDecoration: "none",
                        background: darkMode ? "blue80" : "black00",
                        "& svg": {
                            stroke: darkMode ? "blue50" : "text.default",
                            marginRight: "6px",
                            "& path": {
                                strokeWidth: "3px",
                            },
                        },
                        "&:hover": {
                            svg: {
                                stroke: darkMode ? "blue50" : "green60",
                            },
                            span: {
                                color: darkMode ? "blue50" : "green60",
                            },
                        },
                    }, onClick: () => {
                        setActiveMenu("");
                    }, children: [jsx(SystemIcon, { name: ESystemIconNames.CHEVRON_LEFT }), "Back"] }) }), jsxs(Box, { "data-testid": "menu-wrapper", sx: {
                    fontFamily: "Euclid Circular A,Noto Sans KR,Noto Sans SC,Noto Sans JP",
                    position: "fixed",
                    zIndex: "999",
                    right: 0,
                    top: 55,
                    maxWidth: "432px",
                    width: "100%",
                    height: "calc(100% - 55px)",
                    overflow: "auto",
                    background: darkMode ? "black70" : "black10",
                    animation: `${show ? slideIn : slideOut} 0.3s forwards`,
                    display: "flex",
                    flexDirection: "column",
                    "@media screen and (max-width: 540px)": {
                        maxWidth: "100%",
                    },
                }, children: [jsxs(Box, { children: [content.primary.map(({ href, title, dropdown, uniqueKey }, index) => {
                                const trackProps = {
                                    title,
                                    activeMenu,
                                    href,
                                    index,
                                };
                                return (jsxs(Link, { variant: ELinkVariant.SMALL, customLinkContentStyles: {
                                        ...linkContentStyles,
                                        color: darkMode ? "black00" : "black60",
                                    }, navItem: true, sx: linkStyles(index, darkMode), href: href, onClick: href
                                        ? () => {
                                            mdbTrack(ETrackingEvents.LINK_CLICK, {
                                                ...COMMON_NAVIGATION_TRACKING_PROPS,
                                                title,
                                                href: href,
                                                label: title,
                                                position: trackProps.index,
                                            });
                                        }
                                        : () => onOpenDropdown(title, trackProps), children: [title, dropdown && (jsx(SystemIcon, { name: ESystemIconNames.CHEVRON_RIGHT }))] }, uniqueKey));
                            }), !disableSupport && (jsx(Link, { variant: ELinkVariant.SMALL, customLinkContentStyles: {
                                    ...linkContentStyles,
                                    color: darkMode ? "black00" : "black60",
                                }, navItem: true, sx: linkStyles(6, darkMode), href: content.secondary.support.href, onClick: () => mdbTrack(ETrackingEvents.LINK_CLICK, {
                                    ...COMMON_NAVIGATION_TRACKING_PROPS,
                                    title: content.secondary.support.title,
                                    href: signInUrl !== null && signInUrl !== void 0 ? signInUrl : content.secondary.support.href,
                                    label: content.secondary.support.title,
                                }), children: content.secondary.support.title }, "support")), showLanguageSelector ? (jsxs(Link, { variant: ELinkVariant.SMALL, customLinkContentStyles: {
                                    ...linkContentStyles,
                                    color: darkMode ? "black00" : "black60",
                                }, navItem: true, sx: linkStyles(1, darkMode), onClick: onOpenLanguageSelector, children: [jsxs("span", { sx: { display: "flex", alignItems: "center" }, children: [jsx("img", { src: darkMode
                                                    ? "https://webimages.mongodb.com/_com_assets/cms/lzsle5raf6v32fw36-language-selector-globe-dark-mode.svg?auto=format%252Ccompress"
                                                    : "https://webimages.mongodb.com/_com_assets/cms/lvz91dv3bugodsyau-language-selector-globe.svg?auto=format%252Ccompress", width: "16", height: "16", alt: "Language Selector Icon", style: {
                                                    height: "auto",
                                                    marginRight: "8px",
                                                } }), selectedValue] }), jsx(SystemIcon, { name: ESystemIconNames.CHEVRON_RIGHT })] }, "language-selector")) : null] }), jsxs(Box, { sx: {
                            display: "flex",
                            flexDirection: "column",
                            mt: "auto",
                            pb: "55px",
                            px: "16px",
                        }, children: [disableSignIn ? null : (jsx(ButtonWrapper, { theme: floraTheme, variant: "secondary", href: signInUrl !== null && signInUrl !== void 0 ? signInUrl : content.secondary.login.href, customStyles: {
                                    width: "100%",
                                    mr: "0",
                                    mt: "16px",
                                    textAlign: "center",
                                    letterSpacing: "0.16px",
                                    py: `calc(${theme$1.space.inc30} - 1px)`,
                                    px: `calc(${theme$1.space.inc70} - 1px)`,
                                    borderColor: "blue80",
                                    boxSizing: "border-box",
                                    color: darkMode ? "blue80" : "black00",
                                    bg: darkMode ? "black00" : "blue80",
                                }, onClick: () => {
                                    mdbTrack(ETrackingEvents.LINK_CLICK, {
                                        ...COMMON_NAVIGATION_TRACKING_PROPS,
                                        title: content.secondary.login.title,
                                        href: signInUrl !== null && signInUrl !== void 0 ? signInUrl : content.secondary.login.href,
                                        label: content.secondary.login.title,
                                    });
                                }, children: content.secondary.login.title })), disableTryFree ? null : (jsx(ButtonWrapper, { theme: floraTheme, variant: "primary", href: content.secondary.try.href, customStyles: {
                                    width: "100%",
                                    mr: "0",
                                    mt: "16px",
                                    textAlign: "center",
                                    letterSpacing: "0.16px",
                                    py: `calc(${theme$1.space.inc30} - 1px)`,
                                    px: `calc(${theme$1.space.inc70} - 1px)`,
                                    borderColor: "blue80",
                                    boxSizing: "border-box",
                                }, onClick: () => {
                                    mdbTrack(ETrackingEvents.LINK_CLICK, {
                                        ...COMMON_NAVIGATION_TRACKING_PROPS,
                                        title: content.secondary.try.title,
                                        href: content.secondary.try.href,
                                        label: content.secondary.try.title,
                                    });
                                }, children: content.secondary.try.title })), show] })] }), activeMenuContent && (jsx(NavListMobile, { content: activeMenuContent, show: show && !!activeMenu, darkMode: darkMode })), showLanguageList && (jsx(NavLanguageListMobile, { onSelect: (value) => {
                    setSelectedValue(value);
                    setActiveMenu("");
                    mdbTrack(ETrackingEvents.LINK_CLICK, {
                        ...COMMON_FOOTER_TRACKING_PROPS,
                        title: "Locale Selector Selected",
                        locale: value,
                    });
                    if (onSelectLocale)
                        onSelectLocale(availableLocales[value]);
                }, value: selectedValue, show: show && !!activeMenu, availableLocales: availableLocales, darkMode: darkMode })), jsx(Box, { sx: {
                    cursor: "pointer",
                    position: "fixed",
                    zIndex: "998",
                    width: "100%",
                    height: "100%",
                    background: "rgba(6, 22, 33, 0.6)",
                    top: 55,
                    left: 0,
                    animation: `${show ? fadeIn$1 : fadeOut$1} 0.2s ease-in-out forwards`,
                }, onClick: onClose })] }));
};

const fadeIn = keyframes `
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const fadeOut = keyframes `
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
const NavSearchMobile = ({ content, property, show = true, onClose, docsBaseUrl, }) => {
    var _a;
    const [isMounted, setIsMounted] = useState(false);
    const options = content.secondary.search
        ? content.secondary.search.options
        : [];
    const optionsArray = options.map((el) => el.value);
    const defaultOption = ((_a = options.find((el) => el.universalKey === (property === null || property === void 0 ? void 0 : property.name))) === null || _a === void 0 ? void 0 : _a.value) ||
        optionsArray[0];
    const [selectedProperty, setSelectedProperty] = useState(defaultOption);
    const [query, setQuery] = useState("");
    const inputRef = useRef(null);
    const handlePropertySelection = (e) => {
        setSelectedProperty(e.currentTarget.value);
        mdbTrack(ETrackingEvents.SEARCH, {
            ...COMMON_NAVIGATION_TRACKING_PROPS,
            title: "Select Search Domain",
            text: e.currentTarget.value,
        });
    };
    const startTyping = debounce((func, value) => {
        if (typeof func === "function")
            func(value);
    });
    const trackTyping = (query) => {
        mdbTrack(ETrackingEvents.SEARCH, {
            ...COMMON_NAVIGATION_TRACKING_PROPS,
            title: "Typing Search",
            query: query,
        });
    };
    const handleInputChange = useCallback((e) => {
        setQuery(e.currentTarget.value);
        startTyping(trackTyping, e.currentTarget.value);
    }, []);
    useEffect(() => {
        var _a;
        let timeout;
        if (show) {
            setIsMounted(true);
            setTimeout(() => {
                var _a;
                (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 300);
        }
        else {
            timeout = setTimeout(() => {
                setIsMounted(false);
            }, 200);
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [show]);
    if (!isMounted)
        return null;
    return (jsxs(Fragment, { children: [jsxs(Box, { sx: {
                    fontFamily: "Euclid Circular A,Noto Sans KR,Noto Sans SC,Noto Sans JP",
                    position: "fixed",
                    top: "16px",
                    left: "16px",
                    width: "calc(100% - 32px)",
                    zIndex: "1001",
                    background: "blue80",
                    border: "1px solid",
                    borderColor: "black50",
                    borderRadius: "8px",
                    py: "40px",
                    px: "16px",
                    animation: `${show ? fadeIn : fadeOut} 0.2s ease-in-out forwards`,
                }, children: [jsx(Box, { sx: { cursor: "pointer" }, onClick: onClose, children: jsx(SystemIcon, { sx: {
                                position: "absolute",
                                top: "8px",
                                right: "8px",
                                cursor: "pointer",
                                stroke: "black30",
                            }, name: ESystemIconNames.CLOSE }) }), jsx(Box, { children: jsxs("form", { role: "search", method: "GET", action: selectedProperty === "Blog"
                                ? getSearchURL(selectedProperty, options, docsBaseUrl) +
                                    "/" +
                                    query
                                : getSearchURL(selectedProperty, options, docsBaseUrl), onSubmit: () => {
                                mdbTrack(ETrackingEvents.SEARCH, {
                                    ...COMMON_NAVIGATION_TRACKING_PROPS,
                                    title: "Submit Search",
                                    query,
                                });
                            }, children: [jsxs(Box, { sx: {
                                        fontFamily: "Source Code Pro,Noto Sans KR,Noto Sans SC,Noto Sans JP",
                                        color: "black15",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        lineHeight: "14px",
                                        mb: "8px",
                                    }, children: [jsx("span", { sx: { color: "green40" }, children: "> " }), "SEARCH"] }), jsx(TextInput, { ref: inputRef, inverse: true, placeholder: getPlaceholderText(selectedProperty, options), inputStyles: {
                                        px: "8px !important",
                                        width: "100%",
                                        background: "transparent",
                                        fontFamily: "Source Code Pro,Noto Sans KR,Noto Sans SC,Noto Sans JP !important",
                                        fontSize: "12px !important",
                                        lineHeight: "12px !important",
                                        height: "40px !important",
                                        color: `${theme$1.colors.black15} !important`,
                                        fontWeight: "500 !important",
                                        borderRadius: "6px !important",
                                        "&::placeholder": {
                                            color: "black50",
                                        },
                                    }, wrapperStyles: { width: "100%" }, value: query, onChange: handleInputChange }), jsxs(Box, { sx: { mt: "16px" }, children: [jsxs(Box, { sx: {
                                                fontFamily: "Source Code Pro,Noto Sans KR,Noto Sans SC,Noto Sans JP",
                                                color: "black15",
                                                fontSize: "14px",
                                                fontWeight: "500",
                                                lineHeight: "14px",
                                                mb: "8px",
                                            }, children: [jsx("span", { sx: { color: "green40" }, children: "> " }), "TOPIC"] }), jsx("select", { className: "select-overlay", id: "filter-select", value: selectedProperty, onChange: handlePropertySelection, onClick: () => {
                                                mdbTrack(ETrackingEvents.SEARCH, {
                                                    ...COMMON_NAVIGATION_TRACKING_PROPS,
                                                    title: "Open Search Domain Selector",
                                                });
                                            }, sx: {
                                                padding: "11px 5px",
                                                background: "transparent",
                                                color: `${theme$1.colors.black15}`,
                                                borderColor: "black50",
                                                borderRadius: "6px",
                                                width: "100%",
                                                fontFamily: "Source Code Pro,Noto Sans KR,Noto Sans SC,Noto Sans JP",
                                                fontSize: "12px",
                                                lineHeight: "12px",
                                                fontWeight: "500",
                                            }, children: optionsArray.map((option) => (jsx("option", { value: option, children: option }, option))) }), getQueryStrings(selectedProperty, query, options, metadataParams(selectedProperty, property)).map((querystring) => querystring.param && (jsx("input", { type: "hidden", id: querystring.param, name: querystring.param, value: querystring.value }, `navsearch-form-${querystring.param}`)))] }), jsx(Box, { sx: { mt: "40px", display: "flex", justifyContent: "flex-end" }, children: jsx(ButtonWrapper, { theme: "default", variant: "primary", "aria-label": "Submit Search", type: "submit", sx: {
                                            padding: "inc30",
                                            marginLeft: "inc10",
                                            fontSize: "inc20",
                                            textAlign: "center",
                                        }, customStyles: {
                                            width: "148px",
                                            padding: "16px 14px",
                                        }, children: content.secondary.search.submit }) })] }) })] }), jsx(Box, { sx: {
                    cursor: "pointer",
                    position: "fixed",
                    zIndex: "1000",
                    width: "100%",
                    height: "100%",
                    background: "rgba(6, 22, 33, 0.7)",
                    backdropFilter: "blur(2px)",
                    top: 0,
                    left: 0,
                    animation: `${show ? fadeIn : fadeOut} 0.2s ease-in-out forwards`,
                }, onClick: onClose })] }));
};

const handlePencilBannerFix = (show = false, ref) => {
    var _a, _b, _c;
    if (!show && document.body.style.overflow === "hidden") {
        document.body.style.overflow = "";
    }
    else if (show && (ref === null || ref === void 0 ? void 0 : ref.current)) {
        const offsetScroll = (_c = (_b = (_a = ref.current).getBoundingClientRect) === null || _b === void 0 ? void 0 : _b.call(_a)) === null || _c === void 0 ? void 0 : _c.top;
        if (offsetScroll > 0) {
            window === null || window === void 0 ? void 0 : window.scrollBy(0, offsetScroll);
        }
        setTimeout(() => {
            document.body.style.overflow = "hidden";
            // To fix firefox issue
        }, 500);
    }
};
const Mobile = ({ className, content, shiftableSelector, property, signInUrl, hideTryFree, hideSupport, hideSignIn, hideSearch, floraTheme = "default", docsBaseUrl, showLanguageSelector = false, actualLocale, onSelectLocale, availableLocales, darkMode, }) => {
    const [isAnimating, setIsAnimating] = useState(false);
    const [showMenuLinks, setShowMenuLinks] = useState(false);
    const [showMenuSearch, setShowMenuSearch] = useState(false);
    const ref = useRef(null);
    const disableSearch = hideSearch || !content.secondary.search;
    useEffect(() => {
        handlePencilBannerFix(showMenuLinks || showMenuSearch, ref);
        return () => {
            handlePencilBannerFix(false, ref);
        };
    }, [showMenuSearch, showMenuLinks]);
    const handleSetShowMenuLinks = () => {
        if (!showMenuLinks) {
            setShowMenuSearch(false);
            mdbTrack(ETrackingEvents.DROPDOWN_APPEARS, {
                ...COMMON_NAVIGATION_TRACKING_PROPS,
                title: "Mobile Links",
                label: "Mobile Links",
                nonInteraction: 1,
            });
        }
        setIsAnimating(true);
        setTimeout(() => setIsAnimating(false), 290);
        setShowMenuLinks(!showMenuLinks);
    };
    const handleSetShowMenuSearch = () => {
        if (!showMenuSearch) {
            setShowMenuLinks(false);
            mdbTrack(ETrackingEvents.SEARCH, {
                ...COMMON_NAVIGATION_TRACKING_PROPS,
                title: "Open Search",
            });
        }
        setShowMenuSearch(!showMenuSearch);
    };
    return (jsx(ThemeProvider, { theme: theme$1, children: jsxs(Box, { ref: ref, sx: {
                backgroundColor: darkMode ? "blue80" : "black00",
                display: "flex",
                alignItems: "center",
                fontFamily: "Euclid Circular A,Noto Sans KR,Noto Sans SC,Noto Sans JP",
                fontWeight: "300",
                overflow: "hidden",
                height: "inc60",
                justifyContent: "space-between",
                width: "100%",
                zIndex: "999",
                position: "relative",
                px: ["inc40", null, "inc50"],
                borderBottom: `1px solid ${darkMode
                    ? theme$1.colors.border.inverseDarker
                    : theme$1.colors.border.default}`,
            }, className: className, children: [jsx(MDBLogo, { sx: {
                        display: "flex",
                        fontSize: "inc10",
                        height: "24px",
                        width: "95px",
                        minWidth: "95px",
                        maxWidth: "none",
                        "@media screen and (min-width: 768px)": {
                            // this breakpoint is not tokenized yet
                            minWidth: "126px",
                            width: "126px",
                            height: "32px", // these values are needed for cross-domain consistency
                        },
                    }, width: "95px", height: "24px", variant: darkMode
                        ? ELogoVariant.HORIZONTAL_ALL_WHITE
                        : ELogoVariant.HORIZONTAL_DEFAULT, href: "https://www.mongodb.com", imageWidth: "95px", theme: floraTheme }), jsxs(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        zIndex: "1",
                    }, children: [disableSearch ? null : (jsx("button", { onClick: () => handleSetShowMenuSearch(), "aria-label": showMenuSearch ? "Close Search" : "Open Search", sx: {
                                border: "none",
                                background: "none",
                                outline: "none",
                                marginRight: "20px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                zIndex: "1",
                                height: NAV_HEIGHT,
                                width: "16px",
                                "& > img": {
                                    width: "16px",
                                    height: "16px",
                                    maxWidth: "none",
                                },
                                ":focus-visible": {
                                    outline: "-webkit-focus-ring-color auto 1px",
                                },
                            }, children: jsx("img", { alt: "Search", src: darkMode
                                    ? "https://webimages.mongodb.com/_com_assets/cms/lzslrve126rd6b305-search-dark-mode.svg?auto=format%252Ccompress"
                                    : "https://webimages.mongodb.com/_com_assets/cms/lyekm5ifrkqjod0wu-search_updated.svg?auto=format%252Ccompress", width: "16", height: "16" }) })), jsx("button", { "aria-label": showMenuLinks ? "Close Links" : "Open Links", sx: {
                                border: "none",
                                background: "none",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                height: "inc60",
                                px: 2,
                            }, onClick: handleSetShowMenuLinks, children: jsxs("svg", { width: "16", height: "10", viewBox: "0 0 16 10", xmlns: "http://www.w3.org/2000/svg", overflow: "visible", className: `${showMenuLinks ? "active" : ""} ${isAnimating ? "animating" : ""}`, sx: {
                                    "& > rect": {
                                        transition: "all 0.3s ease-in-out, opacity 0.2s linear 0.1s",
                                        transformOrigin: "50% 50%",
                                        "&#top-line": {
                                            transform: "translateY(-4.375px)",
                                        },
                                        "&#bottom-line": {
                                            transform: "translateY(4.375px)",
                                        },
                                    },
                                    "&.animating, &.active": {
                                        "& #top-line": {
                                            transform: "translateY(0)",
                                        },
                                        "& #middle-line": {
                                            opacity: 0,
                                        },
                                        "& #bottom-line": {
                                            transform: "translateY(0)",
                                        },
                                    },
                                    "&.active:not(.animating)": {
                                        "& #top-line": {
                                            transform: "translateY(0) rotate(-45deg)",
                                        },
                                        "& #middle-line": {
                                            opacity: 0,
                                        },
                                        "& #bottom-line": {
                                            transform: "translateY(0) rotate(-135deg)",
                                        },
                                    },
                                }, children: [jsx("rect", { id: "top-line", x: "0.5", y: "4.375", rx: "0.625", ry: "0.625", width: "15", height: "1.25", fill: darkMode ? "#B8C4C2" : "#21313C" }), jsx("rect", { id: "middle-line", x: "0.5", y: "4.375", rx: "0.625", ry: "0.625", width: "15", height: "1.25", fill: darkMode ? "#B8C4C2" : "#21313C" }), jsx("rect", { id: "bottom-line", x: "0.5", y: "4.375", rx: "0.625", ry: "0.625", width: "15", height: "1.25", fill: darkMode ? "#B8C4C2" : "#21313C" })] }) })] }), jsx(NavMenuMobile, { content: content, signInUrl: signInUrl, hideSupport: hideSupport, hideTryFree: hideTryFree, hideSignIn: hideSignIn, docsBaseUrl: docsBaseUrl, show: showMenuLinks, floraTheme: floraTheme, onClose: handleSetShowMenuLinks, showLanguageSelector: showLanguageSelector, onSelectLocale: onSelectLocale, actualLocale: actualLocale, availableLocales: availableLocales, darkMode: darkMode }), jsx(NavSearchMobile, { content: content, property: property, show: showMenuSearch, onClose: () => setShowMenuSearch(false), docsBaseUrl: docsBaseUrl })] }) }));
};

const NavBar = ({ className, content, shiftableSelector, width, position, offsetTop, property, signInUrl, hideTryFree = false, hideSignIn = false, hideSearch = false, hideSupport = false, fullWidth = false, floraTheme = "default", docsBaseUrl, showLanguageSelector = false, onSelectLocale, locale, enabledLocales, darkMode, }) => {
    const availableLocales = useMemo(() => enabledLocales && enabledLocales.length > 0
        ? generateLocaleMap(enabledLocales)
        : localeMap, [enabledLocales]);
    const actualLocale = useMemo(() => Object.keys(availableLocales).find((key) => availableLocales[key] === locale) || "English", [locale, availableLocales]);
    const contentWithUniqueKeys = useMemo(() => generateUniqueKeys(content), [content]);
    return (jsxs(ThemeProvider, { theme: theme, children: [jsx(Globals, { legacy: true }), jsx(Globals, {}), jsxs("nav", { role: "navigation", className: className, sx: {
                    width: width || "100%",
                    position: position || "fixed",
                    top: offsetTop || "0",
                    left: "0",
                    zIndex: "1",
                }, children: [jsx(Desktop, { sx: { display: ["none", null, null, "flex"] }, content: contentWithUniqueKeys, property: property, signInUrl: signInUrl, hideTryFree: hideTryFree, hideSignIn: hideSignIn, hideSearch: hideSearch, hideSupport: hideSupport, floraTheme: floraTheme, docsBaseUrl: docsBaseUrl, fullWidth: fullWidth, showLanguageSelector: showLanguageSelector, actualLocale: actualLocale, onSelectLocale: onSelectLocale, availableLocales: availableLocales, darkMode: darkMode }), jsx(Mobile, { sx: { display: ["flex", null, null, "none"] }, content: contentWithUniqueKeys, shiftableSelector: shiftableSelector, property: property, signInUrl: signInUrl, hideTryFree: hideTryFree, hideSignIn: hideSignIn, hideSearch: hideSearch, hideSupport: hideSupport, floraTheme: floraTheme, docsBaseUrl: docsBaseUrl, showLanguageSelector: showLanguageSelector, actualLocale: actualLocale, onSelectLocale: onSelectLocale, availableLocales: availableLocales, darkMode: darkMode })] })] }));
};

var LinkID;
(function (LinkID) {
    LinkID["CookiePreference"] = "manage-cookies";
})(LinkID || (LinkID = {}));

const useGeoIP = (cb) => {
  const maxCalls = 3;
  let count = 0;

  useEffect(() => {
    const getGeoIP = () => {
      try {
        if (window && window.oneTrustLocation) {
          cb({ country: window.oneTrustLocation });
          return;
        }
        if (count === maxCalls) {
          return;
        } else {
          count++;
          setTimeout(getGeoIP, 1000);
        }
      } catch (e) {
        console.error(e);
        cb({ country: "" });
      }
    };
    getGeoIP();
  }, []);
};

const SocialIconDimensionsMap = {
    Github: { width: "16", height: "16" },
    LinkedIn: { width: "16", height: "16" },
    X: { width: "16", height: "16" },
    YouTube: { width: "16", height: "12" },
    Twitch: { width: "16", height: "18" },
    Facebook: { width: "9", height: "16" },
    "Stack Overflow": { width: "16", height: "22" },
};
const getIconWidth = (title) => { var _a; return ((_a = SocialIconDimensionsMap[title]) === null || _a === void 0 ? void 0 : _a.width) || "16"; };
const getIconHeight = (title) => { var _a; return ((_a = SocialIconDimensionsMap[title]) === null || _a === void 0 ? void 0 : _a.height) || "16"; };
const Footer = ({ className, content, onSelectLocale, locale, hideLocale, floraTheme, enabledLocales, }) => {
    const [shouldShowVATLink, setShouldShowVATLink] = useState(false);
    const manageCookieLinks = content.sections[1].links.filter((link) => link.id === LinkID.CookiePreference);
    const [showCookiePrefLink, setShowCookiePrefLink] = useState(manageCookieLinks.length === 0);
    const availableLocales = useMemo(() => enabledLocales && enabledLocales.length > 0
        ? generateLocaleMap(enabledLocales)
        : localeMap, [enabledLocales]);
    const actualLocale = Object.keys(availableLocales).find((key) => availableLocales[key] === locale) || "English";
    useEffect(() => {
        var _a;
        const OptanonConsentCookie = document.cookie
            .split("; ")
            .find((row) => row.startsWith("OptanonConsent"));
        if (((_a = window.Optanon) === null || _a === void 0 ? void 0 : _a.useGeoLocationService) || OptanonConsentCookie) {
            setShowCookiePrefLink(true);
        }
    }, []);
    useGeoIP((getGeolocationData) => {
        const isSaudiArabiaUser = getGeolocationData && getGeolocationData.country === "SA";
        setShouldShowVATLink(isSaudiArabiaUser);
    });
    const currentYear = new Date().getFullYear();
    const copyright = `© ${currentYear} ${content.copyright}`;
    return (jsxs(ThemeProvider, { theme: theme, children: [jsx(Globals, { legacy: true }), jsx("footer", { className: className, sx: {
                    "a:hover": {
                        textDecoration: "underline",
                    },
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    backgroundColor: theme.colors.black90,
                    color: theme.colors.black00,
                }, children: jsxs(Box, { sx: {
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: ["wrap", null, "unset"],
                        justifyContent: "space-between",
                        maxWidth: MAX_WIDTH,
                        py: "inc90",
                        px: ["inc40", null, "inc50"],
                    }, children: [jsxs(Box, { sx: {
                                flexBasis: "25%",
                                display: "flex",
                                minWidth: ["100%", null, "unset"],
                                flexDirection: "column",
                                justifyContent: "space-between",
                                marginBottom: [theme.space.inc60, null, theme.space.inc00],
                            }, children: [jsxs(Box, { sx: {
                                        display: ["grid", null, "block"],
                                        gridTemplateColumns: "1fr 1fr",
                                        flexDirection: ["row", null, "column"],
                                        alignItems: ["center", null, "flex-start"],
                                        justifyContent: "space-between",
                                    }, children: [jsx(Box, { sx: { maxWidth: ["120px", null, null, "150px"] }, children: jsx(MDBLogo, { sx: {
                                                    fontSize: "inc10",
                                                    lineHeight: "inc10",
                                                    height: "auto",
                                                }, theme: floraTheme, variant: ELogoVariant.HORIZONTAL_INVERSE, imageWidth: "100%", width: "150", height: "38", href: "https://www.mongodb.com" }) }), !hideLocale && (jsxs(Box, { sx: {
                                                display: "flex",
                                                marginTop: [theme.space.inc00, null, theme.space.inc40],
                                                justifyContent: ["end", null, "start"],
                                            }, children: [jsx("img", { src: "https://webimages.mongodb.com/_com_assets/cms/kr6zmbrgbwlke2l97-atlas-global-deployments.svg?auto=format%252Ccompress", width: "18", height: "48", alt: "Language Selector Icon", style: { height: "auto" } }), jsx(Select, { theme: "legacy", invalid: false, variant: "default", options: Object.keys(availableLocales), inverse: true, border: "none", width: "min-content", value: actualLocale, ariaLabel: "Language Selector", menuPlacement: "auto", onOpen: () => {
                                                        mdbTrack(ETrackingEvents.LINK_CLICK, {
                                                            ...COMMON_FOOTER_TRACKING_PROPS,
                                                            title: "Locale Selector Open",
                                                        });
                                                    }, onSelect: (value) => {
                                                        mdbTrack(ETrackingEvents.LINK_CLICK, {
                                                            ...COMMON_FOOTER_TRACKING_PROPS,
                                                            title: "Locale Selector Selected",
                                                            locale: value,
                                                        });
                                                        if (onSelectLocale)
                                                            onSelectLocale(availableLocales[value]);
                                                    } })] }))] }), jsx(Box, { sx: {
                                        display: ["none", null, "block"],
                                        fontFamily: "akzidenz-grotesk-std",
                                        fontWeight: "300",
                                        fontSize: theme.fontSizes.inc00,
                                        color: theme.colors.black30,
                                    }, children: copyright })] }), content.sections.map((section, index) => (jsxs(Box, { sx: {
                                flexBasis: "25%",
                                marginTop: [theme.space.inc40, null, theme.space.inc00],
                                minWidth: index === 3
                                    ? ["50%", "100%", "unset"]
                                    : ["50%", "unset", "unset"],
                            }, children: [jsx("p", { sx: {
                                        fontFamily: "akzidenz-grotesk-std",
                                        fontWeight: "500",
                                        fontSize: "inc20",
                                        marginBottom: theme.space.inc40,
                                        color: "black00",
                                        marginTop: ["inc00", null, "initial"],
                                    }, children: section.title }), jsx("ul", { sx: {
                                        listStyle: "none",
                                        margin: "0",
                                        padding: "0",
                                        display: index === 3 ? ["block", "grid", "block"] : "block",
                                        gridTemplateColumns: index === 3 ? "1fr 1fr 1fr" : [],
                                    }, children: section.links
                                        .filter((link) => link.id !== LinkID.CookiePreference || showCookiePrefLink)
                                        .map((link, index) => {
                                        const isDefaultLink = !link.hide; // 'hide' field only exists on VAT link
                                        const isSAUser = link.title === "Saudi Arabian VAT Certificate" &&
                                            shouldShowVATLink;
                                        if (isDefaultLink || isSAUser) {
                                            return (jsx("li", { sx: { marginBottom: "inc40" }, children: jsxs("a", { className: link.id === LinkID.CookiePreference
                                                        ? "manage-cookies"
                                                        : "", sx: {
                                                        color: "black00",
                                                        textDecoration: "none",
                                                        fontFamily: "akzidenz-grotesk-std",
                                                        fontWeight: "300",
                                                        fontSize: "inc10",
                                                        lineHeight: "inc30",
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }, href: link.href, target: link.target, rel: "noreferrer noopener", download: isSAUser &&
                                                        "MongoDB Saudi Arabian VAT Certificate", onClick: (evt) => {
                                                        var _a;
                                                        if (link.id === LinkID.CookiePreference) {
                                                            evt.preventDefault();
                                                            (_a = window.Optanon) === null || _a === void 0 ? void 0 : _a.ToggleInfoDisplay();
                                                        }
                                                        mdbTrack(ETrackingEvents.LINK_CLICK, {
                                                            ...COMMON_FOOTER_TRACKING_PROPS,
                                                            title: link.title,
                                                            href: link.href,
                                                            label: link.title,
                                                            position: index,
                                                        });
                                                    }, children: [link.icon && (jsx("img", { sx: { marginRight: "inc30", maxWidth: "16px" }, src: link.icon, alt: link.title, width: getIconWidth(link.title), height: getIconHeight(link.title) })), link.title] }) }, `footer-section-link-${link.title}-${index}`));
                                        }
                                    }) })] }, `footer-section-${section.title}-${index}`))), jsx(Box, { sx: {
                                display: ["block", null, "none"],
                                fontFamily: "akzidenz-grotesk-std",
                                width: "100%",
                                fontWeight: "300",
                                fontSize: theme.fontSizes.inc00,
                                color: theme.colors.black30,
                                marginTop: theme.space.inc40,
                                textAlign: "center",
                            }, children: copyright })] }) })] }));
};

const darkGreen = theme$1.colors.green60;
const darkBlue = theme$1.colors.blue80;
const dark = theme$1.colors.black80;
const midBlue = theme$1.colors.blue60;
const standardBlue = theme$1.colors.blue50;
const brightBlue = theme$1.colors.blue05;
const creme = theme$1.colors.black10;
const brightGreen = theme$1.colors.green20;
const brightestGreen = theme$1.colors.green05;
const pillPropsTheme = {
    default: {
        background: {
            color: creme,
        },
        pill: {
            borderColor: "transparent",
            variant: "identifier",
            color: "blue60",
        },
        text: {
            color: darkBlue,
        },
        link: {
            color: midBlue,
        },
        closeIcon: {
            color: dark,
        },
    },
    forestgreen: {
        background: {
            color: darkGreen,
        },
        pill: {
            borderColor: darkBlue,
            variant: "identifier",
            color: "green30",
        },
        text: {
            color: "white",
        },
        link: {
            color: brightGreen,
        },
        closeIcon: {
            color: brightestGreen,
        },
    },
    inverse: {
        background: {
            color: darkBlue,
        },
        pill: {
            borderColor: darkBlue,
            variant: "identifier",
            color: "green30",
        },
        text: {
            color: "white",
        },
        link: {
            color: standardBlue,
        },
        closeIcon: {
            color: brightBlue,
        },
    },
};

const pillThemes$1 = Object.keys(pillPropsTheme);
const textStyle = {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "16px",
};
const mobileCTA = "<mark>&gt;&gt;</mark>";
const regexp = /<mark>.*<\/mark>/;
function PencilBannerEntry({ theme: theme$2, pillText, bannerText, href, styleOverrides, }) {
    const mobileTextRef = useRef(null);
    useEffect(() => {
        if (mobileTextRef.current) {
            const mobileSpan = mobileTextRef.current;
            // The CTA (text between the <mark></mark> tag) should be replaced with ">>" on Tablet and Mobible breakpoints in bannerText
            const hasCTA = bannerText.match(regexp);
            const bannerTextTablet = hasCTA
                ? bannerText.replace(regexp, mobileCTA)
                : bannerText;
            mobileSpan.innerHTML = bannerTextTablet;
            // Check if the text overflows
            if (mobileSpan.scrollHeight > mobileSpan.clientHeight) {
                // Find the truncation point
                let truncatedText = bannerTextTablet;
                while (mobileSpan.scrollHeight > mobileSpan.clientHeight &&
                    truncatedText.length > 2) {
                    truncatedText = truncatedText.slice(0, -1);
                    mobileSpan.innerHTML = `${truncatedText}...${hasCTA ? ` ${mobileCTA}` : ""}`;
                }
            }
        }
    }, [bannerText]);
    const pencilBannerTheme = pillThemes$1.includes(theme$2.toLowerCase())
        ? theme$2.toLowerCase()
        : pillThemes$1[0];
    const props = pillPropsTheme[pencilBannerTheme];
    return (jsx(ThemeProvider, { theme: theme$2 === "legacy" ? theme : theme$1, children: jsxs("div", { sx: {
                display: "flex",
                alignItems: "center",
                gap: "gap-inc30",
                textDecoration: "none",
                // Make sure we override global styles
                "&:hover": {
                    textDecoration: "none",
                    "& mark": {
                        textDecoration: "underline",
                    },
                },
                maxWidth: ["100%", "unset"],
                ...styleOverrides,
            }, tabIndex: (styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.opacity) === 0 ? -1 : 0, onKeyDown: (e) => {
                if (href && e.key === "Enter")
                    window.location.href = href;
            }, children: [pillText && (jsx(Pill, { ...props === null || props === void 0 ? void 0 : props.pill, variant: "identifier", text: pillText, size: "small", sx: {
                        height: "24px",
                        lineHeight: "24px",
                        paddingX: "12px",
                        paddingY: "0",
                        marginRight: "16px",
                        fontSize: "9px",
                        whiteSpace: "nowrap",
                        fontWeight: "600",
                    } })), jsxs(TypographyScale, { variant: "body4", sx: {
                        textDecoration: "none",
                        color: props.text.color,
                        ...textStyle,
                        fontFamily: "Source Code Pro,Noto Sans KR,Noto Sans SC,Noto Sans JP",
                        maxWidth: [null, null, "85vw"],
                        lineHeight: "18px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        "& mark": {
                            color: props.link.color,
                            backgroundColor: "transparent",
                        },
                        "& > span": {
                            ...textStyle,
                            overflow: "inherit",
                            textOverflow: "inherit",
                            // Truncate text on one line (desktop and tablet)
                            "-webkit-box-orient": "vertical",
                            "-webkit-line-clamp": "1",
                        },
                        "& > span:first-child": {
                            // show the first span containing the bannerText
                            // on desktop and the second span containing the
                            // replaced mark with >> on mobile and tablet breakpoints
                            display: "block",
                        },
                        "& > span:last-child": {
                            display: "none",
                        },
                        "@media (max-width: 767px)": {
                            "& > span": {
                                // Truncate text on two lines (mobile)
                                whiteSpace: "normal",
                                "-webkit-box-orient": "vertical",
                                "-webkit-line-clamp": "2",
                            },
                        },
                        "@media (max-width: 1024px)": {
                            // show the first span containing the bannerText
                            // on desktop and the second span containing the
                            // replaced mark with >> on mobile and tablet breakpoints
                            "& > span:first-child": {
                                display: "none",
                            },
                            "& > span:last-child": {
                                display: "-webkit-box",
                            },
                        },
                    }, children: [jsx("span", { dangerouslySetInnerHTML: {
                                __html: bannerText,
                            } }), jsx("span", { ref: mobileTextRef })] })] }) }));
}

/**
 * Throttle a function to be called at most once every `delay` milliseconds.
 */
const useThrottledCallback = (fn, delayMs = 500, dependencies = []) => {
    const lastCallTime = useRef(null);
    return useCallback((...args) => {
        const now = Date.now();
        if (lastCallTime.current === null ||
            now - lastCallTime.current >= delayMs) {
            lastCallTime.current = now;
            fn(...args);
        }
    }, [fn, delayMs, ...dependencies]);
};

const animationDelay = 850;
const transitionInterval = 5000;
const getHoverStrokeColor = (theme) => {
    switch (theme) {
        case "forestgreen":
            return "green20";
        case "inverse":
            return "blue50";
        case "default":
        default:
            return "blue60";
    }
};
function MultiPromoCarousel({ multiPromoConfiguration, theme, onEntryChange, }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const entries = multiPromoConfiguration.length;
    const intervalRef = useRef(null);
    const resetInterval = () => {
        if (intervalRef === null || intervalRef === void 0 ? void 0 : intervalRef.current)
            clearInterval(intervalRef === null || intervalRef === void 0 ? void 0 : intervalRef.current);
        intervalRef.current = setInterval(() => {
            setCurrentIndex((prevIndex) => prevIndex === entries - 1 ? 0 : prevIndex + 1);
        }, transitionInterval);
    };
    useEffect(() => {
        resetInterval();
        return () => {
            if (intervalRef === null || intervalRef === void 0 ? void 0 : intervalRef.current)
                clearInterval(intervalRef === null || intervalRef === void 0 ? void 0 : intervalRef.current);
        };
    }, [entries]);
    useEffect(() => {
        onEntryChange(multiPromoConfiguration[currentIndex].href || "");
    }, [currentIndex]);
    const prevSlide = useThrottledCallback(() => {
        setCurrentIndex((prevIndex) => prevIndex === 0 ? entries - 1 : prevIndex - 1);
        resetInterval();
    }, animationDelay, [entries]);
    const nextSlide = useThrottledCallback(() => {
        setCurrentIndex((prevIndex) => prevIndex === entries - 1 ? 0 : prevIndex + 1);
        resetInterval();
    }, animationDelay, [entries]);
    // we need to pause the animation when the user hovers over the carousel
    return (jsxs("div", { sx: {
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
            maxWidth: "1420px",
            height: "100%",
        }, onMouseEnter: () => {
            if (intervalRef === null || intervalRef === void 0 ? void 0 : intervalRef.current)
                clearInterval(intervalRef === null || intervalRef === void 0 ? void 0 : intervalRef.current);
        }, onMouseLeave: resetInterval, children: [jsx("div", { sx: {
                    display: "grid",
                }, children: multiPromoConfiguration.map((entry, index) => (jsx(PencilBannerEntry, { theme: theme, pillText: entry.pillText, bannerText: entry.bannerText, href: entry.href, styleOverrides: {
                        width: "100%",
                        maxHeight: index === currentIndex ? "unset" : "24px",
                        transition: `all ${animationDelay}ms ease-in-out`,
                        opacity: index === currentIndex ? 1 : 0,
                        visibility: index === currentIndex ? "visible" : "hidden",
                        gridRowStart: 1,
                        gridColumnStart: 1,
                    } }, index))) }), jsx(MultiPromoCarouselArrows, { prevSlide: prevSlide, nextSlide: nextSlide, theme: theme })] }));
}
const MultiPromoCarouselArrows = ({ prevSlide, nextSlide, theme: theme$2 }) => {
    const hoverStrokeColor = getHoverStrokeColor(theme$2);
    return (jsx(ThemeProvider, { theme: theme$2 === "legacy" ? theme : theme$1, children: jsx("div", { sx: {
                paddingLeft: "16px",
                marginRight: "-10px",
                display: "none",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "inc20",
                fontWeight: "bold",
                color: theme$2 === "default" ? "black" : "white",
                "@media screen and (min-width: 768px)": {
                    display: "flex",
                },
            }, children: ["prevSlide", "nextSlide"].map((direction) => (jsx("div", { sx: {
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    display: "flex",
                    cursor: "pointer",
                    alignItems: "center",
                    justifyContent: "center",
                    "&:hover svg path": {
                        stroke: hoverStrokeColor,
                    },
                }, onClick: (e) => {
                    e.preventDefault();
                    direction === "prevSlide" ? prevSlide() : nextSlide();
                }, onKeyDown: (e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        direction === "prevSlide" ? prevSlide() : nextSlide();
                    }
                }, tabIndex: 0, children: jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", children: jsx("path", { d: direction === "prevSlide"
                            ? "M10.6667 2.66663L5.33337 7.99996L10.6667 13.3333"
                            : "M5 3L10.3333 8.33333L5 13.6667", stroke: theme$2 === "default" ? "black" : "white", strokeLinecap: "round", strokeLinejoin: "round" }) }) }, direction))) }) }));
};

const pillThemes = Object.keys(pillPropsTheme);
const MultiPromoPencilBanner = ({ theme: theme$2 = "default", entries }) => {
    var _a, _b, _c, _d;
    const [currentCtaHref, setCurrentCtaHref] = useState(((_a = entries[0]) === null || _a === void 0 ? void 0 : _a.href) || "");
    const isMultiPromo = entries && entries.length > 1;
    const pencilBannerTheme = pillThemes.includes(theme$2.toLowerCase())
        ? theme$2.toLowerCase()
        : pillThemes[0];
    const props = pillPropsTheme[pencilBannerTheme];
    const Container = currentCtaHref ? "a" : "div";
    return (jsx(ThemeProvider, { theme: theme$2 === "legacy" ? theme : theme$1, children: jsx(Container, { tabIndex: -1, href: currentCtaHref, sx: {
                position: "relative",
                display: "flex",
                minHeight: "40px",
                height: ["auto", "40px"],
                boxSizing: "border-box",
                overflow: "hidden",
                width: "100%",
                cursor: currentCtaHref && "pointer",
                userSelect: "none",
                alignItems: "center",
                justifyContent: "center",
                padding: "8px 24px",
                textDecoration: "none",
                color: theme$2 === "forestgreen"
                    ? "green60"
                    : theme$2 === "inverse"
                        ? "blue80"
                        : "black10",
                backgroundColor: props.background.color,
                "@media screen and (min-width: 1024px)": {
                    // this breakpoint is not tokenized yet
                    paddingX: "48px",
                },
                "&:hover mark": {
                    textDecoration: "underline",
                },
            }, children: isMultiPromo ? (jsx(MultiPromoCarousel, { multiPromoConfiguration: entries, theme: theme$2, onEntryChange: (href) => setCurrentCtaHref(href) })) : (jsx("div", { sx: {
                    maxWidth: "1420px",
                }, children: jsx(PencilBannerEntry, { theme: theme$2, pillText: (_b = entries[0]) === null || _b === void 0 ? void 0 : _b.pillText, bannerText: (_c = entries[0]) === null || _c === void 0 ? void 0 : _c.bannerText, href: (_d = entries[0]) === null || _d === void 0 ? void 0 : _d.href }) })) }) }));
};

/** @deprecated Use MultiPromoPencilBanner instead */
const PencilBanner = ({ pillText, bannerText, href, theme, }) => {
    return (jsx(MultiPromoPencilBanner, { entries: [{ pillText, bannerText, href }], theme: theme }));
};

const defaultLanguage = "en-us";
const UnifiedNav = (props) => {
    var _a;
    const selectedLocale = ((_a = props.locale) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || defaultLanguage;
    const data = getContent(props.docsBaseUrl);
    const selectedContent = data[selectedLocale] || data[defaultLanguage];
    return (jsx(NavBar, { content: props.replacementContent || selectedContent.nav, ...props }));
};
const UnifiedFooter = ({ onSelectLocale, locale, hideLocale, floraTheme, enabledLocales, }) => {
    const selectedLocale = (locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) || defaultLanguage;
    const data = getContent();
    const selectedContent = data[selectedLocale] || data[defaultLanguage];
    return (jsx(Footer, { hideLocale: hideLocale, locale: selectedLocale, content: selectedContent.footer, onSelectLocale: onSelectLocale, floraTheme: floraTheme, enabledLocales: enabledLocales }));
};

export { MultiPromoPencilBanner, PencilBanner, UnifiedFooter, UnifiedNav };
